import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react"
import "./salesinvoice.scss"
import axios from "../axios"
import moment from "moment"
import numeral from "numeral"
import { Backdrop } from "@material-ui/core"
import SweetAlert from "react-bootstrap-sweetalert"
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select"
import { makeStyles } from "@material-ui/core/styles"
import { useHistory } from "react-router-dom"
import Spinner from "react-spinkit"
// import Breadcrumbs from "../../components/Common/Breadcrumb"
// import DeleteModal from "../../components/Common/DeleteModal"
// import DeleteModal1 from "../../components/Common/DeleteModal"
import { Button as ButtonMui } from "@material-ui/core"
import { Link } from "react-router-dom"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"

import Switch from "react-switch"
import toastr from "toastr"
import PrintIcon from "@mui/icons-material/Print"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import CloseIcon from "@mui/icons-material/Close"
import AddCircleIcon from "@mui/icons-material/AddCircle"
import EditIcon from "@mui/icons-material/Edit"
// import StockQtyDesing from "../../components/Common/StockQtyDesing"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import {
  Dialog,
  DialogTitle,
  Grid,
  Paper,
  TextField,
  Zoom,
} from "@material-ui/core"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  Input,
  Table,
  CardBody,
  Button,
  ModalFooter,
  List,
  Label,
} from "reactstrap"
import Divider from "@mui/material/Divider"
import Chip from "@mui/material/Chip"

import {
  Typography,
  // IconButton,
  Table as Table2,
  TableCell as TableCell2,
  TableBody as TableBody2,
  TableHead as TableHead2,
  TableRow as TableRow2,
} from "@mui/material"
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

import { Button as CustomButton2, Stack, Tooltip } from "@mui/material"

import { styled } from "@mui/system"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
// import ProductMaster from "../../components/Common/ProductMaster"
// import LedgerMaster from "../../components/Common/LedgerMaster"
// import GeneralLegermaster from "../Master/GeneralLegermaster"
// import "./TableStyle.css"
import { cloneDeep, forEach } from "lodash"
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  dialogpaper: {
    width: "1200px",
  },
}))
//import components



const CustomButton = styled(Button)({
  boxShadow: 0,
  marginLeft: 5,
  backgroundColor: "#3468C0",
  color: "#yourCustomTextColor",
  "&:hover": {
    backgroundColor: "#2c3e50",
  },
})

function QuotationAdd(props) {
  const theme = useTheme()
  const matchesSmallScreen = useMediaQuery(theme.breakpoints.up("md"))

  // useEffect(() => {
  //   if (
  //     JSON.parse(sessionStorage.getItem("MenuItemQuotationControls")).Edit ==
  //     "N"
  //   ) {
  //     toastr.options.timeOut = 0;
  //     toastr.options.closeButton = true;
  //     toastr.options.extendedTimeOut = 0;
  //     toastr.options.positionClass = "toast-top-center";
  //     toastr["info"](
  //       "Contact Admin for more info..",
  //       "Can View Data, Can't Edit & Save"
  //     );
  //   }
  // }, []);
  let cusid

  const options1 = [
    { value: "General", text: "General" },
    { value: "From Sales Order", text: "Against of SO" },
  ]

  const [otherModel, setotherModel] = useState(false)
  const toggleOpenOthers = () => setotherModel(!otherModel)

  useEffect(() => {
    GetCustomerHelp()
    if (props.match.params.id) {

      Edithdr()
      EditOC()
      Editdtl()
    } else {
      GetCustomerHelp()
    }
    // Getalltransport()

  }, [])

  useEffect(() => {
    const handleBeforeUnload = event => {
      event.preventDefault()
      event.returnValue = "Are You Sure Reload This page" // This is required for some browsers
    }

    window.addEventListener("beforeunload", handleBeforeUnload)

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  }, [])

  useEffect(() => {
    GetBank()
    GetCurrency()
    GetWarehouse()
  }, [])

  const [openPrev, setopenPrev] = useState(false)

  function PrevRateOpen() {
    setopenPrev(true)
  }

  const ClosePrevpopup = () => {
    setopenPrev(false)
  }

  // const options2 = []
  const [options2, setoptions2] = useState([])

  let cgst1 = 0
  let sgst1 = 0
  let igst1 = 0
  let status = ""
  let qcqty = ""
  let qcrate = ""
  let billdiscount1 = 0
  let Dutyamt = 0
  let othertempcollection = []
  let quotationid = 0

  const [tokent, settokent] = useState(
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  )
  const history = useHistory()

  const [PrintPerview, setPrintPerview] = useState(false)
  const [IndexforUom, setIndexforUom] = useState('')
  const [productfromQCFlag, setproductfromQCFlag] = useState("Y")
  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [modal2, setModal2] = useState(false)
  const [customerid, setcustomerid] = useState("")
  const [state, setstate] = useState("")
  const [statecode, setstatecode] = useState("")
  const [customerStateCode, SetCustomerStatecode] = useState(null)
  const [stateid, setstateid] = useState("")
  const [quotationno, setquotationno] = useState("")
  const [contactno, setcontactno] = useState("")
  const [RateError, setRateError] = useState(false)
  const [customerNameHelp, setcustomerNameHelp] = useState({
    label: "Select",
    value: "",
  })
  const classes = useStyles()

  const [dialogbox, setdialogbox] = useState(false)
  const [modalUom, setmodalUom] = useState(false)
  const [otherchargeshelp, setotherchargeshelp] = useState({
    label: "Other Charges",
    value: "",
  })

  const [shiptohelp, setshiptohelp] = useState({
    label: "Select",
    value: "",
  })
  const [salesmanhelp, setsalesmanhelp] = useState({
    label: "Select",
    value: "0",
  })
  const [departmenthelp, setdepartmenthelp] = useState({
    label: "Select",
    value: "",
  })
  const [CustomerModal, setCustomerModal] = useState(false)
  const [billingaddress, setbillingaddress] = useState("")
  const [contactperson, setcontactperson] = useState("")
  const [contactperson1, setcontactperson1] = useState('')
  const [contactno1, setcontactno1] = useState('')
  const [shipto, setshipto] = useState("")
  const [shippingaddress, setshippingaddress] = useState("")
  const [currency, setcurrency] = useState("")
  const [currencyid, setcurrencyid] = useState("")
  const [payrefno, setpayrefno] = useState("")
  const [payterms, setpayterms] = useState("Within 15 Days")
  const [deliveryterms, setdeliveryterms] = useState("Free Delivery")
  const [deliveryperiod, setdeliveryperiod] = useState("Tax as per applicable.")
  const [orderrefdate, setorderrefdate] = useState(new Date())
  const [invoicetype, setinvoicetype] = useState(options1[0].value)
  const [bank, setbank] = useState("")
  const [quotationdate, setquotationdate] = useState(new Date())
  const [transport, settransport] = useState("")
  const [remarks, setremarks] = useState("")
  const [nodataerror, setnodataerror] = useState(false)
  const [QtyEnter, setQtyEnter] = useState()
  const [LabelTax, setLabelTax] = useState("")
  const [LabelUom, setLabelUom] = useState("")
  const [customerNameHelpData, setcustomerNameHelpData] = useState([])
  const [customerNameHelpData1, setcustomerNameHelpData1] = useState([])
  const [salesmanhelpData, setsalesmanhelpData] = useState([])
  const [departmenthelpData, setdepartmenthelpData] = useState([])
  const [CessData, setCessData] = useState([])
  const [cessdatavalue, setcessdatavalue] = useState({
    label: "Select",
    value: "",
  })
  const [otherchargesData, setotherchargesData] = useState([])
  const [productionscollection2, setproductionscollection2] = useState([])

  const [otherchargesData1, setotherchargesData1] = useState([])
  const [otherchargesData2, setotherchargesData2] = useState([])
  const [shiptoHelpData, setshiptoHelpData] = useState([])
  const [shiptoHelpData1, setshiptoHelpData1] = useState([])
  const [SOHeaderData, setSOHeaderData] = useState([])
  const QtyRef = useRef(null)
  const [SingleArray, setSingleArray] = useState([])

  const SelectProcuctRef = useRef(null)
  const [SOHeaderData1, setSOHeaderData1] = useState([])
  const [orderidarr, setorderidarr] = useState([])
  const [productcollection, setproductcollection] = useState([])
  const [otherchargescollection, setotherchargescollection] = useState([])
  const [otherchargescollection2, setotherchargescollection2] = useState([])
  const [prevpricedata, setprevpricedata] = useState([])
  const [prevpriceProductName, setprevpriceProductName] = useState("")
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteModal1, setDeleteModal1] = useState(false)
  const [confirmation, setconfirmation] = useState(false)
  const [deletid, setdeletid] = useState("")
  const [deletid1, setdeletid1] = useState("")
  const [deletid2, setdeletid2] = useState("")
  const keys = ["customer_name"]
  const keys1 = ["product_details_description"]

  const [branchid, setbranchid] = useState("")
  const [currentdate, setcurrentdate] = useState(new Date())
  const [warehouseid, setwarehouseid] = useState("")
  const [invoicesuccess, setinvoicesuccess] = useState(false)
  const [invoiceupdate, setinvoiceupdate] = useState(false)
  const [customerpopup, setcustomerpopup] = useState(false)
  const [productpopup, setproductpopup] = useState(false)
  const [quantitypopup, setquantitypopup] = useState(false)
  const [rowsData, setrowsData] = useState([])
  const [productdata, setproductdata] = useState([])
  const [productdata1, setproductdata1] = useState([])
  const [Options, setOptions] = useState([])
  const [val, setval] = useState({ label: "Select...", value: "" })
  const [editdatahdr, seteditdatahdr] = useState([])
  const [totalamt, settotalamt] = useState(0)
  const [roundoffamt, setroundoffamt] = useState(0)
  const [roundoffstatus, setroundoffstatus] = useState("N")
  const [roundoffstatus1, setroundoffstatus1] = useState(false)
  const [getproductquotation, setgetproductquotation] = useState(false)
  const [searchvalue, setsearchvalue] = useState("")
  const [overflow, setOverflow] = useState("auto")
  const [qtyerror, setqtyerror] = useState(false)
  const [rateerror, setrateerror] = useState(false)
  const [otherchargeserr, setotherchargeserr] = useState(false)
  const [Popupimage, setPopupimage] = useState("")
  const [open, setopen] = useState(false)
  const [billdiscount, setbilldiscount] = useState(null)
  const [cessids, setcessids] = useState("")

  // Group Id
  const [groupid, setgroupid] = useState('')


  const [productsuccess, setproductsuccess] = useState(false)
  const [productupdate, setproductupdate] = useState(false)

  //Previos price
  const [previousprice, setpreviousprice] = useState(false)
  const [previouspriceShow, setpreviouspriceShow] = useState(false)
  // Rate and Discount
  const RateRef = useRef(null)
  const DisRef = useRef(null)
  const [RateEnter, setRateEnter] = useState()
  const [DisEnter, setDisEnter] = useState()
  const [tempCollection, settempCollection] = useState([])

  // Customer Set
  const CustomerRef = useRef(null)

  // Product Master
  const [ProductModal, setProductModal] = useState(false)
  const [RandomCallback, setRandomCallback] = useState('')
  const [RandomCallbackCustomer, setRandomCallbackCustomer] = useState('')
  const [EditProduct, setEditProduct] = useState(false)
  const [returnValue, setreturnValue] = useState(false)

  const [WarehouseTotalQty, setWarehouseTotalQty] = useState(0)
  const [WarehouseTotalQtySecondQty, setWarehouseTotalQtySecondQty] =
    useState(0)
  const [warehouseblockedSecondQty, setwarehouseblockedSecondQty] = useState(0)
  const [ConQty, setConQty] = useState(1)
  const [StockUOM, setStockUOM] = useState()
  const [UOMType, setUOMType] = useState("Secondary")
  const [SecondaryQtyUOM, setSecondaryQtyUOM] = useState("")
  const [warehouseBalanceQty, setwarehouseBalanceQty] = useState(0)
  const [warehouseblockedQty, setwarehouseblockedQty] = useState(0)
  const [PrimarywarehouseQty, setPrimarywarehouseQty] = useState(0)
  const [ViewStockDetails, setViewStockDetails] = useState(false)
  const [ControlcenterScreenStock, setControlcenterScreenStock] = useState(true)
  const [OtherChargesModal, setOtherChargesModal] = useState(false)
  const [RandomcallbackOthercharges, setRandomcallbackOthercharges] = useState('')

  const [validBlockedQty, setvalidBlockedQty] = useState(0)
  const [ProductName, setProductName] = useState('')
  const [BlockModal, setBlockModal] = useState(false)
  const [BlockDeliverydate, setBlockDeliverydate] = useState("")
  const [warehouseQtyCollection, setwarehouseQtyCollection] = useState([])
  const [ChangedBlockedCollection, setChangedBlockedCollection] = useState([])

  const [Buyersuccess, setBuyersuccess] = useState(false)
  const [Updatedalert, setUpdatedalert] = useState(false)

  const [deletedconfirm, setdeletedconfirm] = useState(false);

  const [dailoa1, setdailoa1] = useState(false)

  const LedgerRef = useRef(null)

  const getFinancialYear = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // Months are zero-based

    let startYear, endYear;

    // Assuming the financial year starts in April and ends in March
    if (currentMonth >= 4) {
      startYear = currentYear;
      endYear = currentYear + 1;
    } else {
      startYear = currentYear - 1;
      endYear = currentYear;
    }

    return `${startYear} - ${endYear}`;
  };

  // console.log(getFinancialYear()); // Example Output: "2024 - 2025"
  sessionStorage.setItem("Finalyear", getFinancialYear());



  const toggleblock = id => {
    getallwarehouseqty(id, "Getoneproduct")
    setBlockModal(!BlockModal)
  }
  const toggles = () => {
    setBlockModal(false)
  }



  const totalGrossAmount = productcollection.reduce((accumulator, object) => {
    return accumulator + object.Rate * object.Quantity - object.DisAmt
  }, 0)

  // console.log(totalGrossAmount,'totalGrossAmount')

  // Total CGST

  const totalCGSTAmount = useMemo(() => {
    // console.log(totalGrossAmount,'totalGrossAmount Inside')
    let totalCGSTAmount = 0;
    let gstAmount = 0;

    for (let i = 0; i < productcollection.length; i++) {
      const product = productcollection[i];


      let baseAmount = product.Rate * product.Quantity - product.DisAmt;
      //  console.log(baseAmount,'initialbaseamount')

      for (let j = 0; j < otherchargescollection.length; j++) {
        const otherCharge = otherchargescollection[j];

        if (otherCharge.GST_Applicability === "N" && otherCharge.Calculation_Of_GST === "Y") {
          // Check if the type is "Addition" or "Deduction"
          if (otherCharge.Type === "Addition") {
            gstAmount += (otherCharge.Amount / totalGrossAmount) * baseAmount;
          } else if (otherCharge.Type === "Deduction") {
            gstAmount -= (otherCharge.Amount / totalGrossAmount) * baseAmount;
          }
        }
      }




      // console.log(gstAmount,baseAmount,'baseamount') 
      // Calculate GST on the adjusted base amount
      totalCGSTAmount += ((gstAmount + baseAmount) * product.GSTPer) / 100 / 2;
      // console.log(totalCGSTAmount,'gstAmount')
      gstAmount = 0
    }

    // Additional charges that apply after the product loop
    const additionalCharges = otherchargescollection
      .filter(
        (data) =>
          data.Type === "Addition" &&
          data.GST_Applicability === "Y" &&
          data.Calculation_Of_GST === "N" &&
          ([13, 15].includes(parseInt(data.GroupId)) || [13, 15].includes(parseInt(data.UnderGroupId)))
      )
      .reduce((accumulator, object) => {
        return accumulator + (parseFloat(object.Amount) * parseFloat(object.Tax) / 100);
      }, 0);

    // console.log(additionalCharges,'additionalCharges')

    // Deduction charges after product loop
    const deductionCharges = otherchargescollection
      .filter((data) =>
        data.Type === "Deduction" &&
        data.GST_Applicability === "Y" &&
        data.Calculation_Of_GST === "N" &&
        ([13, 15].includes(parseInt(data.GroupId)) || [13, 15].includes(parseInt(data.UnderGroupId)))
      )
      .reduce((accumulator, object) => {
        return accumulator + (parseFloat(object.Amount) * parseFloat(object.Tax) / 100);
      }, 0);


    // console.log(deductionCharges,'deductionCharges')
    // Final total calculation including additions and deductions
    totalCGSTAmount += (additionalCharges - deductionCharges) / 2;

    return totalCGSTAmount;
  }, [productcollection, otherchargescollection]);
  // console.log("Total CGST Amount:", totalCGSTAmount);

  // Total SGST

  const totalSGSTAmount = useMemo(() => {
    let totalSGSTAmount = 0;
    let gstAmount = 0;

    for (let i = 0; i < productcollection.length; i++) {
      const product = productcollection[i];


      let baseAmount = product.Rate * product.Quantity - product.DisAmt;
      //  console.log(baseAmount,'initialbaseamount')

      for (let j = 0; j < otherchargescollection.length; j++) {
        const otherCharge = otherchargescollection[j];

        if (otherCharge.GST_Applicability === "N" && otherCharge.Calculation_Of_GST === "Y") {
          // Check if the type is "Addition" or "Deduction"
          if (otherCharge.Type === "Addition") {
            gstAmount += (otherCharge.Amount / totalGrossAmount) * baseAmount;
          } else if (otherCharge.Type === "Deduction") {
            gstAmount -= (otherCharge.Amount / totalGrossAmount) * baseAmount;
          }
        }
      }




      // console.log(gstAmount,baseAmount,'baseamount') 
      // Calculate GST on the adjusted base amount
      totalSGSTAmount += ((gstAmount + baseAmount) * product.GSTPer) / 100 / 2;
      // console.log(totalCGSTAmount,'gstAmount')
      gstAmount = 0
    }

    // Additional charges that apply after the product loop
    const additionalCharges = otherchargescollection
      .filter(
        (data) =>
          data.Type === "Addition" &&
          data.GST_Applicability === "Y" &&
          data.Calculation_Of_GST === "N" &&
          ([13, 15].includes(parseInt(data.GroupId)) || [13, 15].includes(parseInt(data.UnderGroupId)))
      )
      .reduce((accumulator, object) => {
        return accumulator + (parseFloat(object.Amount) * parseFloat(object.Tax) / 100);
      }, 0);

    // console.log(additionalCharges,'additionalCharges')

    // Deduction charges after product loop
    const deductionCharges = otherchargescollection
      .filter((data) =>
        data.Type === "Deduction" &&
        data.GST_Applicability === "Y" &&
        data.Calculation_Of_GST === "N" &&
        ([13, 15].includes(parseInt(data.GroupId)) || [13, 15].includes(parseInt(data.UnderGroupId)))
      )
      .reduce((accumulator, object) => {
        return accumulator + (parseFloat(object.Amount) * parseFloat(object.Tax) / 100);
      }, 0);


    // console.log(deductionCharges,'deductionCharges')
    // Final total calculation including additions and deductions
    totalSGSTAmount += (additionalCharges - deductionCharges) / 2;

    return totalSGSTAmount;
  }, [productcollection, otherchargescollection]);

  // Total IGST
  const totalIGSTAmount = useMemo(() => {
    let totalIGSTAmount = 0;
    let gstAmount = 0;

    for (let i = 0; i < productcollection.length; i++) {
      const product = productcollection[i];


      let baseAmount = product.Rate * product.Quantity - product.DisAmt;
      //  console.log(baseAmount,'initialbaseamount')

      for (let j = 0; j < otherchargescollection.length; j++) {
        const otherCharge = otherchargescollection[j];

        if (otherCharge.GST_Applicability === "N" && otherCharge.Calculation_Of_GST === "Y") {
          // Check if the type is "Addition" or "Deduction"
          if (otherCharge.Type === "Addition") {
            gstAmount += (otherCharge.Amount / totalGrossAmount) * baseAmount;
          } else if (otherCharge.Type === "Deduction") {
            gstAmount -= (otherCharge.Amount / totalGrossAmount) * baseAmount;
          }
        }
      }


      // console.log(gstAmount,baseAmount,'baseamount') 
      // Calculate GST on the adjusted base amount
      totalIGSTAmount += ((gstAmount + baseAmount) * product.GSTPer) / 100;
      // console.log(product.GSTPer,'gstAmount')
      gstAmount = 0
    }

    // Additional charges that apply after the product loop
    const additionalCharges = otherchargescollection
      .filter(
        (data) =>
          data.Type === "Addition" &&
          data.GST_Applicability === "Y" &&
          data.Calculation_Of_GST === "N" &&
          ([13, 15].includes(parseInt(data.GroupId)) || [13, 15].includes(parseInt(data.UnderGroupId)))
      )
      .reduce((accumulator, object) => {
        return accumulator + (parseFloat(object.Amount) * parseFloat(object.Tax) / 100);
      }, 0);

    // console.log(additionalCharges,'additionalCharges')

    // Deduction charges after product loop
    const deductionCharges = otherchargescollection
      .filter((data) =>
        data.Type === "Deduction" &&
        data.GST_Applicability === "Y" &&
        data.Calculation_Of_GST === "N" &&
        ([13, 15].includes(parseInt(data.GroupId)) || [13, 15].includes(parseInt(data.UnderGroupId)))
      )
      .reduce((accumulator, object) => {
        return accumulator + (parseFloat(object.Amount) * parseFloat(object.Tax) / 100);
      }, 0);


    // console.log(deductionCharges,'deductionCharges')
    // Final total calculation including additions and deductions
    totalIGSTAmount += (additionalCharges - deductionCharges);

    return totalIGSTAmount;
  }, [productcollection, otherchargescollection]);

  console.log(productcollection.reduce(
    (accumulator, object) => {
      return (
        accumulator +
        (object.Rate * object.Quantity -
          object.DisAmt

        )
      )
    },
    0
  ), 'totalGrossAmount')


  // Gross Total Amount
  const productCollectionTotal = useMemo(() => {
    return productcollection.reduce((accumulator, object) => {
      return (
        accumulator +
        (object.Rate * object.Quantity - object.DisAmt)
      );
    }, 0);
  }, [productcollection]);

  // Total OtherCharges Amount
  const totalOtherChargesAmount = useMemo(() => {
    return otherchargescollection.reduce((accumulator, object) => {
      const amount = Number(object.Amount); // Ensure Amount is treated as a number
      if (object.Type === "Addition") {
        return accumulator + amount;
      } else if (object.Type === "Deduction") {
        return accumulator - amount;
      }
      return accumulator;
    }, 0);
  }, [otherchargescollection]);

  // Calculate the NetAmount
  const NetAmount = useMemo(() => {
    return productCollectionTotal + totalOtherChargesAmount + totalIGSTAmount;
  }, [productCollectionTotal, totalOtherChargesAmount, totalIGSTAmount]);

  // console.log("Total Other Charges Amount:", formattotalOtherChargesAmount);

  // console.log(NetAmount,productCollectionTotal,totalOtherChargesAmount,totalCGSTAmount,totalSGSTAmount,totalIGSTAmount,'totalOtherChargesAmount')

  const getallwarehouseqty = async (id, id1) => {
    const get = await axios.instance
      .get(
        `/getallwarehousestock/${id}/${id1}/${sessionStorage.getItem(
          "Companyid"
        )}/${props.match.params.id ? props.match.params.id : 0}`,
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(res => {
        if (ChangedBlockedCollection.length != 0) {
          const updatedData = res.data.map(item => {
            const blockedItem = ChangedBlockedCollection.find(
              bItem =>
                bItem.WarehouseId === item.WarehouseId &&
                bItem.Product_Details_Id == item.Product_Details_Id
            )
            const BlockDeliverydates = ChangedBlockedCollection.find(
              bItem =>
                bItem.WarehouseId === item.WarehouseId &&
                bItem.Product_Details_Id == item.Product_Details_Id
            )
            return {
              ...item,
              Blocked_Qty: blockedItem
                ? blockedItem.Blocked_Qty
                : item.Blocked_Qty,
              Deliverydate: BlockDeliverydates
                ? BlockDeliverydates.Deliverydate
                : BlockDeliverydate,
            }
          })
          setwarehouseQtyCollection(updatedData)
        } else {
          if (!props.match.params.id) {
            const newInputValues = res.data.map((item, index) => {
              const updatedItem = {
                ...item,

                Deliverydate: BlockDeliverydate,
              }
              return updatedItem
            })
            setwarehouseQtyCollection(newInputValues)
          } else {
            const newInputValues = res.data.map((item, index) => {
              const updatedItem = {
                ...item,

                Deliverydate: moment(item.Deliverydate).format("YYYY-MM-DD"),
              }
              return updatedItem
            })
            setwarehouseQtyCollection(newInputValues)
          }
        }

        if (id1 == "Getoneproduct") {
          let primaryQty = []
          for (const data of res.data) {
            if (data.primaryWarehouse == "Y") {
              setPrimarywarehouseQty(
                parseInt(data.Stock) - parseInt(data.AlreadyBlockedQty)
              )
              // console.log(data.Stock, "data.Stock")
            }
          }
        }
      })
  }


  const returnFromProductMaster = (value, value1) => {
    setreturnValue(value)
    if (value) {
      setval({ label: "Select...", value: "" })
      GetAllProducts()
      if (value1 == 'New') {
        setproductsuccess(true)
      }
      else {
        setproductupdate(true)
      }

      setOptions([])
      setQtyEnter("")
      setRateEnter("")
      setDisEnter("")
    }
  }


  const returnFromLedgerMaster = (value, value1) => {
    if (value) {
      setcustomerNameHelp({
        label: "Select...",
        value: "",
      })
      // }

      GetCustomerHelp()
      if (value1 == 'New') {
        setBuyersuccess(true)
      }
      else {
        setUpdatedalert(true)
      }
      setCustomerModal(false)
      setcustomerid("")
      setcontactno("")
      setbillingaddress("")
    }
  }



  const totalAmount = productcollection.reduce((accumulator, object) => {
    return accumulator + object.Rate * object.Quantity - object.DisAmt
  }, 0)

  // For Other Charges Amount 
  function updateFinalTotalAmount() {
    // Initialize the amount with the base `totalAmount`
    let latestFinalTotalAmount = totalAmount;

    // Create a copy of the `otherchargescollection` to work on
    let updatedCharges = [...otherchargescollection];


    // Iterate over each charge in `otherchargescollection`
    for (let i = 0; i < updatedCharges.length; i++) {
      const charge = updatedCharges[i];

      // Ensure that charge.Amount can be converted to a valid number
      const amount = parseFloat(charge.Amount);
      if (isNaN(amount)) {
        console.error(`Invalid amount at index ${i}:`, charge.Amount);
        continue; // Skip to the next iteration if the amount is not valid
      }

      // Calculate percentage based on the current total (before modifying it)
      updatedCharges[i].Percentage = Number((amount * 100) / latestFinalTotalAmount).toFixed(2);


      // Apply addition or subtraction based on `charge.Type`
      if (charge.Type === "Addition") {
        latestFinalTotalAmount += amount;
      } else if (charge.Type === "Deduction") {
        latestFinalTotalAmount -= amount;
      }


      // Log the current total after each item
      // console.log(`Final Total Amount (after ${charge.Type} at index ${i}):`, latestFinalTotalAmount);
    }

    // Update the state with the modified charges
    setotherchargescollection(updatedCharges);

    // Set the final total amount
    // setotherTotalamt(latestFinalTotalAmount);

    // Log the updated final total amount after applying all charges
    // console.log("Initial Total Amount (without charges):", totalAmount);
    // console.log("Final Total Amount (with all charges):", latestFinalTotalAmount);
  }

  // For Other Charges Percentage 
  function updateFinalPercentage() {
    // Initialize the amount with the base `totalAmount`
    let latestFinalTotalAmount = totalAmount;

    // Create a copy of the `otherchargescollection` to work on
    let updatedCharges = [...otherchargescollection];


    // Iterate over each charge in `otherchargescollection`
    for (let i = 0; i < updatedCharges.length; i++) {
      const charge = updatedCharges[i];

      // Ensure that charge.Amount can be converted to a valid number
      const percentage = parseFloat(charge.Percentage);
      if (isNaN(percentage)) {
        console.error(`Invalid amount at index ${i}:`, charge.Percentage);
        continue; // Skip to the next iteration if the amount is not valid
      }

      // Calculate percentage based on the current total (before modifying it)
      updatedCharges[i].Amount = Number(latestFinalTotalAmount * (percentage) / 100).toFixed(2);


      // Apply addition or subtraction based on `charge.Type`
      if (charge.Type === "Addition") {
        latestFinalTotalAmount += latestFinalTotalAmount * (percentage) / 100
      } else if (charge.Type === "Deduction") {
        latestFinalTotalAmount -= latestFinalTotalAmount * (percentage) / 100
      }


      // Log the current total after each item
      // console.log(`Final Total Amount (after ${charge.Type} at index ${i}):`, latestFinalTotalAmount);
    }

    // Update the state with the modified charges
    setotherchargescollection(updatedCharges);

    // Set the final total amount
    // setotherTotalamt(latestFinalTotalAmount);

    // Log the updated final total amount after applying all charges
    // console.log("Initial Total Amount (without charges):", totalAmount);
    // console.log("Final Total Amount (with all charges):", latestFinalTotalAmount);
  }

  //     console.log(productcollection,otherchargescollection,'Collection')
  //     console.log(   
  //       numeral( productcollection.reduce(
  //       (accumulator, object) => {
  //         return (
  //           accumulator +
  //           ((object.Rate *
  //             object.Quantity -
  //             object.DisAmt +
  //             ((object.Rate *
  //               object.Quantity -
  //               object.DisAmt) *
  //               object.OtherChargesAdd) /
  //               100 -
  //             ((object.Rate *
  //               object.Quantity -
  //               object.DisAmt) *
  //               object.OtherChargesSub) /
  //               100) *
  //             object.GSTPer) /
  //             100 /
  //             2
  //         )
  //       },
  //       0
  //     ) +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
  //       return (
  //         accumulator +
  //         (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
  //       )
  //     }, 0)-
  // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
  //       return (
  //         accumulator +
  //         (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


  //       )
  //     }, 0))/2
  //   ).format("0,0.00"))

  // console.log(productcollection.reduce(
  //   (accumulator, object) => {
  //     return (
  //       accumulator +
  //       ((object.Rate *
  //         object.Quantity -
  //         object.DisAmt +
  //         ((object.Rate *
  //           object.Quantity -
  //           object.DisAmt) *
  //           object.OtherChargesAdd) /
  //           100 -
  //         ((object.Rate *
  //           object.Quantity -
  //           object.DisAmt) *
  //           object.OtherChargesSub) /
  //           100) *
  //         object.GSTPer) /
  //         100 /
  //         2
  //     )
  //   },
  //   0
  // ) ,'Productcollection Tax %')

  // console.log(
  //   productcollection.reduce(
  //     (accumulator, object) => {
  //       // Calculate the base amount after discount only
  //       const baseAmount = object.Rate * object.Quantity - object.DisAmt;

  //       // Accumulate the base amount
  //       return accumulator + baseAmount;
  //     },
  //     0 // Initial accumulator value
  //   ),
  //   'Productcollection Total Base Amount'
  // );



  // console.log((otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
  //     return (
  //       accumulator +
  //       (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
  //     )
  //   }, 0)-
  // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
  //     return (
  //       accumulator +
  //       (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


  //     )
  //   }, 0))/2,'GST Applicability Percentage')

  const OtherCalAmt = otherchargescollection.reduce((accumulator, object) => {
    // console.log(object,"hanok ref")
    if (object.Calculation_Of_GST == "N") {
      if (object.Type === "Deduction") {
        return accumulator - parseFloat(object.Amount)
      } else if (object.Type === "Addition") {
        return accumulator + parseFloat(object.Amount)
      }
    } else {
      return 0
    }

  }, 0)
  // const formattedOtherCalAmt = numeral(OtherCalAmt).format("0,0.00")
  const options3 = [
    { value: "Addition", text: "+" },
    { value: "Deduction", text: "-" },
  ]
  const toggleUom = () => setmodalUom(!modalUom)
  useEffect(() => {
    var date = new Date()
    var firstday = new Date(
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    )
    setorderrefdate(moment(firstday).format("YYYY-MM-DD"))
    if (!props.match.params.id) {
      setquotationdate(moment(firstday).format("YYYY-MM-DD"))
    }
    setcurrentdate(moment(firstday).format("YYYY-MM-DD"))
    GetSalesMan()
    GetDepartment()
    GetAllProducts()
    GetOtherChargesHelp()
    GetCessHelp()
    // GetCustomerHelp()
  }, [])

  useEffect(() => { }, [roundoffstatus])

  const GetBank = async () => {
    const get1 = await axios.instance
      .get(`/GetAllBank/${sessionStorage.getItem("Companyid")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(async res => {
        const data = res.data
        const opt = data.map(b => ({
          text: b.BankName,
          value: b.BankId,
        }))
        setoptions2(opt)

        const get = await axios.instance
          .get(`/GetBank`, {
            headers: {
              Authorization: tokent,
              "Content-Type": "application/json",
            },
          })
          .then(res => {
            // const index = data.findIndex(object => {
            //     return object.BankId === res.data[0].BankId;
            //   });
            //
            //   document.getElementById("bank")[index].setAttribute('selected','selected');
            if (!props.match.params.id) {
              setbank(res.data[0].BankId)
            }
          })
      })
  }

  const GetCustomerHelp = async (cust_id) => {
    const get = await axios.instance
      .get(`/GetallCustomerHelp/${sessionStorage.getItem("Companyid")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        setcustomerNameHelpData1(res.data)
        const data = res.data
        const options = data.map(b => ({
          label: b.customer_name,
          value: b.customer_id,
        }))
        options.unshift({ label: "Add Ledger....", value: "" })
        setcustomerNameHelpData(options)

        if (props.match.params.id && cust_id) {
          let CustomerHelpArray =
            res.data.filter(
              item => item.customer_id == cust_id
            )
          EditCustomer(CustomerHelpArray)
          // console.log(CustomerHelpArray,cust_id,'customerid')
        }
      })
  }

  // console.log(customerNameHelpData1,'customerNameHelpDatayyyyyy')
  // let CustomerHelpArray =
  // customerNameHelpData1.filter(
  //   item => item.customer_id == customerid
  // )
  // console.log(CustomerHelpArray)
  // if (CustomerHelpArray.length > 0) {
  //   // Assuming you want the contact_person from the first matching object
  //   setcontactperson1(CustomerHelpArray[0].contact_person);
  // } else {
  //   console.log("No matching customer found");
  //   setcontactperson1(null); // Or handle the case as needed
  // }
  // selectedCustomer(CustomerHelpArray)

  const GetSalesMan = async () => {
    const get = await axios.instance
      .get(`/GetSalesmanHelp`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.user_name,
          value: b.user_id,
        }))
        // options.push({'label':'Select','value':''})
        setsalesmanhelpData(options)
      })
  }

  const GetDepartment = async () => {
    const get = await axios.instance
      .get(`/GetDepartmentHelp`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.department_description,
          value: b.department_description,
        }))
        setdepartmenthelpData(options)
      })
  }

  const GetCessHelp = async () => {
    const get = await axios.instance
      .get(`/GetCessHelp/${sessionStorage.getItem("Companyid")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        setCessData(res.data)
      })
  }

  const cesspopup = (id1, id2) => {
    const newInputValues = [...productcollection]
    newInputValues[cessids].ExciseId = parseInt(id1)
    newInputValues[cessids].ExcisePer = parseInt(id2)
    setproductcollection(newInputValues)
    // NormalCalculation()
  }

  const GetOtherChargesHelp = async () => {
    const get = await axios.instance
      .get(`/GetOtherCharges/${sessionStorage.getItem("Companyid")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {

        let data
        if (otherchargescollection.length != 0) {

          data = res.data.filter(
            item => otherchargescollection.every(items => item.customer_id != items.LedgerId)
          );

        } else {
          data = (res.data)
        }
        setotherchargesData1(data)


        const options = data.map(b => ({
          label: b.customer_name,
          value: b.customer_id,
        }))
        setotherchargesData2(options)
        if (othertempcollection.length !== 0) {
          let removedata = othertempcollection.map(obj =>
            parseInt(obj.LedgerId)
          )

          let filtereddata = data.filter(
            obj => !removedata.includes(parseInt(obj.customer_id))
          )

          const options = filtereddata.map(b => ({
            label: b.customer_name,
            value: b.customer_id,
          }))
          options.unshift({ label: "Add Ledger....", value: "" })
          setotherchargesData(options)
        } else {
          const options = data.map(b => ({
            label: b.customer_name,
            value: b.customer_id,
          }))
          options.unshift({ label: "Add Ledger....", value: "" })
          setotherchargesData(options)
        }
      })
  }

  const GetShiptoHelp = async id => {
    const get = await axios.instance
      .get(`/GetallShipToHelp/${id}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        setshiptoHelpData1(res.data)
        const data = res.data
        const options = data.map(b => ({
          label: b.branch_name,
          value: b.branch_id,
        }))
        setshiptoHelpData(options)
      })
  }

  const GetCurrency = async () => {
    const get = await axios.instance
      .get(`/GetCurrency`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        for (const data of res.data) {
          setcurrency(data.CurrencyCode)
          setcurrencyid(data.CurrencyId)
        }
      })
  }

  const GetWarehouse = async () => {
    const get = await axios.instance
      .get(`/Getwarehouse/${sessionStorage.getItem("Companyid")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        for (const data of res.data) {
          setwarehouseid(data.Warehouse_Id)
        }
      })
  }

  const GetAllProducts = async () => {
    const get = await axios.instance
      .get(`/GetProducts/${sessionStorage.getItem("Companyid")}/${sessionStorage.getItem("Branch_Log")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        // console.log(res.data)
        setproductdata1(data)
        if (productcollection.length !== 0) {
          let removedata = productcollection.map(obj =>
            parseInt(obj.Product_Details_Id)
          )
          let filtereddata = data.filter(
            obj => !removedata.includes(obj.product_details_id)
          )
          setproductdata(filtereddata)
        } else {
          setproductdata(data)
        }
      })
  }
  // console.log(contactperson, "contactperson")
  const InsertQuotationhdr = async () => {
    // console.log(productcollection,'inserthdr')
    setdailoa1(true)
    const get = await axios.instance
      .post(
        "/InsertQuoationHdr",
        {
          Quotation_Id: "",
          Quotation_No: 0,
          Quotation_Date: quotationdate,
          Company_Id: sessionStorage.getItem("Companyid"),
          Bank_Id: bank,
          Customer_Id: customerid,
          Branch_Id: sessionStorage.getItem("Branch_Log"),
          RefNo: "",
          Remarks: remarks,
          Payment: payterms,
          Delivery: deliveryterms,
          Tax: deliveryperiod,
          Created_by: sessionStorage.getItem("Userid"),
          Created_on: currentdate,
          Modified_by: sessionStorage.getItem("Userid"),
          Modified_on: currentdate,
          EXCHANGE_RATE: "1",
          TotalAmount: productcollection.reduce((accumulator, object) => {
            return accumulator +
              (object.Rate * object.Quantity - object.DisAmt)
          }, 0),
          VatAmount:
            sessionStorage.getItem("IGSTApplicable") === "Y" &&
              sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("RegisterType") === "SEZ"
                ? 0
                : sessionStorage.getItem("QuotationStateCode") ===
                  sessionStorage.getItem("CStateCode")
                  ?
                  //     productcollection.reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           ((object.Quantity * object.Rate -
                  //             (object.Quantity * object.Rate * object.DisPer) / 100) *
                  //             object.GSTPer) /
                  //             100 /
                  //             2
                  //         )
                  //       }, 0) +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                  //         )
                  //       }, 0)-
                  // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                  //         )
                  //       }, 0))/2
                  numeral(totalCGSTAmount).format("00.00")
                  : 0,
          SalesMan_Id: salesmanhelp.value.length !== 0 ? salesmanhelp.value : 0,
          NetAmount: parseFloat(totalamt),
          OtherCharger:
            // otherchargescollection.length !== 0
            //   ? otherchargescollection.reduce((accumulator, object) => {
            //       return accumulator + parseFloat(object.Amount)
            //     }, 0)
            //   : 0,
            numeral(totalOtherChargesAmount).format("00.00"),
          OtherChargerAEd:
            // otherchargescollection.length !== 0
            //   ? otherchargescollection.reduce((accumulator, object) => {
            //       return accumulator + parseFloat(object.Amount)
            //     }, 0)
            //   : 0,
            numeral(totalOtherChargesAmount).format("00.00"),
          Approve: "Y",
          ApproveDate: currentdate,
          Approve_By: sessionStorage.getItem("Userid"),
          DiscAmt: productcollection.reduce((accumulator, object) => {
            return accumulator + (object.DisAmt === null ? 0 : object.DisAmt)
          }, 0),
          DutyAmt: productcollection.reduce((accumulator, object) => {
            return (
              accumulator +
              ((object.Quantity * object.Rate -
                (object.Quantity * object.Rate * object.DisPer) / 100) *
                object.ExcisePer) /
              100
            )
          }, 0),
          QuoType: "Local",
          OpType: "New",
          CurrencyId: currencyid,
          StateId: stateid,
          PlaceofSupply: state,
          StateCode: statecode,
          SGSTAmt:
            sessionStorage.getItem("IGSTApplicable") === "Y" &&
              sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("RegisterType") === "SEZ"
                ? 0
                : sessionStorage.getItem("QuotationStateCode") ===
                  sessionStorage.getItem("CStateCode")
                  ?
                  //     productcollection.reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           ((object.Quantity * object.Rate -
                  //             (object.Quantity * object.Rate * object.DisPer) / 100) *
                  //             object.GSTPer) /
                  //             100 /
                  //             2
                  //         )
                  //       }, 0) +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                  //         )
                  //       }, 0)-
                  // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                  //         )
                  //       }, 0))/2
                  numeral(totalSGSTAmount).format("00.00")
                  : 0,
          IGSTAmt:
            sessionStorage.getItem("IGSTApplicable") === "Y" &&
              sessionStorage.getItem("RegisterType") === "SEZ"
              ?
              //     productcollection.reduce((accumulator, object) => {
              //         return (
              //           accumulator +
              //           ((object.Quantity * object.Rate -
              //             (object.Quantity * object.Rate * object.DisPer) / 100) *
              //             object.GSTPer) /
              //             100
              //         )
              //       }, 0) +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
              //         return (
              //           accumulator +
              //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
              //         )
              //       }, 0)-
              // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
              //         return (
              //           accumulator +
              //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


              //         )
              //       }, 0))
              numeral(totalIGSTAmount).format("00.00")
              : sessionStorage.getItem("RegisterType") === "SEZ"
                ? 0
                : sessionStorage.getItem("QuotationStateCode") ===
                  sessionStorage.getItem("CStateCode")
                  ? 0
                  :
                  //     productcollection.reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           ((object.Quantity * object.Rate -
                  //             (object.Quantity * object.Rate * object.DisPer) / 100) *
                  //             object.GSTPer) /
                  //             100
                  //         )
                  //       }, 0) +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                  //         )
                  //       }, 0)-
                  // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                  //         )
                  //       }, 0))
                  numeral(totalIGSTAmount).format("00.00"),
          cusbranchId: shipto.length !== 0 ? branchid : 0,
          department: departmenthelp.value,
          CRMquoId: 0,
          RoundOff: "+",
          RoundOffAmt: roundoffamt,
          BillDisc: billdiscount !== null ? billdiscount : 0,
          ContactPerson: shipto.length === 0 ? contactperson : "",
          ContactNo: shipto.length === 0 ? contactno : "",
          ComContactPerson: shipto.length !== 0 ? contactperson : "",
          ComContactNo: shipto.length !== 0 ? contactno : "",
          Fiscal_Year: sessionStorage.getItem("Finalyear"),
          IGSTApplicable: sessionStorage.getItem("IGSTApplicable"),
          Round_off_status: roundoffstatus,
        },
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(res => {
        for (let id of res.data) {
          sessionStorage.setItem("quotationid", id.id)
          quotationid = id.id
        }
      })
  }

  const InsertQuotationdtl = async () => {
    // console.log(productcollection,'insertdtl')
   
    for (const data of productcollection) {
      const productdetail = Object.assign(data, {
        Quotation_Id: quotationid,
        Product_Details_Id: data.Product_Details_Id,
        // UOM_Id: data.UOM_Id,
        // ConQty: data.UOMCheck == "Primary" ? 1 : data.ConQty,
        UOM_Id: data.UOMCheck == "Primary" ? data.UOM_Id : data.Snd_UOM,
        // ConQty: data.ConQty,
        // PriUOM_Id :data.UOM_Id,
        // Sec_UomId:data.Snd_UOM,
        Rate: data.Rate,
        // RateinAED: data.Rate,
        RateinAED: otherchargescollection.filter((data) => data.Calculation_Of_GST === 'Y').length != 0 ? ((data.Rate - data.DisAmt) +
          ((((data.Rate * data.Quantity) - (data.DisAmt)) * (data.OtherChargesAdd) / 100) - (((data.Rate * data.Quantity) - (data.DisAmt)) * (data.OtherChargesSub) / 100))) : data.Rate,
        Quantity: data.Quantity,
        Vat_Percentage:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? 0
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? data.Vat_Percentage
                : 0,
        Amount: data.Rate * data.Quantity - parseFloat(data.DisAmt),
        OpType: "New",
        OtherDesc: data.OtherDesc,
        UOMtype: data.UOMCheck == "Primary" ? 1 : 0,
        DisPer: data.DisPer === null || data.DisPer === "" ? 0 : data.DisPer,
        DisAmt: data.DisAmt === null || data.DisAmt === "" ? 0 : data.DisAmt,
        ExciseId:
          data.ExciseId === null || data.ExciseId === "" ? 0 : data.ExciseId,
        ExcisePer:
          data.ExcisePer === null || data.ExcisePer === "" ? 0 : data.ExcisePer,
        TaxId:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? 0
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? data.TaxId
                : 0,
        GSTPer: data.GSTPer,
        SGSTId:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? 0
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? data.SGSTId
                : 0,
        SGSTPer:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? 0
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? data.SGSTPer
                : 0,
        IGSTId:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? data.IGSTId
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? 0
                : data.IGSTId,
        IGSTPer:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? data.IGSTPer
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? 0
                : data.IGSTPer,
        Withimg: "N",
        MRP_Rate: 0,
        // Assessable_Flag:otherchargescollection.filter(data => ( data.Calculation_Of_GST === 'Y') ).length !=0 ?"Y":"N",
        // Assessable_Value:otherchargescollection.filter((data) => data.Calculation_Of_GST === 'Y').length !=0 ?
        // (((data.Rate * data.Quantity)-(data.DisAmt))*(data.OtherChargesAdd)/100)-(((data.Rate * data.Quantity)-(data.DisAmt))*(data.OtherChargesSub)/100):0          
      })

      const createdetail = await axios.instance
        .post(`/InsertQuoationDtl`, productdetail, {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        })
        .then(res => {
          setorderidarr([])
          // setinvoicesuccess(true)
        })
    }
    setTimeout(() => {
      setdailoa1(false)
    }, 500)
    setproductcollection([])
    SetCustomerStatecode(null)

    setinvoicesuccess(true)

    setTimeout(() => {
      history.push("/Quotation")
    }, 500);
  }
  const returnFromLedgerMasterOtherCharges = (value, value1) => {
    if (value) {
      if (value1 == 'Add') {
        setotherchargeshelp({
          label: "Select...",
          value: "",
        })
        GetOtherChargesHelp()
      }

    }
  }
  const Updatehdr = async () => {
    // console.log(productcollection,  numeral(totalCGSTAmount).format("0,0.00"),'updatehdr')
    const get = await axios.instance
      .post(
        "/InsertQuoationHdr",
        {
          Quotation_Id: props.match.params.id,
          Quotation_No: quotationno,
          Quotation_Date: quotationdate,
          Company_Id: sessionStorage.getItem("Companyid"),
          Bank_Id: bank,
          Customer_Id: customerid,
          Branch_Id: sessionStorage.getItem("Branch_Log"),
          RefNo: "",
          Remarks: remarks,
          Payment: payterms,
          Delivery: deliveryterms,
          Tax: deliveryperiod,
          Created_by: sessionStorage.getItem("Userid"),
          Created_on: currentdate,
          Modified_by: sessionStorage.getItem("Userid"),
          Modified_on: currentdate,
          EXCHANGE_RATE: "1",
          TotalAmount: productcollection.reduce((accumulator, object) => {
            return accumulator +
              (object.Rate * object.Quantity - object.DisAmt)
          }, 0),
          VatAmount:
            sessionStorage.getItem("IGSTApplicable") === "Y" &&
              sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("RegisterType") === "SEZ"
                ? 0
                : sessionStorage.getItem("QuotationStateCode") ===
                  sessionStorage.getItem("CStateCode")
                  ?
                  //     productcollection.reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           ((object.Quantity * object.Rate -
                  //             (object.Quantity * object.Rate * object.DisPer) / 100) *
                  //             object.GSTPer) /
                  //             100 /
                  //             2
                  //         )
                  //       }, 0)+(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                  //         )
                  //       }, 0)-
                  // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                  //         )
                  //       }, 0))/2
                  numeral(totalCGSTAmount).format("00.00")
                  : 0,
          SalesMan_Id: salesmanhelp.value.length !== 0 ? salesmanhelp.value : 0,
          NetAmount: totalamt,
          OtherCharger:
            otherchargescollection.length !== 0
              ? otherchargescollection.reduce((accumulator, object) => {
                return accumulator + parseFloat(object.Amount)
              }, 0)
              : 0,
          OtherChargerAEd:
            otherchargescollection.length !== 0
              ? otherchargescollection.reduce((accumulator, object) => {
                return accumulator + parseFloat(object.Amount)
              }, 0)
              : 0,
          Approve: "Y",
          ApproveDate: currentdate,
          Approve_By: sessionStorage.getItem("Userid"),
          DiscAmt: productcollection.reduce((accumulator, object) => {
            return accumulator + (object.DisAmt === null ? 0 : object.DisAmt)
          }, 0),
          DutyAmt: productcollection.reduce((accumulator, object) => {
            return (
              accumulator +
              ((object.Quantity * object.Rate -
                (object.Quantity * object.Rate * object.DisPer) / 100) *
                object.ExcisePer) /
              100
            )
          }, 0),
          QuoType: "Local",
          OpType: "Edit",
          CurrencyId: currencyid,
          StateId: stateid,
          PlaceofSupply: state,
          StateCode: statecode,
          SGSTAmt:
            sessionStorage.getItem("IGSTApplicable") === "Y" &&
              sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("RegisterType") === "SEZ"
                ? 0
                : sessionStorage.getItem("QuotationStateCode") ===
                  sessionStorage.getItem("CStateCode")
                  ?
                  //     productcollection.reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           ((object.Quantity * object.Rate -
                  //             (object.Quantity * object.Rate * object.DisPer) / 100) *
                  //             object.GSTPer) /
                  //             100 /
                  //             2
                  //         )
                  //       }, 0)+(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                  //         )
                  //       }, 0)-
                  // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                  //         )
                  //       }, 0))/2
                  numeral(totalSGSTAmount).format("00.00")
                  : 0,
          IGSTAmt:
            sessionStorage.getItem("IGSTApplicable") === "Y" &&
              sessionStorage.getItem("RegisterType") === "SEZ"
              ?
              // productcollection.reduce((accumulator, object) => {
              //     return (
              //       accumulator +
              //       ((object.Quantity * object.Rate -
              //         (object.Quantity * object.Rate * object.DisPer) / 100) *
              //         object.GSTPer) /
              //         100
              //     )
              //   }, 0)
              numeral(totalIGSTAmount).format("00.00")
              : sessionStorage.getItem("RegisterType") === "SEZ"
                ? 0
                : sessionStorage.getItem("QuotationStateCode") ===
                  sessionStorage.getItem("CStateCode")
                  ? 0
                  :
                  //     productcollection.reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           ((object.Quantity * object.Rate -
                  //             (object.Quantity * object.Rate * object.DisPer) / 100) *
                  //             object.GSTPer) /
                  //             100
                  //         )
                  //       }, 0)+(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                  //         )
                  //       }, 0)-
                  // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                  //         return (
                  //           accumulator +
                  //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                  //         )
                  //       }, 0))
                  numeral(totalIGSTAmount).format("00.00"),
          cusbranchId: branchid,
          department: departmenthelp.value,
          CRMquoId: 0,
          RoundOff: "+",
          RoundOffAmt: roundoffamt,
          BillDisc: billdiscount !== null ? billdiscount : 0,
          ContactPerson: shipto.length === 0 ? contactperson : "",
          ContactNo: shipto.length === 0 ? contactno : "",
          ComContactPerson: shipto.length !== 0 ? contactperson : "",
          ComContactNo: shipto.length !== 0 ? contactno : "",
          Fiscal_Year: sessionStorage.getItem("FInalyear"),
          IGSTApplicable: sessionStorage.getItem("IGSTApplicable"),
          Round_off_status: roundoffstatus,
        },
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(res => {
        for (let id of res.data) {
          sessionStorage.setItem("quotationid", id.id)
        }
      })
  }

  const Updatedtl = async () => {
    //  console.log(productcollection,'updatedtl')
    for (const data of productcollection) {
      const productdetail = Object.assign(data, {
        Quotation_Id: props.match.params.id,
        Product_Details_Id: data.Product_Details_Id,
        // UOM_Id: data.UOM_Id,
        // ConQty: data.UOMCheck == "Primary" ? 1 : data.ConQty,
        UOM_Id: data.UOMCheck == "Primary" ? data.UOM_Id : data.Snd_UOM,
        // ConQty: data.ConQty,
        // PriUOM_Id :data.UOM_Id,
        // Sec_UomId:data.Snd_UOM,
        Rate: data.Rate,
        // RateinAED: data.Rate,
        RateinAED: otherchargescollection.filter((data) => data.Calculation_Of_GST === 'Y').length != 0 ? ((data.Rate - data.DisAmt) +
          ((((data.Rate * data.Quantity) - (data.DisAmt)) * (data.OtherChargesAdd) / 100) - (((data.Rate * data.Quantity) - (data.DisAmt)) * (data.OtherChargesSub) / 100))) : data.Rate,
        Quantity: data.Quantity,
        Vat_Percentage:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? 0
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? data.Vat_Percentage
                : 0,
        Amount: data.Rate * data.Quantity - parseFloat(data.DisAmt),
        OpType: "Edit",
        OtherDesc: data.OtherDesc,
        UOMtype: data.UOMtype == 'Primary' ? 1 : 0,
        DisPer: data.DisPer === null || data.DisPer === "" ? 0 : data.DisPer,
        DisAmt: data.DisAmt === null || data.DisAmt === "" ? 0 : data.DisAmt,
        ExciseId:
          data.ExciseId === null || data.ExciseId === "" ? 0 : data.ExciseId,
        ExcisePer:
          data.ExcisePer === null || data.ExcisePer === "" ? 0 : data.ExcisePer,
        TaxId:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? 0
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? data.TaxId
                : 0,
        GSTPer: data.GSTPer,
        SGSTId:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? 0
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? data.SGSTId
                : 0,
        SGSTPer:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? 0
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? data.SGSTPer
                : 0,
        IGSTId:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? data.IGSTId
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? 0
                : data.IGSTId,
        IGSTPer:
          sessionStorage.getItem("IGSTApplicable") === "Y" &&
            sessionStorage.getItem("RegisterType") === "SEZ"
            ? data.IGSTPer
            : sessionStorage.getItem("RegisterType") === "SEZ"
              ? 0
              : sessionStorage.getItem("QuotationStateCode") ===
                sessionStorage.getItem("CStateCode")
                ? 0
                : data.IGSTPer,
        Withimg: "N",
        MRP_Rate: 0,
        // Assessable_Flag:otherchargescollection.filter(data => ( data.Calculation_Of_GST === 'Y') ).length !=0 ?"Y":"N",
        // Assessable_Value:otherchargescollection.filter((data) => data.Calculation_Of_GST === 'Y').length !=0 ?
        // (((data.Rate * data.Quantity)-(data.DisAmt))*(data.OtherChargesAdd)/100)-(((data.Rate * data.Quantity)-(data.DisAmt))*(data.OtherChargesSub)/100):0          
      })

      const createdetail = await axios.instance
        .post(`/InsertQuoationDtl`, productdetail, {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        })
        .then(res => {
          setorderidarr([])

        })
    }
    setproductcollection([])
    setinvoiceupdate(true);
    setTimeout(() => {
      history.push("/Quotation")
    }, 500);
  }


  useLayoutEffect(() => {
    if (props.match.params.id1) {
      viewpage()
    }

  }, [])
  const viewpage = async () => {

    const InvoicePrint = await axios.instance
      .get(
        `/GetQuotationPrint/${props.match.params.id}/${sessionStorage.getItem(
          "Branch_Log"
        )}/${sessionStorage.getItem("Companyid")}/${sessionStorage.getItem(
          "WebCal"
        )}`,
        {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        }
      )
      .then(async res => {

      })

  }
  const InsertOtherCharges = async () => {
    for (const data of otherchargescollection) {
      const productdetail = Object.assign(data, {
        Quotation_Id: quotationid,
        LedgerId: data.LedgerId,
        Amount: data.Amount,
        OpType: "New",
        Type: data.Type,
        Percentage: data.Percentage,
        Calculation_Of_GST: data.Calculation_Of_GST,
        GST_Applicability: data.GST_Applicability,
        TaxPercentage: data.Tax == null ? 0 : data.Tax,
        HSNCode: data.HSNCode
      })

      const createdetail = await axios.instance
        .post(`/InsertOtherCharges`, productdetail, {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        })
        .then(res => { })
    }
    setotherchargescollection([])
  }

  const UpdateOtherCharges = async () => {
    for (const data of otherchargescollection) {
      const productdetail = Object.assign(data, {
        Quotation_Id: props.match.params.id,
        LedgerId: data.LedgerId,
        Amount: data.Amount,
        OpType: "Edit",
        Type: data.Type,
        Percentage: data.Percentage,
        Calculation_Of_GST: data.Calculation_Of_GST,
        GST_Applicability: data.GST_Applicability,
        TaxPercentage: data.Tax == null ? 0 : data.Tax,
        HSNCode: data.HSNCode
      })

      const createdetail = await axios.instance
        .post(`/InsertOtherCharges`, productdetail, {
          headers: {
            Authorization: tokent,
            "Content-Type": "application/json",
          },
        })
        .then(res => { })
    }
    setotherchargescollection([])
  }

  const Deleteinvoiceproduct = () => {
    const updatedData = productcollection.filter(
      (row, index) => index !== deletid
    )

    setproductcollection(updatedData)
    setDeleteModal(false)
    // NormalCalculation()
  }

  const Deleteothercharges = () => {
    const updatedData = otherchargescollection.filter(
      (row, index) => index !== deletid1
    )

    setotherchargescollection(updatedData)
    let dd = otherchargesData2.filter(
      item => parseInt(item.value) === parseInt(deletid2)
    )
    setotherchargesData([...otherchargesData, ...dd])
    setDeleteModal1(false)
  }
  // console.log(customerNameHelpData1,'customerNameHelpData1')
  const Edithdr = async () => {
    const get = await axios.instance
      .get(`/GetQuotationRetriveHdr/${props.match.params.id1 == 'QR' ? props.match.params.id : sessionStorage.getItem("quotationid")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        seteditdatahdr(res.data)
        // console.log(res.data,'editdatahdr')
        for (const data of res.data) {
          // console.log(data.customer_id,'customer_id')

          let date = data.quotation_date
          setquotationdate(
            moment(data.quotation_date, "DD/MM/YYYY").format("YYYY-MM-DD")
          )
          GetCustomerHelp(data.customer_id)

          setcustomerid(data.customer_id)
          setcustomerNameHelp({
            label: data.customer_name,
            value: data.customer_id,
          })
          setsalesmanhelp(
            data.salesman !== null
              ? { label: data.salesman, value: data.SalesMan_Id }
              : { label: "Select", value: "0" }
          )
          setdepartmenthelp(
            data.department.length !== 0
              ? { label: data.department, value: data.department }
              : { label: "Select", value: "" }
          )
          setbranchid(data.Cbranch_id === "" ? 0 : data.Cbranch_id)
          // setorderrefdate(moment(data.Order_Reference_Date).format('YYYY-MM-DD'))
          // setpaymode(data.PayMode)
          setremarks(data.remarks)
          // setinvoicetype(data.SalesInvoice)
          setcontactperson(
            data.comcontactperson.length === 0
              ? data.contactperson
              : data.comcontactperson
          )
          // setcontactperson1(data.contactperson)
          setcontactno(
            data.comcontactno.length === 0 ? data.contactno : data.comcontactno
          )
          setquotationno(data.quotation_no)
          setbillingaddress(data.Address1 + " " + data.Address2)
          setshippingaddress(
            data.Add1 === null
              ? data.Address1 + " " + data.Address2
              : data.Add1 + " " + data.Add2
          )

          // setpayrefno(data.Cust_PO_Ref)
          setbank(data.bank_id)
          setshipto(data.cusbranchname)
          setstate(data.PlaceofSupply)
          setstatecode(data.StateCode)
          setstateid(data.StateId)
          sessionStorage.setItem("IGSTApplicable", data.igstapplicable)
          sessionStorage.setItem("QuotationStateCode", data.StateCode)
          SetCustomerStatecode(data.StateCode)
          setroundoffstatus(data.Round_off_status)
          setshiptohelp(
            data.cusbranchname.length !== 0
              ? { label: data.cusbranchname, value: data.branch_id }
              : { label: "Select", value: "" }
          )

          if (data.Round_off_status === 'Y') {
            setroundoffstatus1(true)
          } else {
            setroundoffstatus1(false)
          }
          setpayterms(data.payment)
          setdeliveryterms(data.delivery)
          setdeliveryperiod(data.tax)
          setbilldiscount(parseFloat(data.billdisc))
          billdiscount1 = parseFloat(data.billdisc)
          Dutyamt = data.exciseamt
          status = data.Round_off_status
          GetShiptoHelp(data.customer_id)


          // .get(`/GetallCustomerHelp/${sessionStorage.getItem("Companyid")}`, {
          //   headers: { Authorization: tokent, "Content-Type": "application/json" },
          // })
          // .then(res => {
          //           let CustomerHelpArray =
          //                 res.data.filter(
          //                   item => item.customer_id == data.customer_id
          //                 )
          //               selectedCustomer(CustomerHelpArray)
          //               console.log(CustomerHelpArray,';CustomerHelpArray')    
          // })
        }
      })
  }

  const Editdtl = async () => {
    const get = await axios.instance
      .get(`/GetQuotationRetriveDtl/${props.match.params.id}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        // console.log(res.data,'editdatas')
        setproductcollection(res.data)
        for (const data of res.data) {
          setUOMType(
            data.Act_UOMDesc == data.SecondaryUOM ? "Secondary" : "Primary"
          )
        }

        // if (status === "Y") {
        //   setroundoffstatus1(true)
        //   let a = parseFloat(
        //     res.data.reduce((accumulator, object) => {
        //       return (
        //         accumulator +
        //         (object.Quantity * parseFloat(object.Rate) -
        //           (object.Quantity *
        //             parseFloat(object.Rate) *
        //             parseFloat(object.DisPer)) /
        //             100)
        //       )
        //     }, 0)
        //   )

        //   let b = parseFloat(
        //     res.data.reduce((accumulator, object) => {
        //       return (
        //         accumulator +
        //         ((object.Quantity * object.Rate -
        //           (object.Quantity * object.Rate * parseFloat(object.DisPer)) /
        //             100) *
        //           object.GSTPer) /
        //           100
        //       )
        //     }, 0)
        //   )

        //   let c =
        //     othertempcollection.length !== 0
        //       ? othertempcollection.reduce((accumulator, object) => {
        //           return accumulator + parseFloat(object.Amount)
        //         }, 0)
        //       : 0

        //   let d = res.data.reduce((accumulator, object) => {
        //     return (
        //       accumulator +
        //       ((object.Quantity * parseFloat(object.Rate) -
        //         (object.Quantity *
        //           parseFloat(object.Rate) *
        //           parseFloat(object.DisPer)) /
        //           100) *
        //         parseFloat(object.ExcisePer)) /
        //         100
        //     )
        //   }, 0)

        //   settotalamt(
        //     sessionStorage.getItem("IGSTApplicable") === "Y" &&
        //       sessionStorage.getItem("RegisterType") === "SEZ"
        //       ? Math.round(a + b - billdiscount1 + c + d)
        //       : sessionStorage.getItem("RegisterType") === "SEZ"
        //       ? Math.round(a - billdiscount1 + c + d)
        //       : sessionStorage.getItem("QuotationStateCode") ===
        //         sessionStorage.getItem("StateCode")
        //       ? Math.round(a + b - billdiscount1 + c + d)
        //       : Math.round(a + b - billdiscount1 + c + d)
        //   )
        // } else {
        //   let a = parseFloat(
        //     res.data.reduce((accumulator, object) => {
        //       return (
        //         accumulator +
        //         (object.Quantity * parseFloat(object.Rate) -
        //           (object.Quantity *
        //             parseFloat(object.Rate) *
        //             parseFloat(object.DisPer)) /
        //             100)
        //       )
        //     }, 0)
        //   )

        //   let b = parseFloat(
        //     res.data.reduce((accumulator, object) => {
        //       return (
        //         accumulator +
        //         ((object.Quantity * object.Rate -
        //           (object.Quantity * object.Rate * parseFloat(object.DisPer)) /
        //             100) *
        //           object.GSTPer) /
        //           100
        //       )
        //     }, 0)
        //   )

        //   let c =
        //     othertempcollection.length !== 0
        //       ? othertempcollection.reduce((accumulator, object) => {
        //           return accumulator + parseFloat(object.Amount)
        //         }, 0)
        //       : 0

        //   let d = res.data.reduce((accumulator, object) => {
        //     return (
        //       accumulator +
        //       ((object.Quantity * parseFloat(object.Rate) -
        //         (object.Quantity *
        //           parseFloat(object.Rate) *
        //           parseFloat(object.DisPer)) /
        //           100) *
        //         parseFloat(object.ExcisePer)) /
        //         100
        //     )
        //   }, 0)

        //   settotalamt(
        //     sessionStorage.getItem("IGSTApplicable") === "Y" &&
        //       sessionStorage.getItem("RegisterType") === "SEZ"
        //       ? a + b - billdiscount1 + c + d
        //       : sessionStorage.getItem("RegisterType") === "SEZ"
        //       ? a - billdiscount1 + c + d
        //       : sessionStorage.getItem("QuotationStateCode") ===
        //         sessionStorage.getItem("StateCode")
        //       ? a + b - billdiscount1 + c + d
        //       : a + b - billdiscount1 + c + d
        //   )
        // }
      })
  }

  const EditOC = async () => {
    const get = await axios.instance
      .get(`/GetOtherChargesData/${props.match.params.id1 == 'QR' ? props.match.params.id : sessionStorage.getItem("quotationid")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        othertempcollection = res.data
        setotherchargescollection(res.data)
        setotherchargescollection2(res.data)
      })
  }

  const GetPreviousPrice = async id => {
    const get = await axios.instance
      .get(`/GetPreviousPrice/${customerid}/${id}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        // console.log("GetPreviousPrice", res.data)
        setprevpricedata(res.data)
      })
  }

  const Getoneproducts = async producttaxid => {
    const get = await axios.instance
      .get(`/Getoneproducts/${producttaxid}/${sessionStorage.getItem("Companyid")}/${sessionStorage.getItem("Branch_Log")}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(async res => {
        for (const data of res.data) {
          const cgst = await axios.instance.get(
            `/Getalltaxpercentage/CGST/${data.CGSTPer}`,
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          const sgst = await axios.instance.get(
            `/Getalltaxpercentage/SGST/${data.SGSTPer}`,
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          const Igst = await axios.instance.get(
            `/Getalltaxpercentage/IGST/${data.VAT_Percentage}`,
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          // console.log(cgst,sgst,Igst)
          cgst1 = cgst.data.length !== 0 ? cgst.data.at(0).TaxId : 0
          sgst1 = sgst.data.length !== 0 ? sgst.data.at(0).TaxId : 0
          igst1 = Igst.data.length !== 0 ? Igst.data.at(0).TaxId : 0

          // setwarehouseblockedQty(data.block)
          // setwarehouseblockedSecondQty(data.Secondaryblock)
          // setWarehouseTotalQty(data.stock)
          // setConQty(data.ConQty)
          // setWarehouseTotalQtySecondQty(data.SecondaryStock)
          // setStockUOM(data.UOM_Description)
          // setUOMType("Secondary")
          // setSecondaryQtyUOM(data.SecondaryUOM)
          try {
            const get = await axios.instance
              .get(
                `/Getoneproductforbockandstock/${producttaxid}/${sessionStorage.getItem(
                  "Companyid"
                )}/${sessionStorage.getItem(
                  "Branch_Log")}`,
                {
                  headers: {
                    Authorization: tokent,
                    "Content-Type": "application/json",
                  },
                }
              )
              .then(async res => {
                // console.log(res.data, "Getoneproductforbockandstock")

                if (res.data.length != 0) {
                  setViewStockDetails(res.data.length > 0)
                  for (const data of res.data) {

                    setwarehouseblockedQty(data.block)
                    setwarehouseblockedSecondQty(data.Secondaryblock)
                    setWarehouseTotalQty(data.stock)
                    setConQty(data.ConQty)
                    setWarehouseTotalQtySecondQty(data.SecondaryStock)
                    setStockUOM(data.UOM_Description)
                    setUOMType("Secondary")
                    setSecondaryQtyUOM(data.SecondaryUOM)


                    // setwarehouseblockedQty(data.block)
                    // setwarehouseblockedSecondQty(data.Secondaryblock)
                    // setWarehouseTotalQty(data.stock)
                    // setConQty(data.ConQty)

                    // setWarehouseTotalQtySecondQty(data.SecondaryStock)
                    // setStockUOM(data.UOM_Description)
                    // setUOMType(data.UOMCheck)
                    // setSecondaryQtyUOM(data.SecondaryUOM)
                  }
                }

              })
          } catch (error) {
            setViewStockDetails(false)

            setwarehouseblockedQty(0)
            setwarehouseblockedSecondQty(0)
            setWarehouseTotalQty(0)
            setWarehouseTotalQtySecondQty(0)
            setStockUOM(0)
            setUOMType("Secondary")
            setSecondaryQtyUOM(0)
          }
        }
      })
  }

  const GetQCProduct = async id => {
    const qc = await axios.instance
      .get(`/GetQCProduct/${id}/${customerNameHelp.value}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        // console.log(res.data)
        if (res.data.length !== 0) {
          qcqty = res.data[0].Quantity
          qcrate = res.data[0].Rate
        }
      })
  }

  const SetProductDetail = data1 => {
    setsearchvalue("")
    //  console.log(data1,'oneproduct')
    const productcollection1 = []

    for (const data of data1) {
      Getoneproducts(data.product_details_id)
      GetQCProduct(data.product_details_id)
      setLabelUom(data.UOMCheck == 'Primary' ? data.uom_description : data.suom_description)
      setLabelTax(data.tax_percentage)
    }

    setTimeout(() => {
      // let cgst = {...CGstid}
      //

      for (const data of data1) {
        setQtyEnter(
          getproductquotation === true
            ? productfromQCFlag === "Y"
              ? data.quantity
              : ""
            : ""
        )
        setRateEnter(
          getproductquotation === true
            ? data.rate
            : (qcrate == "" || qcrate == undefined)
              ? data.sales_rate
              : qcrate
        )
        setDisEnter(getproductquotation === true ? data.disper : null)
        productcollection1.push({
          Product_Details_Description: data.product_details_description,
          Product_Details_Id: data.product_details_id,
          UOM_Id: data.uom_id,
          UOM_Description: data.uom_description,
          SecondaryUOM: data.suom_description,
          Snd_UOM: data.snd_uom,
          PHSNCode: data.phsncode,
          ItemCode: data.itemcode,
          Rate:
            getproductquotation === true
              ? data.rate
              : (qcrate == "" || qcrate == undefined)
                ? data.sales_rate
                : qcrate,
          RateinAED: 0,
          Quantity:
            getproductquotation === true
              ? productfromQCFlag === "Y"
                ? data.quantity
                : null
              : null,
          Vat_Percentage:
            sessionStorage.getItem("QuotationStateCode") ===
              sessionStorage.getItem("CStateCode")
              ? data.cgstper
              : 0,
          Amount: 0,
          OtherDesc: "",
          // UOMtype: 1,
          UOMtype: data.UOMCheck,
          ConQty: data.conqty,
          ConQtyCal: data.conqty,
          DisPer: getproductquotation === true ? data.disper : null,
          DisAmt: getproductquotation === true ? parseFloat(data.disamt) : null,
          ExcisePer: getproductquotation === true ? data.exciseper : null,
          ExciseId: getproductquotation === true ? data.exciseid : null,
          ImagePath: data.ImagePath,
          TaxId:
            sessionStorage.getItem("QuotationStateCode") ===
              sessionStorage.getItem("CStateCode")
              ? cgst1
              : 0,
          GSTPer: parseInt(data.tax_percentage),
          SGSTId:
            sessionStorage.getItem("QuotationStateCode") ===
              sessionStorage.getItem("CStateCode")
              ? sgst1
              : 0,
          SGSTPer:
            sessionStorage.getItem("QuotationStateCode") ===
              sessionStorage.getItem("CStateCode")
              ? data.sgstper
              : 0,
          IGSTId:
            sessionStorage.getItem("QuotationStateCode") ===
              sessionStorage.getItem("CStateCode")
              ? 0
              : igst1,
          IGSTPer:
            sessionStorage.getItem("QuotationStateCode") ===
              sessionStorage.getItem("CStateCode")
              ? 0
              : parseInt(data.tax_percentage),
          OtherChargesAdd: 0,
          OtherChargesSub: 0,
        })
      }
      setSingleArray(productcollection1)
      setViewStockDetails(productcollection1.length > 0)
      // console.log(productcollection1, "collection",qcrate)
      setproductionscollection2(
        productionscollection2.concat(productcollection1)
      )

      // setproductcollection(productcollection.concat(productcollection1))
      //setval({ label: "Select...", value: "" })
      // console.log(productcollection1)
    }, 700)
    // console.log(productcollection)
  }

  const toggle = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }

  // const handleKeyPress = event => {
  //   if (SingleArray.length != 0) {
  //     if (
  //       event.key === "Enter" ||
  //       event.keyCode === 13 ||
  //       event.key === "Tab" ||
  //       event.keyCode === 9
  //     ) {
  //       // setLabelTax("")
  //       // setLabelUom("")
  //       // setval({ label: "Select...", value: "" })
  //       const newInputValues = SingleArray.map((item, index) => {
  //         // console.log(SingleArray, "value")
  //         const updatedItem = {
  //           ...item,
  //           Quantity: QtyEnter,
  //           DisAmt: (parseInt(QtyEnter) * item.Rate * item.DisPer) / 100,
  //         }
  //         return updatedItem
  //       })
  //       // setproductcollection(productcollection.concat(newInputValues))
  //       // setQtyEnter("")
  //       // setSingleArray([])
  //       if (
  //         newInputValues[0].Quantity === "" ||
  //         newInputValues[0].Quantity == 0
  //       ) {
  //         setqtyerror(true)
  //         QtyRef.current.focus()
  //         QtyRef.current.select()
  //       } else {
  //         settempCollection(newInputValues)
  //         RateRef.current.focus()
  //         QtyRef.current.blur()
  //         event.preventDefault()
  //       }
  //     }
  //   }
  // }

  // const handleRatePress = event => {
  //   if (SingleArray.length != 0) {
  //     if (
  //       event.key === "Enter" ||
  //       event.keyCode === 13 ||
  //       event.key === "Tab" ||
  //       event.keyCode === 9
  //     ) {
  //       const newInputValues = tempCollection.map((item, index) => {
  //         console.log(SingleArray, "value")
  //         const updatedItem = {
  //           ...item,
  //           Rate: RateEnter,
  //           DisAmt: (item.Quantity * parseFloat(RateEnter) * item.DisPer) / 100,
  //         }
  //         return updatedItem
  //       })
  //       // setproductcollection(productcollection.concat(newInputValues))
  //       if (newInputValues[0].Rate === "" || newInputValues[0].Rate == 0) {
  //         setrateerror(true)
  //         RateRef.current.focus()
  //         RateRef.current.select()
  //       } else {
  //         settempCollection(newInputValues)
  //         DisRef.current.focus()
  //         RateRef.current.blur()
  //         event.preventDefault()
  //       }
  //     }
  //   }
  // }

  // const handleDisPress = event => {
  //   if (SingleArray.length != 0) {
  //     if (
  //       event.key === "Enter" ||
  //       event.keyCode === 13 ||
  //       event.key === "Tab" ||
  //       event.keyCode === 9
  //     ) {
  //       setLabelTax("")
  //       setLabelUom("")
  //       setval({ label: "Select...", value: "" })
  //       const newInputValues = tempCollection.map((item, index) => {
  //         console.log(SingleArray, "value")
  //         // if(DisEnter === ""){
  //         //   const updatedItem = {
  //         //     ...item,
  //         //     DisPer: null,
  //         //     DisAmt: (item.Quantity * item.Rate * null) / 100,
  //         //   }
  //         //   return updatedItem
  //         // } else {
  //         const updatedItem = {
  //           ...item,
  //           DisPer: DisEnter,
  //           DisAmt: (item.Quantity * parseFloat(item.Rate) * DisEnter) / 100,
  //         }
  //         return updatedItem
  //         // }
  //       })

  //       setproductcollection(productcollection.concat(newInputValues))
  //       console.log(newInputValues)
  //       setQtyEnter("")
  //       setRateEnter("")
  //       setDisEnter("")
  //       setSingleArray([])
  //       setOptions([])

  //       DisRef.current.blur()
  //       SelectProcuctRef.current.select.inputRef.focus()

  //       event.preventDefault()
  //       setpreviousprice(false)
  //                 setopenPrev(false)
  //     }
  //   }
  // }

  const handleKeyPress = event => {
    if (event.target.value >= 0) {
      if (SingleArray.length != 0) {
        // console.log(SingleArray,'SingleArrayQtyEnter')
        if (
          event.key === "Enter" ||
          event.keyCode === 13 ||
          event.key === "Tab" ||
          event.keyCode === 9
          // || event.keyCode === undefined
        ) {
          // setval({ label: "Select...", value: "" })
          const newInputValues = SingleArray.map((item, index) => {
            const updatedItem = {
              ...item,
              Quantity: QtyEnter,
              DisAmt: (parseInt(QtyEnter) * item.Rate * item.DisPer) / 100,
            }
            return updatedItem
          })
          // setproductcollection(productcollection.concat(newInputValues))
          // setQtyEnter("")
          // setSingleArray([])
          // setViewStockDetails(false)
          if (
            newInputValues[0].Quantity === "" ||
            newInputValues[0].Quantity <= 0
          ) {
            // setqtyerror(true)
            QtyRef.current.focus()
            QtyRef.current.select()
          } else {
            settempCollection(newInputValues)
            RateRef.current.focus()
            QtyRef.current.blur()
            event.preventDefault()
          }
        }
      }
    }
  }

  const handleRatePress = event => {
    if (event.target.value >= 0) {
      if (SingleArray.length != 0) {
        if (
          event.key === "Enter" ||
          event.keyCode === 13 ||
          event.key === "Tab" ||
          event.keyCode === 9
          // || event.keyCode === undefined
        ) {
          const newInputValues = tempCollection.map((item, index) => {
            // console.log(tempCollection, "value")
            const updatedItem = {
              ...item,
              Rate: RateEnter,
              DisAmt:
                (item.Quantity == ""
                  ? 0
                  : item.Quantity * parseFloat(RateEnter) * item.DisPer) / 100,
            }

            return updatedItem
          })
          // setproductcollection(productcollection.concat(newInputValues))
          if (newInputValues[0].Rate === "" || newInputValues[0].Rate <= 0) {
            // setrateerror(true)
            // console.log(newInputValues[0].Rate,'if')
            RateRef.current.focus()
            RateRef.current.select()
          } else {
            settempCollection(newInputValues)
            // console.log(newInputValues[0].Rate)
            DisRef.current.focus()
            RateRef.current.blur()
            event.preventDefault()
          }
        }
      }
    }
  }

  const handleDisPress = event => {
    if (SingleArray.length != 0) {
      if (
        event.key === "Enter" ||
        event.keyCode === 13 ||
        event.key === "Tab" ||
        event.keyCode === 9
        // ||
        // event.keyCode === undefined
      ) {
        if (
          (QtyEnter !== "" || QtyEnter > 0) &&
          (RateEnter != "" || RateEnter > 0)
        ) {
          const newInputValues = tempCollection.map((item, index) => {
            // console.log(SingleArray, "value")

            const updatedItem = {
              ...item,
              DisPer: DisEnter,
              DisAmt: (item.Quantity * parseFloat(item.Rate) * DisEnter) / 100,
            }
            return updatedItem
            // }
          })
          setproductcollection(productcollection.concat(newInputValues))
          // console.log(tempCollection)
          setpreviousprice(false)
          setQtyEnter("")
          setRateEnter("")
          setDisEnter("")
          setSingleArray([])
          setpreviouspriceShow(false)

          setOptions([])
          setViewStockDetails(false)
          setLabelTax("")
          setLabelUom("")
          setval({ label: "Select...", value: "" })

          // setopenPrev(false)
          DisRef.current.blur()
          SelectProcuctRef.current.select.inputRef.focus()

          event.preventDefault()
        } else {
          // console.log(QtyEnter, RateEnter, "Else Block")
          if (QtyEnter == 0 || QtyEnter == null || QtyEnter == "") {
            toastr.error("Please Enter Qty")
          }
          if (RateEnter == 0 || RateEnter == null || RateEnter == "") {
            toastr.error("Please Enter Rate")
          }
        }
      }
    }
  }

  const toggle1 = () => setModal1(!modal1)

  const toggle2 = () => setModal2(!modal2)

  const productToggle = () => setProductModal(!ProductModal)

  const toggledeletemodal = id => {
    // setDeleteModal(true)
    setdeletedconfirm(true);
    setdeletid(id)
  }

  const toggledeletemodal1 = (id, id2) => {
    setDeleteModal1(true)
    setdeletid1(id)
    setdeletid2(id2)
  }
  const EditCustomer = data1 => {
    // console.log(data1,'selectedcustomer')
    for (const data of data1) {
      SetCustomerStatecode(data.statecode)
      sessionStorage.setItem("QuotationStateCode", data.statecode)
      sessionStorage.setItem("RegisterType", data.registertype)
      sessionStorage.setItem("IGSTApplicable", data.IGSTApplicable)
      setcustomerNameHelp({
        label: data.customer_name,
        value: data.customer_id,
      })
      // setcontactno(data.phone)
      setbillingaddress(data.address1 + "," + data.address2)
      setshippingaddress(data.address1 + "," + data.address2)
      // setcontactperson(data.contact_person)
      setcontactperson1(data.contact_person)
      setcontactno1(data.phone)
      setcustomerid(data.customer_id)
      setstate(data.state)
      setstatecode(data.statecode)
      setstateid(data.stateid)
      setshipto("")
      GetShiptoHelp(data.customer_id)

      setgroupid(data.group_id)
    }
  }
  const selectedCustomer = data1 => {
    // console.log(data1,'selectedcustomer')
    for (const data of data1) {
      SetCustomerStatecode(data.statecode)
      sessionStorage.setItem("QuotationStateCode", data.statecode)
      sessionStorage.setItem("RegisterType", data.registertype)
      sessionStorage.setItem("IGSTApplicable", data.IGSTApplicable)
      setcustomerNameHelp({
        label: data.customer_name,
        value: data.customer_id,
      })
      setcontactno(data.phone)
      setbillingaddress(data.address1 + "," + data.address2)
      setshippingaddress(data.address1 + "," + data.address2)
      setcontactperson(data.contact_person)
      setcontactperson1(data.contact_person)
      setcontactno1(data.phone)
      setcustomerid(data.customer_id)
      setstate(data.state)
      setstatecode(data.statecode)
      setstateid(data.stateid)
      setshipto("")
      GetShiptoHelp(data.customer_id)

      setgroupid(data.group_id)
    }
  }

  const selectedCustomer1 = data1 => {
    // console.log(data1,"General Ledger")
    const otherchargescollection1 = []
    for (const data of data1) {
      otherchargescollection1.push({
        Ledger: data.customer_name,
        LedgerId: data.customer_id,
        Amount: 0,
        Type: "Addition",
        Percentage: 0,
        Calculation_Of_GST: data.Calculation_Of_GST,
        GroupId: data.group_id,
        UnderGroupId: data.BaseGrpId,
        GST_Applicability: data.GST_Applicability,
        Tax: data.Tax,
        GST_Applicability: data.GST_Applicability,
        Tax: data.Tax,
        HSNCode: data.HSNCode
      })
    }
    setotherchargescollection(
      otherchargescollection.concat(otherchargescollection1)
    )
    // console.log(otherchargescollection1)
  }

  // const selectedCustomer1 = data1 => {
  //   const otherchargescollection1 = []
  //   for (const data of data1) {
  //     otherchargescollection1.push({
  //       Ledger: data.customer_name,
  //       LedgerId: data.customer_id,
  //       Amount: 0,
  //     })
  //   }
  //   setotherchargescollection(
  //     otherchargescollection.concat(otherchargescollection1)
  //   )
  // }
  // console.log(shiptohelp.value,'shiptohelp.value')
  const selectedShipto = data1 => {
    for (const data of data1) {
      setshiptohelp({ label: data.branch_name, value: data.branch_id })
      setshipto(data.branch_name)
      setbranchid(data.branch_id)
      setshippingaddress(data.address1 + "," + data.address2)
      setcontactno(data.phone)
      setcontactperson(data.contact_person)
    }
  }

  // const handleShowDropdown = () => {
  //     setOverflow('inherit');
  // };

  // const handleHideDropdown = () => {
  //     setOverflow('auto');
  // };

  // const handleSelectChange = (event) => {
  // // Handle the change of the <select> tag here
  //
  // };
  const customFilter = (option, inputValue) => {
    console.log(option, 'option', inputValue, 'inputValue')
    if (inputValue) {
      // const reg1 = new RegExp(`^${inputValue.toLowerCase()}`)
      const reg2 = new RegExp(`^${inputValue.toLowerCase()}`)
      // const reg3 = new RegExp(`^${inputValue.toLowerCase()}`)
      // const reg4 = new RegExp(`^${inputValue.toLowerCase()}`)
      const reg5 = new RegExp(`^${inputValue.toLowerCase()}`)
      return (
        // reg1.test(option.data.Itemcode.toLowerCase()) ||
        reg2.test(option.data.label.toLowerCase()) ||
        // reg3.test(option.data.MouldNo.toLowerCase()) ||

        // reg4.test(option.data.SKU_Id.toLowerCase()) ||
        reg5.test(option.data.product_details_description.toLowerCase())
      )
    } else {
      return false
    }
  }

  const customFilter1 = (option, inputValue) => {
    if (inputValue) {
      const reg1 = new RegExp(`^${inputValue.toLowerCase()}`)
      const reg2 = new RegExp(`^${inputValue.toLowerCase()}`)
      const reg3 = new RegExp(`^${inputValue.toLowerCase()}`)
      const reg4 = new RegExp(`^${inputValue.toLowerCase()}`)
      const reg5 = new RegExp(`^${inputValue.toLowerCase()}`)
      const reg6 = new RegExp(`^${inputValue.toLowerCase()}`)
      const reg7 = new RegExp(`^${inputValue.toLowerCase()}`)
      return (
        // reg1.test(option.data.Itemcode.toLowerCase()) ||
        reg2.test(option.data.label.toLowerCase()) ||
        // reg3.test(option.data.MouldNo.toLowerCase()) ||
        // reg4.test(option.data.SKU_Id.toLowerCase()) ||
        reg5.test(option.data.product_details_description.toLowerCase()) ||
        reg6.test(option.data.quotation_no.toLowerCase()) ||
        reg7.test(option.data.quotation_date.toLowerCase())
      )
    } else {
      return false
    }
  }

  const Producthelp = useMemo(() => {
    return (
      <Select
        isClearable
        onInputChange={v => {
          if (v !== "" && v !== null) {
            if (customerNameHelp.value === "") {
              setcustomerpopup(true)
              setOptions([])
              return
            }
            loadOptions(v)
          } else {
            setViewStockDetails(false)
            setpreviouspriceShow(false)
            setOptions([{ label: "Type Something to Search...", value: "" }])
          }
        }}
        options={Options}
        menuHeight={50}
        filterOption={getproductquotation ? customFilter1 : customFilter}
        value={val}
        ref={SelectProcuctRef}
        classNamePrefix="select2-search-disable"
        onChange={value => {
          if (value !== null && value !== "") {
            console.log(value, 'value')
            setval(value)
            if (getproductquotation !== true) {
              let data = productdata.filter(
                item => item.product_details_id === value.value
              )
              console.log(data, 'Producthelp')

              SetProductDetail(data)
              GetPreviousPrice(data[0].product_details_id)
              setpreviouspriceShow(true)
              setprevpriceProductName(
                `${data[0].product_details_description} (HSN : ${data[0].phsncode})`
              )
              QtyRef.current.focus()
            } else {
              let data = productdata.filter(
                item =>
                  item.quotation_no == value.quotation_no &&
                  item.product_details_id === value.value
              )
              console.log(data, 'getfromquotation')
              QtyRef.current.focus()
              SetProductDetail(data)
              GetPreviousPrice(data[0].product_details_id)
              setpreviouspriceShow(true)
              setprevpriceProductName(
                `${data[0].product_details_description} (HSN : ${data[0].phsncode})`
              )
            }
          } else {
            setViewStockDetails(false)
            setpreviouspriceShow(false)
            setval({ label: "Select Product", value: "" })
          }
        }}
      />
    )
  }, [Options, val, customerNameHelp])

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "1px solid lightgrey",
      borderRadius: "4px",
      boxShadow: state.isFocused ? "0 0 0 2px #1a5599" : null,
      "&:hover": {
        border: "1px solid lightgrey",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#1a5599" : "white",
      color: state.isFocused ? "white" : "grey",
      "&:hover": {
        backgroundColor: "#1a5599",
        color: "white",
      },
    }),
  }

  let keys2 = ["itemcode", "product_details_description", "warrantyyears", "SKU_Id"]
  let keys3 = ["itemcode", "product_details_description", "warrantyyears", "SKU_Id", "quotation_no", "quotation_date", "rate"]

  const loadOptions = useCallback(

    inputValue => {
      // console.log(inputValue,'inputValue')
      let ProductArray
      //   if (getproductquotation) {
      //     ProductArray = productdata.filter(item => {
      //         return keys3.some(key => {
      //             const value = item[key]; // Get the value corresponding to the key
      //             if (value !== undefined && value !== null) {
      //                 return value.toString().toLowerCase().startsWith(inputValue.toLowerCase().trim());
      //             }
      //             return false;
      //         });
      //     });
      // }
      // ?previouscode 
      //    if(getproductquotation){
      //     ProductArray = productdata.filter(item => {
      //     return keys3.some(key =>
      //        // item[key].toString().match(/^[A-Za-z ]*$/).includes(inputValue),
      //       // item[key]
      //       //   .toString()
      //       //   .toLowerCase()
      //       //   .match(inputValue.toLowerCase())
      //       item[key].toString().toLowerCase().startsWith(inputValue.toLowerCase().trim())
      //     )
      //   })
      // }
      if (getproductquotation) {
        ProductArray = productdata.filter(item => {
          return keys3.some(key => {
            const value = item[key]; // Store the value first

            if (value && typeof value === "string") {
              return value.toLowerCase().startsWith(inputValue.toLowerCase().trim());
            }

            if (value && typeof value === "number") {
              return value.toString().toLowerCase().startsWith(inputValue.toLowerCase().trim());
            }

            return false; // Skip undefined or null values
          });
        });
      }
      // Previous fiolter
      // else {
      //    ProductArray = productdata.filter(item => {
      //     return keys2.some(key =>
      //        // item[key].toString().match(/^[A-Za-z ]*$/).includes(inputValue),
      //       // item[key]
      //       //   .toString()
      //       //   .toLowerCase()
      //       //   .match(inputValue.toLowerCase())
      //       item[key].toString().toLowerCase().startsWith(inputValue.toLowerCase().trim())
      //     )
      //   })
      // }
      else {
        ProductArray = productdata.filter(item => {
          return keys2.some(key => {
            const value = item[key]; // Get the value first

            if (value && typeof value === "string") {
              return value.toLowerCase().startsWith(inputValue.toLowerCase().trim());
            }

            if (value && typeof value === "number") {
              return value.toString().toLowerCase().startsWith(inputValue.toLowerCase().trim());
            }

            return false; // Skip undefined or null values
          });
        });
      }


      if (productcollection.length !== 0) {
        let removedata = productcollection.map(obj =>
          parseInt(obj.Product_Details_Id)
        )

        let filtereddata = ProductArray.filter(
          obj => !removedata.includes(parseInt(obj.product_details_id))
        )

        if (getproductquotation !== true) {
          const formattedOptions = filtereddata.map((item, index) => ({
            value: item.product_details_id,
            label: `${item.product_details_description}`,
            Itemcode: item.itemcode,
            MouldNo: item.warrantyyears,
            SKU_Id: item.SKU_Id,
            product_details_description: item.product_details_description
          }))
          // formattedOptions.unshift({ label: "Add Product....", value: "0",Itemcode:'0' })
          setOptions(formattedOptions)
        } else {
          const formattedOptions = filtereddata.map((item, index) => ({
            value: item.product_details_id,
            label: `${item.product_details_description} - ${item.quotation_no}${" - "}${item.quotation_date}${" - "}${item.rate}`,
            quotation_no: item.quotation_no,
            Itemcode: item.itemcode,
            MouldNo: item.warrantyyears,
            SKU_Id: item.SKU_Id,
            product_details_description: item.product_details_description,
            quotation_date: item.quotation_date


          }))
          // formattedOptions.unshift({ label: "Add Product....", value: "0",Itemcode:'0' })
          setOptions(formattedOptions)
        }
      } else {
        if (getproductquotation !== true) {
          const formattedOptions = ProductArray.map((item, index) => ({
            value: item.product_details_id,
            label: `${item.product_details_description}`,
            Itemcode: item.itemcode,
            MouldNo: item.warrantyyears,
            SKU_Id: item.SKU_Id,
            product_details_description: item.product_details_description
          }))
          // formattedOptions.unshift({ label: "Add Product....", value: "0",Itemcode:'0' })
          setOptions(formattedOptions)
        } else {
          const formattedOptions = ProductArray.map((item, index) => ({
            value: item.product_details_id,
            label: `${item.product_details_description} - ${item.quotation_no}${" - "}${item.quotation_date}${" - "}${item.rate}`,
            quotation_no: item.quotation_no,
            Itemcode: item.itemcode,
            MouldNo: item.warrantyyears,
            SKU_Id: item.SKU_Id,
            product_details_description: item.product_details_description,
            quotation_date: item.quotation_date

          }))
          // formattedOptions.unshift({ label: "Add Product....", value: "0",Itemcode:'0' })
          setOptions(formattedOptions)
        }
      }
    },
    [productdata, productcollection, Options]
  )

  const handleChange = checked => {
    setroundoffstatus1(checked)
    if (checked) {
      setroundoffstatus("Y")
      // setroundoffstatus1(false)
      let a = productcollection.reduce((accumulator, object) => {
        return (
          accumulator +
          // (object.Quantity * object.Rate -
          //   (object.Quantity * object.Rate * object.DisPer) / 100)

          (object.Rate * object.Quantity -
            object.DisAmt +
            ((object.Rate * object.Quantity - object.DisAmt) *
              object.OtherChargesAdd) /
            100 -
            ((object.Rate * object.Quantity - object.DisAmt) *
              object.OtherChargesSub) /
            100)
        )
      }, 0)

      // GST Amount
      let b = productcollection.reduce((accumulator, object) => {

        return (

          accumulator +
          ((object.Rate * object.Quantity -
            object.DisAmt +
            ((object.Rate * object.Quantity - object.DisAmt) *
              object.OtherChargesAdd) /
            100 -
            ((object.Rate * object.Quantity - object.DisAmt) *
              object.OtherChargesSub) /
            100) *
            object.GSTPer) /
          100
        )
      }, 0)

      let c = billdiscount !== null ? parseFloat(billdiscount) : 0

      let d = (parseFloat(
        otherchargescollection.length !== 0
          ? otherchargescollection.filter(data => (data.Calculation_Of_GST == "N" || data.GST_Applicability === 'Y') && (data.Type === "Addition")).reduce((accumulator, object) => {



            return accumulator + parseFloat(object.Amount)

          }, 0)
          : 0
      ) - parseFloat(
        otherchargescollection.length !== 0
          ? otherchargescollection.filter(data => (data.Calculation_Of_GST == "N" || data.GST_Applicability === 'Y') && (data.Type === "Deduction")).reduce((accumulator, object) => {



            return accumulator + parseFloat(object.Amount)

          }, 0)
          : 0
      )) + (otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')).reduce((accumulator, object) => {
        return (
          accumulator +
          (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)
        )
      }, 0) -
        otherchargescollection.filter((data) => (data.Type === 'Deduction') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')).reduce((accumulator, object) => {
          return (
            accumulator +
            (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)


          )
        }, 0))

      let e = productcollection.reduce((accumulator, object) => {
        return (
          accumulator +
          ((object.Quantity * object.Rate -
            (object.Quantity * object.Rate * object.DisPer) / 100) *
            object.ExcisePer) /
          100
        )
      }, 0)

      settotalamt(
        sessionStorage.getItem("IGSTApplicable") === "Y" &&
          sessionStorage.getItem("RegisterType") === "SEZ"
          ?
          // Math.round(a + b - c + d + e)
          Math.round(NetAmount)
          : sessionStorage.getItem("RegisterType") === "SEZ"
            ?
            // Math.round(a - c + d + e)
            Math.round(NetAmount)
            : sessionStorage.getItem("QuotationStateCode") ===
              sessionStorage.getItem("CStateCode")
              ?
              Math.round(NetAmount)
              : Math.round(NetAmount)
        // Math.round(a + b - c + d + e)
        // : Math.round(a + b - c + d + e)
      )

      // console.log(a,b,c,d,e)
      setroundoffamt(
        sessionStorage.getItem("IGSTApplicable") === "Y" &&
          sessionStorage.getItem("RegisterType") === "SEZ"
          ?
          Math.round(NetAmount) - (NetAmount)
          // Math.round(a + b - c + d + e) - (a + b - c + d + e)
          : sessionStorage.getItem("RegisterType") === "SEZ"
            ?
            Math.round(NetAmount) - (NetAmount)
            // Math.round(a - c + d + e) - (a - c + d + e)
            : sessionStorage.getItem("QuotationStateCode") ===
              sessionStorage.getItem("CStateCode")
              ?
              Math.round(NetAmount) - (NetAmount)
              // Math.round(a + b - c + d + e) - (a + b - c + d + e)
              :
              Math.round(NetAmount) - (NetAmount)
        // Math.round(a + b - c + d + e) - (a + b - c + d + e)
      )
    } else if (checked === false) {
      setroundoffstatus("N")
      // setroundoffstatus1(true)
      let a = productcollection.reduce((accumulator, object) => {
        return (
          accumulator +
          // (object.Quantity * object.Rate -
          //   (object.Quantity * object.Rate * object.DisPer) / 100)

          (object.Rate * object.Quantity -
            object.DisAmt +
            ((object.Rate * object.Quantity - object.DisAmt) *
              object.OtherChargesAdd) /
            100 -
            ((object.Rate * object.Quantity - object.DisAmt) *
              object.OtherChargesSub) /
            100)
        )
      }, 0)

      // GST Amount
      let b = productcollection.reduce((accumulator, object) => {

        return (

          accumulator +
          ((object.Rate * object.Quantity -
            object.DisAmt +
            ((object.Rate * object.Quantity - object.DisAmt) *
              object.OtherChargesAdd) /
            100 -
            ((object.Rate * object.Quantity - object.DisAmt) *
              object.OtherChargesSub) /
            100) *
            object.GSTPer) /
          100
        )
      }, 0)



      let c = billdiscount !== null ? parseFloat(billdiscount) : 0

      let d =
        (parseFloat(
          otherchargescollection.length !== 0
            ? otherchargescollection.filter(data => (data.Calculation_Of_GST == "N" || data.GST_Applicability === 'Y') && (data.Type === "Addition")).reduce((accumulator, object) => {



              return accumulator + parseFloat(object.Amount)

            }, 0)
            : 0
        ) - parseFloat(
          otherchargescollection.length !== 0
            ? otherchargescollection.filter(data => (data.Calculation_Of_GST == "N" || data.GST_Applicability === 'Y') && (data.Type === "Deduction")).reduce((accumulator, object) => {



              return accumulator + parseFloat(object.Amount)

            }, 0)
            : 0
        )) + (otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')).reduce((accumulator, object) => {
          return (
            accumulator +
            (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)
          )
        }, 0) -
          otherchargescollection.filter((data) => (data.Type === 'Deduction') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')).reduce((accumulator, object) => {
            return (
              accumulator +
              (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)


            )
          }, 0))

      let e = productcollection.reduce((accumulator, object) => {
        return (
          accumulator +
          ((object.Quantity * object.Rate -
            (object.Quantity * object.Rate * object.DisPer) / 100) *
            object.ExcisePer) /
          100
        )
      }, 0)

      settotalamt(
        sessionStorage.getItem("IGSTApplicable") === "Y" &&
          sessionStorage.getItem("RegisterType") === "SEZ"
          ?
          // a + b - c + d + e
          (NetAmount)
          : sessionStorage.getItem("RegisterType") === "SEZ"
            ?
            (NetAmount)
            // a - c + d + e
            : sessionStorage.getItem("QuotationStateCode") ===
              sessionStorage.getItem("CStateCode")
              ?
              (NetAmount)
              // a + b - c + d + e
              :
              (NetAmount)
        //  a + b - c + d + e
      )
      // console.log(a,b,c,d,e)
      // NormalCalculation()
    }
  }

  const handleChange1 = useCallback(
    async checked => {
      setgetproductquotation(checked)
      if (checked) {
        setdialogbox(true)
        const get = await axios.instance
          .get(
            `/GetProductFromQC/${sessionStorage.getItem(
              "Companyid"
            )}/${customerid}/${sessionStorage.getItem("Branch_Log")}/${1}`,
            {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            }
          )
          .then(res => {
            const data = res.data
            // console.log(res.data,'GetProductFromQC')
            if (productcollection.length !== 0) {
              let removedata = productcollection.map(obj =>
                parseInt(obj.Product_Details_Id)
              )
              let filtereddata = data.filter(
                obj => !removedata.includes(obj.product_details_id)
              )
              setproductdata(filtereddata)
            } else {
              setproductdata(data)
            }
            setdialogbox(false)
          })
      } else if (checked === false) {
        setproductdata(productdata1)
      }
    },
    [productdata, customerid, getproductquotation]
  )

  function productpreview(url) {
    setPopupimage(url)
    setopen(true)
  }

  const Closepopup = () => {
    setopen(false)
  }

  // const NormalCalculation = () => {
  //     console.log(productcollection,otherchargescollection,billdiscount)
  //     // Gross Amount
  //     let a= productcollection.reduce((accumulator, object,) => {
  //         return accumulator +((object.Quantity * object.Rate) - ((object.Quantity * object.Rate * object.DisPer)/100))  }, 0)

  //     // GST Amount
  //     let b= productcollection.reduce((accumulator, object,) => {
  //         return accumulator + ((((object.Quantity * object.Rate) - ((object.Quantity * object.Rate * object.DisPer)/100)) * object.GSTPer)/100) }, 0)

  //     // Sales Bill Amount
  //     let c = billdiscount.length !== 0 || billdiscount === null ? parseFloat(billdiscount) : 0

  //     // OtherCharges Amount
  //     let d = otherchargescollection.length !== 0 ? otherchargescollection.reduce((accumulator, object,) => {
  //         return accumulator + (parseFloat(object.Amount))  }, 0) : 0

  //     // Cess
  //     let e = productcollection.reduce((accumulator, object,) => {
  //         return accumulator +(((((object.Quantity * object.Rate) - ((object.Quantity * object.Rate * object.DisPer)/100)) * object.ExcisePer)/100))  }, 0)
  //        console.log(a,b,c,d,e)
  //     if(roundoffstatus == 'Y'){
  //         let tot = Math.round(a+b-c+d+e)
  //         settotalamt(oldtot => ([...oldtot, ...tot]))
  //     } else {
  //         let tot = a+b-c+d+e
  //         settotalamt(tot)
  //     }
  // }

  useEffect(() => {
    // console.log(productcollection,otherchargescollection,billdiscount,typeof billdiscount)
    // Gross Amount
    let a = productcollection.reduce((accumulator, object) => {
      return (
        accumulator +
        // (object.Quantity * object.Rate -
        //   (object.Quantity * object.Rate * object.DisPer) / 100)

        (object.Rate * object.Quantity -
          object.DisAmt +
          ((object.Rate * object.Quantity - object.DisAmt) *
            object.OtherChargesAdd) /
          100 -
          ((object.Rate * object.Quantity - object.DisAmt) *
            object.OtherChargesSub) /
          100)
      )
    }, 0)

    // GST Amount
    let b = productcollection.reduce((accumulator, object) => {

      return (

        accumulator +
        ((object.Rate * object.Quantity -
          object.DisAmt +
          ((object.Rate * object.Quantity - object.DisAmt) *
            object.OtherChargesAdd) /
          100 -
          ((object.Rate * object.Quantity - object.DisAmt) *
            object.OtherChargesSub) /
          100) *
          object.GSTPer) /
        100
      )
    }, 0)

    // Sales Bill Amount
    let c = billdiscount !== null ? billdiscount : 0

    // OtherCharges Amount
    let d =
      (parseFloat(
        otherchargescollection.length !== 0
          ? otherchargescollection.filter(data => (data.GST_Applicability === 'Y') && (data.Type === "Addition") && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.GroupId) === 14 || parseInt(data.GroupId) === 16 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15 || parseInt(data.UnderGroupId) === 14 || parseInt(data.UnderGroupId) === 16)).reduce((accumulator, object) => {



            return accumulator + parseFloat(object.Amount)

          }, 0)
          : 0
      ) - parseFloat(
        otherchargescollection.length !== 0
          ? otherchargescollection.filter(data => (data.GST_Applicability === 'Y') && (data.Type === "Deduction") && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.GroupId) === 14 || parseInt(data.GroupId) === 16 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15 || parseInt(data.UnderGroupId) === 14 || parseInt(data.UnderGroupId) === 16)).reduce((accumulator, object) => {



            return accumulator + parseFloat(object.Amount)

          }, 0)
          : 0
      )) + (otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
        return (
          accumulator +
          (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)
        )
      }, 0) -
        otherchargescollection.filter((data) => (data.Type === 'Deduction') && (data.GST_Applicability === 'Y') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
          return (
            accumulator +
            (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)


          )
        }, 0))

      +


      (parseFloat(
        otherchargescollection.length !== 0
          ? otherchargescollection.filter(data => (data.Calculation_Of_GST == "N" && data.GST_Applicability === 'N') && (data.Type === "Addition") && (parseInt(data.GroupId) != 13 || parseInt(data.GroupId) != 15 || parseInt(data.UnderGroupId) != 13 || parseInt(data.UnderGroupId) != 15)).reduce((accumulator, object) => {



            return accumulator + parseFloat(object.Amount)

          }, 0)
          : 0
      ) - parseFloat(
        otherchargescollection.length !== 0
          ? otherchargescollection.filter(data => (data.Calculation_Of_GST == "N" && data.GST_Applicability === 'N') && (data.Type === "Deduction") && (parseInt(data.GroupId) != 13 || parseInt(data.GroupId) != 15 || parseInt(data.UnderGroupId) != 13 || parseInt(data.UnderGroupId) != 15)).reduce((accumulator, object) => {



            return accumulator + parseFloat(object.Amount)

          }, 0)
          : 0
      ))
    //   otherchargescollection.filter(
    //     data => data.Calculation_Of_GST === "Y"
    //   ).length != 0
    //   ? numeral(
    //       productcollection.reduce(
    //         (accumulator, object) => {
    //           return (
    //             accumulator +
    //             ((object.Rate *
    //               object.Quantity -
    //               object.DisAmt +
    //               (
    //                 (object.Rate *
    //                 object.Quantity -
    //                 object.DisAmt) *
    //                 object.OtherChargesAdd) /
    //                 100 
    //                 -
    //               ((object.Rate *
    //                 object.Quantity -
    //                 object.DisAmt) *
    //                 object.OtherChargesSub) /
    //                 100) *
    //               object.GSTPer) /
    //               100
    //           )
    //         },
    //         0
    //       ) +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
    //         return (
    //           accumulator +
    //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
    //         )
    //       }, 0)-
    // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
    //         return (
    //           accumulator +
    //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


    //         )
    //       }, 0))
    //     ).format("0,0.00")
    //   : numeral(
    //       productcollection.reduce(
    //         (accumulator, object) => {
    //           return (
    //             accumulator +
    //             ((object.Quantity *
    //               object.Rate -
    //               (object.Quantity *
    //                 object.Rate *
    //                 object.DisPer) /
    //                 100) *
    //               object.GSTPer) /
    //               100
    //           )
    //         },
    //         0
    //       ) +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
    //         return (
    //           accumulator +
    //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
    //         )
    //       }, 0)-
    // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
    //         return (
    //           accumulator +
    //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


    //         )
    //       }, 0))
    //     ).format("0,0.00")

    // Cess
    let e = productcollection.reduce((accumulator, object) => {
      return (
        accumulator +
        ((object.Quantity * object.Rate -
          (object.Quantity * object.Rate * object.DisPer) / 100) *
          object.ExcisePer) /
        100
      )
    }, 0)
    // console.log(a,b,c,d,e,'Total')
    if (roundoffstatus == "Y") {
      // let tot = Math.round(a+b-c+d+e)
      // settotalamt(tot)

      sessionStorage.getItem("IGSTApplicable") === "Y" &&
        sessionStorage.getItem("RegisterType") === "SEZ"
        ?
        settotalamt(Math.round(NetAmount))
        // settotalamt(Math.round(a + b - c + d + e))
        : sessionStorage.getItem("RegisterType") === "SEZ"
          ?
          settotalamt(Math.round(NetAmount))
          // settotalamt(Math.round(a - c + d + e))
          : sessionStorage.getItem("QuotationStateCode") ===
            sessionStorage.getItem("CStateCode")
            ?
            settotalamt(Math.round(NetAmount))
            // settotalamt(Math.round(a + b - c + d + e))
            :
            settotalamt(Math.round(NetAmount))
      // settotalamt(Math.round(a + b - c + d + e))
    } else {
      // let tot = a+b-c+d+e
      // settotalamt(tot)

      sessionStorage.getItem("IGSTApplicable") === "Y" &&
        sessionStorage.getItem("RegisterType") === "SEZ"
        ?
        settotalamt(NetAmount)
        // settotalamt(a + b - c + d + e)
        : sessionStorage.getItem("RegisterType") === "SEZ"
          ?
          // settotalamt(a - c + d + e)
          settotalamt(NetAmount)
          : sessionStorage.getItem("QuotationStateCode") ===
            sessionStorage.getItem("CStateCode")
            ?
            settotalamt(NetAmount)
            // settotalamt(a + b - c + d + e)
            :
            settotalamt(NetAmount)
      // settotalamt(a + b - c + d + e)
    }
    // console.log(a , b , c , d , e)
    // console.log(a+b+d+e)
  }, [productcollection, otherchargescollection])

  return (
    <React.Fragment>
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={() => Deleteinvoiceproduct()}
        onCloseClick={() => setDeleteModal(false)}
      /> */}

      {/* <DeleteModal1
        show={deleteModal1}
        onDeleteClick={() => Deleteothercharges()}
        onCloseClick={() => setDeleteModal1(false)}
      /> */}

      <div
        className="page-content root1"
        style={{ backgroundColor: "#dee3e3" }}
      >

        {PrintPerview ?


          <Card>
            <CardBody>


              <div className=" d-flex   justify-content-end" style={{ paddingBottom: '20px' }}>

                {/* <Skeleton variant="circular" width={40} height={40} /> */}
                <IconButton aria-label="delete" color="error"
                  onClick={() => [
                    setPrintPerview(false)
                  ]}
                >


                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>

              <embed title="Quotation Print" style={{
                width: "100%",
                height: "200vh",
              }} src={axios.baseURL + `GetQuotation`} type="application/pdf"></embed>


            </CardBody>
          </Card>



          :
          <div className="container" style={{ maxWidth: "fit-content" }}>

            <Card className="m-0 p-0">
              <CardBody>


                <Row>

                  <Col>
                    <div>
                      {/* <Breadcrumbs
                      title="Quotation"
                      breadcrumbItem={`${
                        props.match.params.id ? (props.match.params.id && props.match.params.id1 )?'Preview Quotation'
                          : `Edit Quotation`
                          : `Add Quotation`
                      }`}
                    /> */}
                    </div>
                    <Divider style={{ marginBottom: 20 }} />
                    <Row>
                      <Col lg={3}>
                        <Row>
                          <Col lg={4} className="mb-2">
                            <label
                              className="input"
                              style={{ cursor: "not-allowed" }}
                            >
                              <input
                                className="input__field"
                                type="text"
                                placeholder=" "
                                value={quotationno}
                                onChange={e => setquotationno(e.target.value)}
                                disabled
                                style={{ cursor: "not-allowed" }}
                              />
                              <span
                                className="input__label"
                                style={{
                                  width: "-webkit-fill-available",
                                  cursor: "not-allowed",
                                }}
                              >
                                Quo No
                              </span>
                            </label>
                          </Col>
                          <Col lg={8} className="mb-2">
                            <label
                              className="input"
                              style={{ cursor: "not-allowed" }}
                            >
                              <input
                                className="input__field"
                                type="text"
                                placeholder=" "
                                value={contactno}
                                onChange={e => setcontactno(e.target.value)}
                                disabled
                                style={{ cursor: "not-allowed" }}
                              />
                              <span
                                className="input__label"
                                style={{ cursor: "not-allowed" }}
                              >
                                Contact No
                              </span>
                            </label>
                          </Col>
                          <Col lg={12} className="mb-2">
                            <label className="input">
                              <Select
                                options={customerNameHelpData}
                                classNamePrefix="select2-search-disable"
                                styles={customStyles}
                                ref={CustomerRef}
                                value={customerNameHelp}
                                onChange={value => {
                                  if (value.label == "Add Ledger....") {

                                    setcustomerNameHelp({
                                      label: "Select...",
                                      value: "",
                                    })
                                    setCustomerModal(true)

                                    setRandomCallbackCustomer((Math.floor(Math.random() * 90) + 10))
                                    setcustomerid("")
                                    // // setcontactperson("")
                                    // setcontactno("")
                                    // setbillingaddress("")
                                  } else {
                                    let CustomerHelpArray =
                                      customerNameHelpData1.filter(
                                        item => item.customer_id === value.value
                                      )
                                    // console.log(CustomerHelpArray)
                                    selectedCustomer(CustomerHelpArray)
                                    setshiptohelp({
                                      label: "Select",
                                      value: "",
                                    })

                                  }
                                }}
                              />
                              <span className="input__label1" style={{ top: -24 }}>
                                Customer Name <b className="text-danger">*</b>
                                {/* {customerNameHelp.value.length == 0 ? (
                                  <IconButton
                                    aria-label="add"
                                    color="success"
                                    size={"small"}
                                    onClick={() => {
                                      setCustomerModal(true)

                                      setRandomCallbackCustomer((Math.floor(Math.random() * 90) + 10))
                                    }}
                                  >
                                    <AddCircleOutlineIcon
                                      sx={{ fontSize: "15px" }}
                                    />
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    aria-label="add"
                                    color="warning"
                                    size={"small"}
                                    onClick={() => {
                                      setCustomerModal(true)

                                      setRandomCallbackCustomer((Math.floor(Math.random() * 90) + 10))
                                    }}
                                  >
                                    <EditIcon sx={{ fontSize: "15px" }} />
                                  </IconButton>
                                )} */}

                              </span>

                              {/* <span className="Astrix">*</span> */}
                            </label>
                          </Col>
                          <Col lg={12} className="mb-2">
                            <label className="input">
                              <Select
                                options={salesmanhelpData}
                                classNamePrefix="select2-search-disable"
                                styles={customStyles}
                                value={salesmanhelp}
                                onChange={value => {
                                  setsalesmanhelp({
                                    label: value.label,
                                    value: value.value,
                                  })
                                  //    console.log(value)
                                }}
                              />
                              <span className="input__label1">Sales Man</span>
                            </label>
                          </Col>
                          <Col lg={12} className="mb-2">
                            <div className="d-flex justify-content-between">
                              <p>Get Product from Quotation</p>
                              <Switch
                                onChange={handleChange1}
                                checked={getproductquotation}
                                width={40}
                                height={20}
                              />
                            </div>
                          </Col>

                          {/* <Col lg={12} className="mb-2">
                                                        <label className="input">
                                                            <textarea 
                                                                className="input__field" 
                                                                placeholder=" " 
                                                                rows={3} cols={50} 
                                                                style={{height:'75px'}}
                                                                value={billingaddress}
                                                                onChange={(e) => setbillingaddress(e.target.value)}
                                                                disabled
                                                            ></textarea>
                                                            <span className="input__label">Billing Address</span>
                                                        </label>
                                                    </Col> */}
                        </Row>
                      </Col>
                      <Col lg={3}>
                        <Row>
                          <Col
                            lg={12}
                            className="mb-2"
                            style={{ cursor: "not-allowed" }}
                          >
                            <label className="input">
                              <input
                                className="input__field"
                                type="text"
                                placeholder=" "
                                value={contactperson}
                                onChange={e => setcontactperson(e.target.value)}
                                disabled
                                style={{ cursor: "not-allowed" }}
                              />
                              <span
                                className="input__label"
                                style={{ cursor: "not-allowed" }}
                              >
                                Contact Person
                              </span>
                            </label>
                          </Col>
                          <Col lg={12} className="mb-2">
                            <label className="input">
                              <Select
                                isClearable
                                options={shiptoHelpData}
                                classNamePrefix="select2-search-disable"
                                styles={customStyles}
                                value={shiptohelp}
                                onChange={value => {
                                  if (value == null) {
                                    setshiptohelp({ label: 'Select Branch', value: '' })
                                    setbranchid('')
                                    setcontactperson(contactperson1)
                                    setcontactno(contactno1)
                                  }
                                  else {
                                    let CustomerHelpArray = shiptoHelpData1.filter(
                                      item => item.branch_id === value.value
                                    )

                                    selectedShipto(CustomerHelpArray)
                                  }
                                }}
                              />
                              <span className="input__label1">
                                Customer Branch
                              </span>
                            </label>
                          </Col>
                          <Col lg={12} className="mb-2">
                            <label className="input">
                              <Select
                                options={departmenthelpData}
                                classNamePrefix="select2-search-disable"
                                styles={customStyles}
                                value={departmenthelp}
                                onChange={value => {
                                  setdepartmenthelp({
                                    label: value.label,
                                    value: value.label,
                                  })
                                  // console.log(value)
                                }}
                              />
                              <span className="input__label1">Department</span>
                            </label>
                          </Col>
                          {/* <Col lg={12} className="mb-2">
                                                        <label className="input">
                                                            <textarea 
                                                                className="input__field" 
                                                                placeholder=" " 
                                                                rows={3} cols={50} 
                                                                style={{height:'75px'}}
                                                                value={shippingaddress}
                                                                onChange={(e) => setshippingaddress(e.target.value)}
                                                                disabled
                                                            ></textarea>
                                                            <span className="input__label">Shipping Address</span>
                                                        </label>
                                                    </Col> */}
                        </Row>
                      </Col>
                      <Col lg={2}>
                        <Row>
                          <Col lg={12} className="mb-2">
                            <label className="input">
                              <input
                                className="input__field"
                                type="text"
                                placeholder=" "
                                value={currency}
                                onChange={e => setcurrency(e.target.value)}
                                disabled
                              />
                              <span className="input__label">Currency</span>
                            </label>
                          </Col>
                          <Col lg={12} className="mb-2">
                            <label className="input">
                              <input
                                className="input__field"
                                type="text"
                                placeholder=" "
                                value={payterms}
                                onChange={e => setpayterms(e.target.value)}
                              />
                              <span className="input__label">Pay Terms</span>
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={2}>
                        <Row>
                          <Col lg={12} className="mb-2">
                            <label className="input">
                              <select
                                className="input__field"
                                value={bank}
                                onChange={e => {
                                  setbank(e.target.value)
                                }}
                                id="bank"
                              >
                                {options2.map(option => (
                                  <option key={option.value} value={option.value}>
                                    {option.text}
                                  </option>
                                ))}
                              </select>
                              <span className="input__label">Bank</span>
                            </label>
                          </Col>
                          <Col lg={12} className="mb-2">
                            <label className="input">
                              <input
                                className="input__field"
                                type="date"
                                placeholder=" "
                                value={quotationdate}
                                min={"1000-01-01"}
                                max={"9999-12-31"}
                                onChange={e => {
                                  if (e.target.value) {
                                    setquotationdate(e.target.value)
                                  } else {
                                    // toastr.error("Invalid Date")
                                  }
                                }}
                              />
                              <span className="input__label">Quotation Date</span>
                            </label>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={2}>
                        <Row>
                          <Col lg={12} className="mb-2">
                            <label className="input">
                              <input
                                className="input__field"
                                type="text"
                                placeholder=" "
                                value={deliveryterms}
                                onChange={e => setdeliveryterms(e.target.value)}
                              />
                              <span className="input__label">Delivery Terms</span>
                            </label>
                          </Col>
                          <Col lg={12} className="mb-2">
                            <label className="input">
                              <input
                                className="input__field"
                                type="text"
                                placeholder=" "
                                value={deliveryperiod}
                                onChange={e => setdeliveryperiod(e.target.value)}
                              />
                              <span className="input__label">
                                Delivery Period
                              </span>
                            </label>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Divider style={{margin:'10px'}}>
                  <Chip label="Quotation Details" color="info" size="small" />
                </Divider>
                {!props.match.params.id1 && <Row className="mb-2 mt-5 ">
                  <Col lg={{ size: 4 }}>
                    <label className="input">
                      {Producthelp}
                      <span className="input__label1" style={{ top: "-29px" }}>
                        Search Products <b className="text-danger">*</b>{" "}
                        {/* {val.value == null || val.value == "" ? (
                          <IconButton
                            aria-label="add"
                            color="success"
                            size={"small"}
                            onClick={() => {
                              setProductModal(true)
                              setRandomCallback((Math.floor(Math.random() * 90) + 10))
                              setEditProduct(false)
                            }}
                          >
                            <AddCircleOutlineIcon sx={{ fontSize: "15px" }} />
                          </IconButton>
                        ) : (
                          <IconButton
                            aria-label="add"
                            color="warning"
                            size={"small"}
                            onClick={() => {
                              setProductModal(true)
                              setRandomCallback((Math.floor(Math.random() * 90) + 10))
                              setEditProduct(true)
                            }}
                          >
                            <EditIcon sx={{ fontSize: "15px" }} />
                          </IconButton>
                        )} */}
                      </span>
                    </label>
                  </Col>
                  <Col lg={2} className="mb-2">
                    {/* <TextField
                    // id="Quantity"
                    ref={QtyRef}
                    variant="outlined"
                    type="number"
                    label="Quantity"
                    placeholder="0.00"
                    size="small"
                    value={QtyEnter}
                    onKeyPress={handleKeyPress}
                    onChange={e => {
                      setQtyEnter(e.target.value)
                    }}
                  /> */}

                    <label className="input">
                      <input
                        style={{ height: "40px", cursor: "text" }}
                        className="input__field"
                        ref={QtyRef}
                        placeholder="0.00"
                        type="number"
                        value={QtyEnter}
                        // onKeyUp={handleKeyPress}
                        onKeyPress={handleKeyPress}
                        // onBlur={handleKeyPress}
                        // onKeyDown={handleKeyPress}
                        onChange={e => {
                          if (e.target.value >= 0) {
                            setQtyEnter(e.target.value)
                          }
                        }}
                        onFocus={e => {
                          e.target.select()
                        }}
                      />
                      <span className="input__label">Quantity</span>
                    </label>
                  </Col>
                  <Col lg={2} className="mb-2">
                    <label className="input">
                      <input
                        style={{ height: "40px", cursor: "text" }}
                        className="input__field"
                        ref={RateRef}
                        placeholder="0.00"
                        type="number"
                        value={RateEnter}
                        // onKeyUp={handleRatePress}
                        onKeyPress={handleRatePress}
                        // onBlur={handleRatePress}
                        // onKeyDown={handleRatePress}
                        onChange={e => {
                          if (e.target.value >= 0) {
                            setRateEnter(e.target.value)
                          }
                        }}
                        onFocus={e => {
                          e.target.select()
                        }}
                      />
                      <span className="input__label">Rate</span>
                    </label>
                  </Col>
                  <Col lg={2} className="mb-2">
                    <label className="input">
                      <input
                        style={{ height: "40px", cursor: "text" }}
                        className="input__field"
                        ref={DisRef}
                        placeholder="0.00"
                        type="number"
                        value={DisEnter}
                        // onKeyUp={handleDisPress}
                        onKeyPress={handleDisPress}
                        // onBlur={handleDisPress}
                        // onKeyDown={handleDisPress}
                        min={0}
                        onChange={e => {
                          if (e.target.value >= 0) {
                            setDisEnter(e.target.value)
                          }
                        }}
                        onFocus={e => {
                          e.target.select()
                        }}
                      />
                      <span className="input__label">{"Discount(%)"}</span>
                    </label>
                  </Col>
                  {SingleArray.length != 0 && (
                    <Col lg={1} className="mb-2">
                      <label className="input">
                        <input
                          disabled
                          style={{ height: "40px" }}
                          className="input__field"
                          placeholder="0.00"
                          type="text"
                          value={LabelUom}
                        />
                        <span className="input__label">UOM </span>
                      </label>
                    </Col>
                  )}
                  {SingleArray.length != 0 && (
                    <Col lg={1} className="mb-2">
                      <label className="input">
                        <input
                          style={{ height: "40px" }}
                          className="input__field"
                          disabled
                          placeholder="0.00"
                          type="text"
                          value={`${LabelTax} %`}
                        />
                        <span className="input__label"> {"GST"} </span>
                      </label>
                    </Col>
                  )}
                </Row>}

                {/* {ControlcenterScreenStock ? (
                sessionStorage.getItem("quotation") == "Y" ? (
                  ViewStockDetails ? (
                    <StockQtyDesing
                      Uom={StockUOM}
                      SecUom={SecondaryQtyUOM}
                      Stock={WarehouseTotalQty}
                      SecStock={WarehouseTotalQtySecondQty}
                      Blocked={warehouseblockedQty}
                      SecBlocked={warehouseblockedSecondQty}
                      ProductId={val.value}
                      ConQty={ConQty}
                    />
                  ) : null
                ) : null
              ) : null} */}
                <Row>
                  <Col lg={12}>
                    {/* {previouspriceShow && (
                    <div className="my-2">
                      <div
                        style={{ marginBottom: "8px", fontWeight: "bold" }}
                        className="d-flex justify-content-between align-items-center gap-2"
                      >
                        <p style={{ marginRight: "10px" }}>
                          {`Previous Price for `}{" "}
                          <Typography variant="button" color="blue">
                            {prevpriceProductName}
                          </Typography>
                        </p>
                        <IconButton
                          aria-label="close"
                          onClick={() => {
                            setpreviousprice(false)
                            setopenPrev(false)
                          }}
                        >
                          <CloseIcon />
                        </IconButton>

                      </div>
                      <Zoom in={true}>
                        <Paper sx={{ p: 4, borderRadius: 5 }} elevation={2}>
                          {prevpricedata.length > 0 ? (
                            <>
                              <Table2 size="small">
                                <TableHead2>
                                  <TableRow2
                                    style={{ backgroundColor: "#F6D776" }}
                                  >
                                    <TableCell2>Bill No</TableCell2>
                                    <TableCell2>Bill Date</TableCell2>
                                    <TableCell2>Quantity</TableCell2>
                                    <TableCell2>UOM</TableCell2>
                                    <TableCell2>Price</TableCell2>
                                    <TableCell2>Discount (%)</TableCell2>
                                  </TableRow2>
                                </TableHead2>
                                <TableBody2>
                                  {prevpricedata.map((item, index) => {
                                    const [
                                      salesBillNo,
                                      salesBillDate,
                                      quantity,
                                      unit,
                                      price,
                                      discount,
                                    ] =
                                      item.SALESBILLDETAILSGETPREVIOUSDETALAS.split(
                                        "--"
                                      )
                                    return (
                                      <TableRow2 key={index}>
                                        <TableCell2>{salesBillNo}</TableCell2>
                                        <TableCell2>{salesBillDate}</TableCell2>
                                        <TableCell2>{quantity}</TableCell2>
                                        <TableCell2>{unit}</TableCell2>
                                        <TableCell2>{price}</TableCell2>
                                        <TableCell2>{discount}</TableCell2>
                                      </TableRow2>
                                    )
                                  })}
                                </TableBody2>
                              </Table2>
                            </>
                          ) : (
                            <>
                              <Typography
                                variant="subtitle2"
                                color="#FE7A36"
                                sx={{ m: 1, p: 2 }}
                              >
                                No Previous Price Record found
                              </Typography>
                            </>
                          )}
                        </Paper>
                      </Zoom>
                      <Divider style={{ marginBottom: 15 }} />
                    </div>
                  )} */}
                    {previouspriceShow && (
                      <div className="my-2">
                        <div
                          style={{ marginBottom: "8px", fontWeight: "bold" }}
                          className="d-flex justify-content-between align-items-center gap-2 m-2"
                        >
                          <p style={{ marginRight: "10px" }}>
                            {`Previous Price for `}{" "}
                            <Typography variant="button" color="blue">
                              {prevpriceProductName}
                            </Typography>
                          </p>
                          <IconButton
                            aria-label="close"
                            onClick={() => {
                              setpreviouspriceShow(false)
                              setopenPrev(false)
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </div>
                        <Zoom in={true}>
                          <Paper elevation={2}>
                            {prevpricedata.length > 0 ? (
                              <>
                                <Table2 size="small">
                                  <TableHead2>
                                    <TableRow2
                                      style={{ backgroundColor: "#F6D776" }}
                                    >
                                      <TableCell2>Bill No</TableCell2>
                                      <TableCell2>Bill Date</TableCell2>
                                      <TableCell2>Quantity</TableCell2>
                                      <TableCell2>UOM</TableCell2>
                                      <TableCell2>Price</TableCell2>
                                      <TableCell2>Discount (%)</TableCell2>
                                    </TableRow2>
                                  </TableHead2>
                                  <TableBody2>
                                    {prevpricedata.map((item, index) => {
                                      const [
                                        salesBillNo,
                                        salesBillDate,
                                        quantity,
                                        unit,
                                        price,
                                        discount,
                                      ] =
                                        item.SALESBILLDETAILSGETPREVIOUSDETALAS.split(
                                          "--"
                                        )
                                      return (
                                        <TableRow2 key={index}>
                                          <TableCell2>{salesBillNo}</TableCell2>
                                          <TableCell2>
                                            {salesBillDate}
                                          </TableCell2>
                                          <TableCell2>{quantity}</TableCell2>
                                          <TableCell2>{unit}</TableCell2>
                                          <TableCell2>{price}</TableCell2>
                                          <TableCell2>{discount}</TableCell2>
                                        </TableRow2>
                                      )
                                    })}
                                  </TableBody2>
                                </Table2>
                              </>
                            ) : (
                              <>
                                <Typography
                                  variant="subtitle2"
                                  color="#FE7A36"
                                  sx={{ m: 1, p: 2 }}
                                >
                                  No Previous Price Record found
                                </Typography>
                              </>
                            )}
                          </Paper>
                        </Zoom>
                        <Divider style={{ marginBottom: 15 }} />
                      </div>
                    )}
                  </Col>
                </Row>

                <div style={{ marginBottom: "25px" }}>
                  <Table
                    bordered
                    hover
                    responsive
                    style={{
                      width: "100%",
                      border: "1px solid white",
                      fontSize: "13px",
                    }}
                  >
                    <thead style={{ border: "1px solid white" }}>
                      <tr
                        style={{
                          backgroundColor: "#2D9596",
                          border: "1px solid white",
                        }}
                      >
                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          SNo
                        </th>
                        {/* <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            maxWidth: "30px",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          SKU Id
                        </th> */}
                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            whiteSpace: "nowrap",
                            minWidth: "300px",
                          }}
                          rowSpan={2}
                          colSpan={2}
                          className="text-center"
                        >
                          Product Description
                        </th>

                        {/* <th
                        style={{
                          padding: "3px",
                          backgroundColor: "#3876BF",
                          color: "white",
                          whiteSpace: "nowrap",
                        }}
                        rowSpan={2}
                        className="text-center"
                      >
                        Other Description
                      </th> */}
                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          Image
                        </th>
                        {/* <th
                        style={{
                          padding: "3px",
                          backgroundColor: "#3876BF",
                          color: "white",
                        }}
                        rowSpan={2}
                        className="text-center"
                      >
                        HSN
                      </th> */}
                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            maxWidth: "30px",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          QTY / UOM
                        </th>
                        {/* <th
                        style={{
                          padding: "3px",
                          backgroundColor: "#3876BF",
                          color: "white",
                        }}
                        rowSpan={2}
                        className="text-center"
                      >
                        UOM
                      </th> */}
                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            maxWidth: "100px",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          Rate
                        </th>

                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            minWidth: "70px",
                          }}
                          className="text-center"
                        >
                          {"Discount(%)"}
                        </th>
                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            minWidth: "80px",
                          }}
                          className="text-center"
                        >
                          {"Tax(%)"}
                        </th>
                        {/* <th
                        style={{
                          padding: "3px",
                          backgroundColor: "#3876BF",
                          color: "white",
                          minWidth: "70px",
                        }}
                        className="text-center"
                      >
                        {"Cess(%)"}
                      </th> */}
                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                            minWidth: "100px",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          Amount
                        </th>
                        <th
                          style={{
                            padding: "3px",
                            backgroundColor: "#3876BF",
                            color: "white",
                          }}
                          rowSpan={2}
                          className="text-center"
                        >
                          Action
                        </th>
                      </tr>
                      {/* <tr style={{ backgroundColor: "#3876BF" }}>
                      <th
                        style={{
                          padding: "3px",
                          backgroundColor: "#3876BF",
                          color: "white",
                        }}
                        className="text-center"
                      >
                        %
                      </th>
                      <th
                        style={{
                          padding: "3px",
                          backgroundColor: "#3876BF",
                          color: "white",
                        }}
                        className="text-center"
                      >
                        Amount
                      </th>
                      <th
                        style={{
                          padding: "3px",
                          backgroundColor: "#3876BF",
                          color: "white",
                        }}
                        className="text-center"
                      >
                        %
                      </th>
                      <th
                        style={{
                          padding: "3px",
                          backgroundColor: "#3876BF",
                          color: "white",
                        }}
                        className="text-center"
                      >
                        Amount
                      </th>
                      <th
                        style={{
                          padding: "3px",
                          backgroundColor: "#3876BF",
                          color: "white",
                        }}
                        className="text-center"
                      >
                        %
                      </th>
                      <th
                        style={{
                          padding: "3px",
                          backgroundColor: "#3876BF",
                          color: "white",
                        }}
                        className="text-center"
                      >
                        Amount
                      </th>
                    </tr> */}
                    </thead>
                    <tbody style={{ border: "1px solid rgb(169 169 169 / 14%)" }}>
                      <React.Fragment>
                        {productcollection.map((item, index) => (
                          <tr key={index} style={{ backgroundColor: "white" }}>
                            <td style={{ backgroundColor: "white" }}>
                              {index + 1}
                            </td>
                            {/* <td style={{ backgroundColor: "white" }}>
                              {item.ItemCode}
                            </td> */}

                            <td
                              colSpan={2}
                              style={{
                                backgroundColor: "white",
                                minWidth: "300px",
                              }}
                            >
                              <Stack
                                direction={"column"}
                                justifyContent={"start"}
                              >
                                <Typography variant="body2" color="initial">
                                  {item.Product_Details_Description}
                                </Typography>

                                <TextField
                                  id="outlined-multiline-flexible"
                                  label="Other Description"
                                  //   variant="outlined"
                                  size="small"
                                  multiline
                                  maxRows={4}
                                  value={item.OtherDesc}
                                  onChange={e => {
                                    const newInputValues = [...productcollection]
                                    newInputValues[index].OtherDesc =
                                      e.target.value
                                    setproductcollection(newInputValues)
                                  }}
                                />
                                {/* <div className="d-flex">
                                  <Typography
                                    variant="caption"
                                    color="#28ABB9"
                                    textAlign={"left"}
                                    fontWeight={"bolder"}
                                    sx={{ paddingRight: "2px" }}
                                  >
                                    <span style={{ fontSize: "small" }}>
                                      HSN : {item.PHSNCode}
                                    </span>
                                  </Typography>
                                  <Typography
                                    className="mx-5"
                                    variant="caption"
                                    color="#28ABB9"
                                    textAlign={"left"}
                                    fontWeight={"bolder"}
                                    sx={{ paddingRight: "2px" }}
                                  >
                                    <span style={{ fontSize: "small" }}>
                                      Package : {"(1x" + (!props.match.params.id ? item.ConQty : item.ConQtyCal) + ")"}
                                    </span>
                                  </Typography>
                                </div> */}
                              </Stack>
                            </td>

                            {/* <td >                           */}

                            {/* <input
                              type="text"
                              style={{
                                width: "100%",
                                border: "1px solid  #3876BF",
                                borderRadius: 2,
                              }}
                              className="inputText"
                              value={item.OtherDesc}
                              onChange={e => {
                                const newInputValues = [...productcollection]
                                newInputValues[index].OtherDesc = e.target.value
                                setproductcollection(newInputValues)
                              }}
                              dir="rtl"
                            /> */}
                            {/* </td> */}
                            <td style={{ maxWidth: "18%" }}>
                              <Link to="#" className="text-body">
                                {item.Imagepath != "" ? (
                                  <img
                                    src={`${axios.baseURL + 'ProductImages'}/${item.ImagePath}`}
                                    width="30px"
                                    height="30px"
                                    style={{ objectFit: "contain" }}
                                    onClick={() =>
                                      productpreview(
                                        `${axios.baseURL + 'ProductImages'}/${item.ImagePath}`
                                      )
                                    }
                                  />
                                ) : (
                                  <p style={{ whiteSpace: "nowrap" }}>No Image</p>
                                )}
                              </Link>
                            </td>

                            {/* <td>{item.PHSNCode}</td> */}

                            <td>
                              <Stack
                                direction={"column"}
                                justifyContent={"start"}
                              >
                                <div style={{ textAlign: "right" }}>
                                  <input
                                    type="number"
                                    className="inputText"
                                    value={item.Quantity}
                                    min={0}
                                    style={{
                                      minWidth: "50px",
                                      border: "1px solid white",
                                      borderRadius: 2,
                                      outline: "none",
                                      textAlign: "right",
                                      transition: "border-color 0.3s ease",
                                    }}
                                    onFocus={e => {
                                      e.target.style.borderColor = "#66afe9"
                                      e.target.select()
                                    }}
                                    onBlur={e => {
                                      e.target.style.borderColor = "white"
                                    }}
                                    onChange={e => {
                                      if (e.target.value >= 0) {


                                        const newInputValues = [
                                          ...productcollection,
                                        ]
                                        newInputValues[index].Quantity =
                                          e.target.value
                                        newInputValues[index].DisAmt =
                                          (parseInt(item.Quantity) *
                                            parseFloat(item.Rate) *
                                            item.DisPer) /
                                          100
                                        setproductcollection(newInputValues)
                                        // console.log(productcollection)
                                        const newdata = [...otherchargescollection]
                                        const data = newdata.map(d => ({
                                          ...d,
                                          Amount: Number(d.Percentage) > 0 ? (productcollection.reduce((accumulator, object) => {
                                            return accumulator + object.Rate * object.Quantity - object.DisAmt
                                          }, 0) * parseFloat(d.Percentage / 100)).toFixed(2) : d.Amount
                                        }))
                                        setotherchargescollection(data)
                                      }

                                      if (e.target.value === "") {


                                        const newInputValues = [
                                          ...productcollection,
                                        ]
                                        newInputValues[index].Quantity =
                                          0
                                        newInputValues[index].DisAmt =
                                          (parseInt(item.Quantity) *
                                            parseFloat(item.Rate) *
                                            item.DisPer) /
                                          100
                                        setproductcollection(newInputValues)
                                        // console.log(productcollection)
                                        const newdata = [...otherchargescollection]
                                        const data = newdata.map(d => ({
                                          ...d,
                                          Amount: Number(d.Percentage) > 0 ? (productcollection.reduce((accumulator, object) => {
                                            return accumulator + object.Rate * object.Quantity - object.DisAmt
                                          }, 0) * parseFloat(d.Percentage / 100)).toFixed(2) : d.Amount
                                        }))
                                        setotherchargescollection(data)
                                      }
                                      // NormalCalculation()
                                    }}
                                  />
                                  {/* <Tooltip title="check more">
                                    <CheckCircleIcon
                                      className={`text-success font-size-18`}
                                      style={{
                                        marginLeft: "3px",
                                        cursor: "pointer",
                                      }}
                                    // onClick={() => {
                                    //   // console.log(item, "coll")
                                    //   setvalidBlockedQty(
                                    //     item.Quantity
                                    //   )
                                    //   setProductName(item.Product_Details_Description)


                                    //   toggleblock(
                                    //     item.Product_Details_Id
                                    //   )
                                    // }}
                                    />
                                  </Tooltip> */}


                                </div>
                                <Typography
                                  variant="caption"
                                  color="#539165"
                                  textAlign={"right"}
                                  fontWeight={"bolder"}
                                  sx={{ paddingRight: "2px" }}
                                  onClick={() => {
                                    setmodalUom(true)
                                    setIndexforUom(item.Product_Details_Id)
                                  }}
                                >
                                  {item.UOMCheck == "Primary"
                                    ? item.UOM_Description
                                    : item.SecondaryUOM}{" "}
                                </Typography>
                                {/* <div className="react-datepicker__day--selected ms-3 text-end">
                                  <p className="mx-1">{item.UOMCheck === 'Primary' ? ((item.Quantity * (!props.match.params.id ? item.ConQty : item.ConQtyCal)))
                                    : (numeral(item.Quantity / (!props.match.params.id ? item.ConQty : item.ConQtyCal)).format('0.0'))}
                                  </p>
                                  <p className="mx-1"> {item.UOMCheck === 'Primary' ? (item.SecondaryUOM)
                                    : (item.UOM_Description)}
                                  </p>
                                </div> */}


                                {/* <p className="react-datepicker__day--selected">{item.UOMCheck ==='Primary' ? (numeral(item.Quantity*item.ConQty).format('0.0') +" "+item.SecondaryUOM )
                                  :(numeral(item.Quantity/item.ConQty).format('0.0') +" "+ item.UOM_Description)}</p> */}
                              </Stack>
                            </td>
                            {/* <td>{item.UOM_Description}</td> */}
                            <td style={{ textAlign: "right" }}>
                              <div
                                style={{ textAlign: "right" }}
                                className="d-flex justify-content-end align-items-center "
                              >
                                <input
                                  type="number"
                                  className="inputText"
                                  name="rate"
                                  style={{
                                    minWidth: "100px",
                                    border: "1px solid white",
                                    borderRadius: 2,
                                    outline: "none",
                                    transition: "border-color 0.3s ease",
                                    textAlign: "right",
                                    maxWidth: "auto",
                                    fontWeight: "500",
                                  }}
                                  onFocus={e => {
                                    e.target.style.borderColor = "#66afe9"
                                    e.target.select()
                                  }}
                                  onBlur={e => {
                                    e.target.style.borderColor = "white"
                                  }}
                                  value={parseFloat(item.Rate)}
                                  min={0}
                                  onChange={e => {
                                    if (e.target.value >= 0) {
                                      const newInputValues = [...productcollection]
                                      newInputValues[index].Rate = parseFloat(
                                        e.target.value
                                      )
                                      newInputValues[index].DisAmt =
                                        (item.Quantity *
                                          parseFloat(e.target.value) *
                                          item.DisPer) /
                                        100
                                      setproductcollection(newInputValues)
                                      const newdata = [...otherchargescollection]
                                      const data = newdata.map(d => ({
                                        ...d,
                                        Amount: Number(d.Percentage) > 0 ? (productcollection.reduce((accumulator, object) => {
                                          return accumulator + object.Rate * object.Quantity - object.DisAmt
                                        }, 0) * parseFloat(d.Percentage / 100)).toFixed(2) : d.Amount
                                      }))
                                      setotherchargescollection(data)
                                    }
                                    if (e.target.value === "") {
                                      const newInputValues = [...productcollection]
                                      newInputValues[index].Rate = parseFloat(
                                        0
                                      )
                                      newInputValues[index].DisAmt =
                                        (item.Quantity *
                                          parseFloat(0) *
                                          item.DisPer) /
                                        100
                                      setproductcollection(newInputValues)
                                      const newdata = [...otherchargescollection]
                                      const data = newdata.map(d => ({
                                        ...d,
                                        Amount: Number(d.Percentage) > 0 ? (productcollection.reduce((accumulator, object) => {
                                          return accumulator + object.Rate * object.Quantity - object.DisAmt
                                        }, 0) * parseFloat(d.Percentage / 100)).toFixed(2) : d.Amount
                                      }))
                                      setotherchargescollection(data)
                                    }
                                  }}
                                />
                                {/* 
                                <Tooltip title="Check Previous Rates ">
                                  <IconButton
                                    size="small"
                                    color="warning"
                                    // onClick={() => {
                                    //   GetPreviousPrice(item.Product_Details_Id)
                                    //   setpreviousprice(true)
                                    //   setprevpriceProductName(
                                    //     `${item.Product_Details_Description} (HSN : ${item.PHSNCode})`
                                    //   )
                                    //   PrevRateOpen()
                                    // }}
                                  >
                                    <InfoOutlinedIcon
                                      sx={{ fontSize: "20px" }}
                                      color="inherit"
                                    />
                                  </IconButton>
                                </Tooltip> */}
                              </div>
                              <Typography
                                variant="caption"
                                color="#539165"
                                textAlign={"right"}
                                fontWeight={"bolder"}
                                sx={{ paddingRight: "30px" }}
                              >
                                <span>{currency}</span>
                              </Typography>
                            </td>

                            <td className="text-end">
                              <Stack
                                direction={"column"}
                                justifyContent={"start"}
                              >
                                <div style={{ textAlign: "right" }}>
                                  <input
                                    type="number"
                                    className="inputText"
                                    value={parseFloat(item.DisPer)}
                                    //   style={{ width: "50px" }}
                                    min={0}
                                    style={{
                                      maxWidth: "50px",
                                      border: "1px solid white",
                                      borderRadius: 2,
                                      outline: "none",
                                      textAlign: "right",
                                      transition: "border-color 0.3s ease",
                                    }}
                                    onFocus={e => {
                                      e.target.style.borderColor = "#66afe9"
                                      e.target.select()
                                    }}
                                    onBlur={e => {
                                      e.target.style.borderColor = "white"
                                    }}
                                    onChange={e => {
                                      if (e.target.value >= 0) {
                                        const newInputValues = [
                                          ...productcollection,
                                        ]
                                        if (e.target.value === "") {
                                          newInputValues[index].DisPer = 0
                                          newInputValues[index].DisAmt =
                                            (item.Quantity * item.Rate * 0) / 100
                                        } else {
                                          newInputValues[index].DisPer = parseFloat(
                                            e.target.value
                                          )
                                          newInputValues[index].DisAmt =
                                            (item.Quantity *
                                              parseFloat(item.Rate) *
                                              parseFloat(e.target.value)) /
                                            100
                                        }
                                        setproductcollection(newInputValues)
                                        const newdata = [...otherchargescollection]
                                        const data = newdata.map(d => ({
                                          ...d,
                                          Amount: Number(d.Percentage) > 0 ? (productcollection.reduce((accumulator, object) => {
                                            return accumulator + object.Rate * object.Quantity - object.DisAmt
                                          }, 0) * parseFloat(d.Percentage / 100)).toFixed(2) : d.Amount
                                        }))
                                        setotherchargescollection(data)
                                        // NormalCalculation()

                                      }
                                    }
                                    }
                                  />
                                  {"%"}
                                </div>
                                <Typography
                                  variant="button"
                                  color="#539165"
                                  textAlign={"right"}
                                  fontWeight={"bolder"}
                                  sx={{ paddingRight: "2px" }}
                                >
                                  {numeral(item.DisAmt).format("0,0.00")}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="#539165"
                                  textAlign={"right"}
                                  fontWeight={"bolder"}
                                  sx={{ paddingRight: "2px" }}
                                >
                                  <span>{currency}</span>
                                </Typography>
                              </Stack>
                            </td>
                            {/* <td className="text-end">
                            {numeral(item.DisAmt).format("0,0.00")}
                          </td> */}
                            <td className="text-end">
                              <Stack
                                direction={"column"}
                                justifyContent={"start"}
                              >
                                <Typography
                                  variant="caption"
                                  color="#539165"
                                  textAlign={"right"}
                                  fontWeight={"bolder"}
                                  sx={{ paddingRight: "2px" }}
                                >
                                  {item.GSTPer} {"%"}
                                </Typography>
                                <Typography
                                  variant="button"
                                  color="#539165"
                                  textAlign={"right"}
                                  fontWeight={"bolder"}
                                  sx={{ paddingRight: "2px" }}
                                >
                                  {numeral(
                                    ((item.Quantity * item.Rate -
                                      (item.Quantity * item.Rate * item.DisPer) /
                                      100) *
                                      item.GSTPer) /
                                    100
                                  ).format("0,0.00")}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="#539165"
                                  textAlign={"right"}
                                  fontWeight={"bolder"}
                                  sx={{ paddingRight: "2px" }}
                                >
                                  <span>{currency}</span>
                                </Typography>
                              </Stack>
                            </td>
                            {/* <td className="text-end">
                            {numeral(
                              ((item.Quantity * item.Rate -
                                (item.Quantity * item.Rate * item.DisPer) /
                                  100) *
                                item.GSTPer) /
                                100
                            ).format("0,0.00")}
                          </td> */}


                            {/* CESS HIDE */}
                            {/* <td className="text-end">
                            <Stack
                              direction={"column"}
                              justifyContent={"start"}
                            >
                              <div style={{ textAlign: "right" }}>
                                <input
                                  type="text"
                                  value={item.ExcisePer}
                                  style={{
                                    maxWidth: "30px",
                                    height: "20px",
                                    border: "1px solid white",
                                    borderRadius: 2,
                                    outline: "none",
                                    transition: "border-color 0.3s ease",
                                  }}
                                  onFocus={e => {
                                    e.target.style.borderColor = "#66afe9"
                                    e.target.select()
                                  }}
                                  onBlur={e => {
                                    e.target.style.borderColor = "white"
                                  }}
                                  min={0}
                                  dir="rtl"
                                  onClick={() => {
                                    toggle2()
                                    setcessids(index)
                                  }}
                                  onChange={e => {
                                    const newInputValues = [
                                      ...productcollection,
                                    ]
                                    if (e.target.value === "") {
                                      newInputValues[index].ExcisePer = 0
                                      newInputValues[index].ExciseId = 0
                                    } else {
                                      newInputValues[index].ExcisePer = 0
                                      newInputValues[index].ExciseId = 0
                                    }
                                    setproductcollection(newInputValues)
                                    // NormalCalculation()
                                  }}
                                  onKeyPress={e => {
                                    if (e.key === "Enter") {
                                      toggle2()
                                      setcessids(index)
                                    }
                                  }}
                                />
                                {"%"}
                              </div>
                              <Typography
                                variant="button"
                                color="#539165"
                                textAlign={"right"}
                                fontWeight={"bolder"}
                                sx={{ paddingRight: "2px" }}
                              >
                                {numeral(
                                  ((item.Quantity * item.Rate -
                                    (item.Quantity * item.Rate * item.DisPer) /
                                      100) *
                                    item.ExcisePer) /
                                    100
                                ).format("0,0.00")}
                              </Typography>
                              <Typography
                                variant="caption"
                                color="#539165"
                                textAlign={"right"}
                                fontWeight={"bolder"}
                                sx={{ paddingRight: "2px" }}
                              >
                                <span>{currency}</span>
                              </Typography>
                            </Stack>
                          </td> */}





                            {/* <td align="right" className="text-end">
                            {numeral(
                              ((item.Quantity * item.Rate -
                                (item.Quantity * item.Rate * item.DisPer) /
                                  100) *
                                item.ExcisePer) /
                                100
                            ).format("0,0.00")}
                          </td> */}
                            <td align="right" className="text-end">
                              <Stack
                                direction={"column"}
                                justifyContent={"start"}
                              >
                                <Typography
                                  variant="button"
                                  color="#539165"
                                  textAlign={"right"}
                                  fontWeight={"bolder"}
                                  sx={{ paddingRight: "2px" }}
                                >
                                  {numeral(item.Rate * item.Quantity -
                                    item.DisAmt).format(
                                      "0,0.00"
                                    )}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="#539165"
                                  textAlign={"right"}
                                  fontWeight={"bolder"}
                                  sx={{ paddingRight: "2px" }}
                                >
                                  <span>{currency}</span>
                                </Typography>
                              </Stack>
                            </td>
                            {!props.match.params.id1 &&
                              <td className="d-flex justify-content-center align-items-center">
                                <IconButton size="small">
                                  {/* aria-label="delete"
                              onClick={() => {
                                toggledeletemodal(index)
                              }}
                             >
                              <i
                                className="uil uil-trash-alt font-size-18 text-danger"
                                id="deletetooltip"
                              /> */}
                                  <DeleteIcon
                                    color="error"
                                    fontSize="small"
                                    onClick={() => {
                                      toggledeletemodal(index)
                                      // setdeletedconfirm(true);
                                      // setdeleteid(data.Termsid);

                                      // // toggledeletemodal(data.branch_id)
                                      // setdeletid(data.uom_id)
                                    }}
                                  />


                                </IconButton>
                              </td>}
                          </tr>
                        ))}
                      </React.Fragment>
                      <tr className="table_footer">
                        <th
                          style={{ padding: "5px", backgroundColor: "#F5F7F8" }}
                        ></th>
                        <th
                          colSpan={3}
                          style={{
                            padding: "10px",
                            fontWeight: "bolder",
                            backgroundColor: "#F5F7F8",
                          }}
                          className="text-end"
                        >
                          Total
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            fontWeight: "bolder",
                            backgroundColor: "#F5F7F8",
                          }}
                          align="right"
                          className="text-end"
                        >
                          {numeral(
                            productcollection.reduce((accumulator, object) => {
                              return accumulator + parseInt(object.Quantity)
                            }, 0)
                          ).format("0,0")}
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            fontWeight: "bolder",
                            backgroundColor: "#F5F7F8",
                          }}
                        ></th>

                        <th
                          style={{
                            padding: "10px",
                            fontWeight: "bolder",
                            backgroundColor: "#F5F7F8",
                          }}
                          align="right"
                          className="text-end"
                        >
                          {numeral(
                            productcollection.reduce((accumulator, object) => {
                              return accumulator + object.DisAmt
                            }, 0)
                          ).format("0,0.00")}
                        </th>

                        <th
                          style={{
                            padding: "10px",
                            fontWeight: "bolder",
                            backgroundColor: "#F5F7F8",
                          }}
                          align="right"
                          className="text-end"
                        >
                          {numeral(
                            productcollection.reduce((accumulator, object) => {
                              return (
                                accumulator +
                                ((object.Quantity * object.Rate -
                                  (object.Quantity *
                                    object.Rate *
                                    object.DisPer) /
                                  100) *
                                  object.GSTPer) /
                                100
                              )
                            }, 0)
                          ).format("0,0.00")}
                        </th>

                        {/* <th
                        style={{
                          padding: "10px",
                          fontWeight: "bolder",
                          backgroundColor: "#F5F7F8",
                        }}
                        align="right"
                        className="text-end"
                      >
                        {numeral(
                          productcollection.reduce((accumulator, object) => {
                            return (
                              accumulator +
                              ((object.Quantity * object.Rate -
                                (object.Quantity *
                                  object.Rate *
                                  object.DisPer) /
                                  100) *
                                object.ExcisePer) /
                                100
                            )
                          }, 0)
                        ).format("0,0.00")}
                      </th> */}
                        <th
                          style={{
                            padding: "10px",
                            fontWeight: "bolder",
                            backgroundColor: "#F5F7F8",
                          }}
                          align="right"
                          className="text-end"
                        >
                          {numeral(
                            productcollection.reduce((accumulator, object) => {
                              return accumulator + object.Rate * object.Quantity - object.DisAmt
                            }, 0)
                          ).format("0,0.00")}
                        </th>
                        <th style={{ backgroundColor: "#F5F7F8" }}> </th>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                <div>
                  <Row>
                    <Col lg={6} className="mb-2 mt-1">
                      <label className="input w-100">
                        <textarea
                          className="input__field"
                          rows="7"
                          cols="50"
                          value={remarks}
                          onChange={e => {
                            setremarks(e.target.value)
                          }}
                        ></textarea>
                        <span className="input__label">Subject</span>
                      </label>
                    </Col>
                    {/* <Col lg={5}>
                    <Paper style={{ padding: "20px" }}>
                      <Grid
                        container
                        justifyContent={"center"}
                        alignItems={"center"}
                        p={3}
                        rowSpacing={2}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      >
                        <Grid item xs={12}>
                          <Divider>
                            <Chip
                              label="Quatation Amount"
                              variant="outlined"
                              color="primary"
                              size="small"
                            />
                          </Divider>
                          <Stack
                            justifyContent={"space-between"}
                            direction={"row"}
                          >
                            <Stack
                              justifyContent={"flex-end"}
                              direction={"row"}
                            >
                              <Typography
                                variant="subtitle2"
                                color="GrayText"
                                pr={1}
                              >
                                Gross Amount
                              </Typography>
                            </Stack>
                            <Typography
                              variant="subtitle2"
                              color="#655DBB"
                              style={{ paddingRight: "7px" }}
                            >
                              {numeral(
                                productcollection.reduce(
                                  (accumulator, object) => {
                                    return (
                                      accumulator +
                                      object.Rate * object.Quantity
                                    )
                                  },
                                  0
                                )
                              ).format("0,0.00")}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12}>
                          <Stack
                            justifyContent={"space-between"}
                            direction={"row"}
                          >
                            <Stack
                              justifyContent={"flex-end"}
                              direction={"row"}
                            >
                              <Typography
                                variant="subtitle2"
                                color="GrayText"
                                pr={1}
                              >
                                Discount
                              </Typography>
                            </Stack>

                            <Typography
                              variant="subtitle2"
                              color="#655DBB"
                              textTransform={"capitalize"}
                              style={{ paddingRight: "7px" }}
                            >
                              {numeral(
                                productcollection.reduce(
                                  (accumulator, object) => {
                                    return accumulator + object.DisAmt
                                  },
                                  0
                                )
                              ).format("0,0.00")}
                            </Typography>
                          </Stack>
                        </Grid>

                        <Grid item xs={12}>
                         
                          <Stack
                            justifyContent={"space-between"}
                            direction={"row"}
                          >
                            <Stack
                              justifyContent={"flex-end"}
                              direction={"row"}
                            >
                              <Typography
                                variant="subtitle2"
                                color="GrayText"
                                pr={1}
                              >
                                CESS
                              </Typography>
                            </Stack>

                            <Typography
                              variant="subtitle2"
                              color="#655DBB"
                              style={{ paddingRight: "7px" }}
                            >
                              {numeral(
                                productcollection.reduce(
                                  (accumulator, object) => {
                                    return (
                                      accumulator +
                                      ((object.Quantity * object.Rate -
                                        (object.Quantity *
                                          object.Rate *
                                          object.DisPer) /
                                          100) *
                                        object.ExcisePer) /
                                        100
                                    )
                                  },
                                  0
                                )
                              ).format("0,0.00")}
                            </Typography>
                          </Stack>
                        </Grid>
                        {sessionStorage.getItem("RegisterType") != "SEZ" &&
                          sessionStorage.getItem("StateCode") ===
                            customerStateCode && (
                            <>
                              <Grid item xs={12}>
                                <Stack
                                  justifyContent={"space-between"}
                                  direction={"row"}
                                >
                                  <Stack
                                    justifyContent={"flex-end"}
                                    direction={"row"}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      color="GrayText"
                                      pr={1}
                                    >
                                      CGST
                                    </Typography>
                                  </Stack>

                                  <Typography
                                    variant="subtitle2"
                                    color="#655DBB"
                                    textTransform={"capitalize"}
                                    style={{ paddingRight: "7px" }}
                                  >
                                    {
                                      sessionStorage.getItem("IGSTApplicable") ===
                                        "Y" &&
                                      sessionStorage.getItem("RegisterType") ===
                                        "SEZ"
                                        ? 0
                                        : sessionStorage.getItem(
                                            "RegisterType"
                                          ) === "SEZ"
                                        ? 0
                                        : sessionStorage.getItem(
                                            "QuotationStateCode"
                                          ) ===
                                          sessionStorage.getItem("StateCode")
                                        ? numeral(
                                            productcollection.reduce(
                                              (accumulator, object) => {
                                                return (
                                                  accumulator +
                                                  ((object.Quantity *
                                                    object.Rate -
                                                    (object.Quantity *
                                                      object.Rate *
                                                      object.DisPer) /
                                                      100) *
                                                    object.GSTPer) /
                                                    100 /
                                                    2
                                                )
                                              },
                                              0
                                            )
                                          ).format("0,0.00")
                                        : 0

                                      // sessionStorage.getItem('QuotationStateCode') === sessionStorage.getItem('StateCode') ?
                                      // (numeral(productcollection.reduce((accumulator, object,) => {
                                      //     return accumulator + ((((object.Quantity * object.Rate) - ((object.Quantity * object.Rate * object.DisPer)/100)) * object.GSTPer)/100)/2 }, 0)).format('0,0.00'))
                                      //     : 0
                                    }
                                  </Typography>
                                </Stack>
                              </Grid>

                              <Grid item xs={12}>
                                <Stack
                                  justifyContent={"space-between"}
                                  direction={"row"}
                                >
                                  <Stack
                                    justifyContent={"flex-end"}
                                    direction={"row"}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      color="GrayText"
                                      pr={1}
                                    >
                                      SGST
                                    </Typography>
                                  </Stack>
                                  <Typography
                                    variant="subtitle2"
                                    color="#655DBB"
                                    style={{ paddingRight: "7px" }}
                                  >
                                    {
                                      sessionStorage.getItem("IGSTApplicable") ===
                                        "Y" &&
                                      sessionStorage.getItem("RegisterType") ===
                                        "SEZ"
                                        ? 0
                                        : sessionStorage.getItem(
                                            "RegisterType"
                                          ) === "SEZ"
                                        ? 0
                                        : sessionStorage.getItem(
                                            "QuotationStateCode"
                                          ) ===
                                          sessionStorage.getItem("StateCode")
                                        ? numeral(
                                            productcollection.reduce(
                                              (accumulator, object) => {
                                                return (
                                                  accumulator +
                                                  ((object.Quantity *
                                                    object.Rate -
                                                    (object.Quantity *
                                                      object.Rate *
                                                      object.DisPer) /
                                                      100) *
                                                    object.GSTPer) /
                                                    100 /
                                                    2
                                                )
                                              },
                                              0
                                            )
                                          ).format("0,0.00")
                                        : 0

                                      // sessionStorage.getItem('QuotationStateCode') === sessionStorage.getItem('StateCode') ?
                                      // (numeral(productcollection.reduce((accumulator, object,) => {
                                      // return accumulator + ((((object.Quantity * object.Rate) - ((object.Quantity * object.Rate * object.DisPer)/100)) * object.GSTPer)/100)/2 }, 0)).format('0,0.00'))
                                      // : 0
                                    }
                                  </Typography>
                                </Stack>
                              </Grid>
                            </>
                          )}
                        {customerStateCode !== null &&
                          sessionStorage.getItem("StateCode") !==
                            customerStateCode && (
                            <Grid item xs={12}>
                              <Stack
                                justifyContent={"space-between"}
                                direction={"row"}
                              >
                                <Stack
                                  justifyContent={"flex-end"}
                                  direction={"row"}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="GrayText"
                                    pr={1}
                                  >
                                    IGST
                                  </Typography>
                                </Stack>

                                <Typography
                                  variant="subtitle2"
                                  color="#655DBB"
                                  style={{ paddingRight: "7px" }}
                                >
                                  {sessionStorage.getItem("IGSTApplicable") ===
                                    "Y" &&
                                  sessionStorage.getItem("RegisterType") === "SEZ"
                                    ? numeral(
                                        productcollection.reduce(
                                          (accumulator, object) => {
                                            return (
                                              accumulator +
                                              ((object.Quantity * object.Rate -
                                                (object.Quantity *
                                                  object.Rate *
                                                  object.DisPer) /
                                                  100) *
                                                object.GSTPer) /
                                                100
                                            )
                                          },
                                          0
                                        )
                                      ).format("0,0.00")
                                    : sessionStorage.getItem("RegisterType") ===
                                      "SEZ"
                                    ? 0
                                    : sessionStorage.getItem(
                                        "QuotationStateCode"
                                      ) === sessionStorage.getItem("StateCode")
                                    ? 0
                                    : numeral(
                                        productcollection.reduce(
                                          (accumulator, object) => {
                                            return (
                                              accumulator +
                                              ((object.Quantity * object.Rate -
                                                (object.Quantity *
                                                  object.Rate *
                                                  object.DisPer) /
                                                  100) *
                                                object.GSTPer) /
                                                100
                                            )
                                          },
                                          0
                                        )
                                      ).format("0,0.00")}
                                </Typography>
                              </Stack>
                            </Grid>
                          )}
                        {sessionStorage.getItem("RegisterType") === "SEZ" &&
                          sessionStorage.getItem("IGSTApplicable") === "Y" && (
                            <Grid item xs={12}>
                              <Stack
                                justifyContent={"space-between"}
                                direction={"row"}
                              >
                                <Stack
                                  justifyContent={"flex-end"}
                                  direction={"row"}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="GrayText"
                                    pr={1}
                                  >
                                    IGST
                                  </Typography>
                                </Stack>

                                <Typography
                                  variant="subtitle2"
                                  color="#655DBB"
                                  style={{ paddingRight: "7px" }}
                                >
                                  {sessionStorage.getItem("IGSTApplicable") ===
                                    "Y" &&
                                  sessionStorage.getItem("RegisterType") === "SEZ"
                                    ? numeral(
                                        productcollection.reduce(
                                          (accumulator, object) => {
                                            return (
                                              accumulator +
                                              ((object.Quantity * object.Rate -
                                                (object.Quantity *
                                                  object.Rate *
                                                  object.DisPer) /
                                                  100) *
                                                object.GSTPer) /
                                                100
                                            )
                                          },
                                          0
                                        )
                                      ).format("0,0.00")
                                    : sessionStorage.getItem("RegisterType") ===
                                      "SEZ"
                                    ? 0
                                    : sessionStorage.getItem(
                                        "QuotationStateCode"
                                      ) === sessionStorage.getItem("StateCode")
                                    ? 0
                                    : numeral(
                                        productcollection.reduce(
                                          (accumulator, object) => {
                                            return (
                                              accumulator +
                                              ((object.Quantity * object.Rate -
                                                (object.Quantity *
                                                  object.Rate *
                                                  object.DisPer) /
                                                  100) *
                                                object.GSTPer) /
                                                100
                                            )
                                          },
                                          0
                                        )
                                      ).format("0,0.00")}
                                </Typography>
                              </Stack>
                            </Grid>
                          )}
                        <Grid item xs={12}>
                         
                          <Stack
                            justifyContent={"space-between"}
                            direction={"row"}
                            mt={1}
                          >
                            <Stack
                              justifyContent={"flex-end"}
                              direction={"row"}
                            >
                              <Typography
                                variant="subtitle2"
                                color="GrayText"
                                pr={1}
                              >
                                Bill Discount
                              </Typography>
                            </Stack>
                            <Typography
                              variant="subtitle2"
                              color="#655DBB"
                              textTransform={"capitalize"}
                              textAlign={"right"}
                            >
                              <div style={{ textAlign: "right" }}>
                                <input

                                 disabled={props.match.params.id1}
                                  style={{
                                    fontWeight: "bolder",
                                    textAlign: "right",
                                    maxWidth: "100px",
                                    height: "25px",
                                  }}
                                  type="number"
                                  className="form-control"
                                  aria-label="discount"
                                  aria-describedby="basic-addon1"
                                  value={billdiscount}
                                  min={0}
                                  onChange={e => {
                                    let a = productcollection.reduce(
                                      (accumulator, object) => {
                                        return (
                                          accumulator +
                                          (object.Quantity * object.Rate -
                                            (object.Quantity *
                                              object.Rate *
                                              object.DisPer) /
                                              100)
                                        )
                                      },
                                      0
                                    )

                                    let b = productcollection.reduce(
                                      (accumulator, object) => {
                                        return (
                                          accumulator +
                                          ((object.Quantity * object.Rate -
                                            (object.Quantity *
                                              object.Rate *
                                              object.DisPer) /
                                              100) *
                                            object.GSTPer) /
                                            100
                                        )
                                      },
                                      0
                                    )

                                    let c =
                                      otherchargescollection.length !== 0
                                        ? otherchargescollection.reduce(
                                            (accumulator, object) => {
                                              return (
                                                accumulator +
                                                parseFloat(object.Amount)
                                              )
                                            },
                                            0
                                          )
                                        : 0

                                    let d = productcollection.reduce(
                                      (accumulator, object) => {
                                        return (
                                          accumulator +
                                          ((object.Quantity * object.Rate -
                                            (object.Quantity *
                                              object.Rate *
                                              object.DisPer) /
                                              100) *
                                            object.ExcisePer) /
                                            100
                                        )
                                      },
                                      0
                                    )
                                    if (roundoffstatus == "Y") {
                                      if (e.target.value === "") {
                                        setbilldiscount(null)
                                        settotalamt(
                                          Math.round(a + b - null + c + d)
                                        )
                                      } else {
                                        setbilldiscount(
                                          parseFloat(e.target.value)
                                        )
                                        settotalamt(
                                          Math.round(
                                            a +
                                              b -
                                              parseFloat(e.target.value) +
                                              c +
                                              d
                                          )
                                        )
                                      }
                                    } else {
                                      if (e.target.value === "") {
                                        setbilldiscount(null)
                                        settotalamt(a + b - null + c + d)
                                      } else {
                                        setbilldiscount(
                                          parseFloat(e.target.value)
                                        )
                                        settotalamt(
                                          a +
                                            b -
                                            parseFloat(e.target.value) +
                                            c +
                                            d
                                        )
                                      }
                                    }
                                  }}
                                />
                              </div>
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12}>
                          <Stack
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            direction={"row"}
                          >
                            <Stack
                              justifyContent={"flex-start"}
                              alignItems={"center"}
                              direction={"row"}
                            >
                              <Typography
                                variant="subtitle2"
                                color="GrayText"
                                pr={1}
                              >
                                Other Charges
                                <IconButton
                                  aria-label="add"
                                  color="success"
                                  onClick={toggle1}
                                >
                                  <AddCircleIcon />
                                </IconButton>
                              </Typography>
                            </Stack>

                            <Typography
                              variant="subtitle2"
                              color="#655DBB"
                              style={{ paddingRight: "7px" }}
                            >
                              {numeral(
                                otherchargescollection.reduce(
                                  (accumulator, object) => {
                                    return (
                                      accumulator + parseFloat(object.Amount)
                                    )
                                  },
                                  0
                                )
                              ).format("0,0.00")}
                            </Typography>
                          </Stack>
                        </Grid>

                        <Grid item xs={12}>
                          <Divider />
                          
                          <Stack
                            justifyContent={"space-between"}
                            direction={"row"}
                          >
                            <Stack
                              justifyContent={"flex-end"}
                              direction={"row"}
                            >
                              <Typography variant="h6" color="GrayText" pr={1}>
                                Net Amount
                              </Typography>
                            </Stack>

                            <Typography
                              variant="h6"
                              color="#5B9A8B"
                              textAlign={"right"}
                              style={{ paddingRight: "7px" }}
                            >
                              <span
                                style={{
                                  fontSize: "small",
                                  paddingRight: "5px",
                                }}
                              >
                                {currency}
                              </span>
                              {totalamt === 0
                                ? numeral(
                                    productcollection.reduce(
                                      (accumulator, object) => {
                                        return (
                                          accumulator +
                                          (object.Quantity * object.Rate -
                                            (object.Quantity *
                                              object.Rate *
                                              object.DisPer) /
                                              100)
                                        )
                                      },
                                      0
                                    ) +
                                      productcollection.reduce(
                                        (accumulator, object) => {
                                          return (
                                            accumulator +
                                            ((object.Quantity * object.Rate -
                                              (object.Quantity *
                                                object.Rate *
                                                object.DisPer) /
                                                100) *
                                              object.GSTPer) /
                                              100
                                          )
                                        },
                                        0
                                      ) +
                                      (otherchargescollection.length !== 0
                                        ? otherchargescollection.reduce(
                                            (accumulator, object) => {
                                              return (
                                                accumulator +
                                                parseFloat(object.Amount)
                                              )
                                            },
                                            0
                                          )
                                        : 0) +
                                      productcollection.reduce(
                                        (accumulator, object) => {
                                          return (
                                            accumulator +
                                            ((object.Quantity * object.Rate -
                                              (object.Quantity *
                                                object.Rate *
                                                object.DisPer) /
                                                100) *
                                              object.ExcisePer) /
                                              100
                                          )
                                        },
                                        0
                                      ) -
                                      billdiscount !==
                                      null
                                      ? parseFloat(billdiscount)
                                      : 0
                                  ).format("0,0.00")
                                : numeral(totalamt).format("0,0.00")}
                              <div className="form-check d-flex justify-content-end align-items-start gap-2 m-0 p-0">
                                <div className="d-flex justify-content-center align-items-center gap-2">
                                  <h5 className="font-size-10 mt-2">
                                    Round Off
                                  </h5>
                                  <Switch
                                    onChange={handleChange}
                                    checked={roundoffstatus1}
                                    width={30}
                                    height={15}
                                  />
                                </div>
                              </div>
                            </Typography>
                          </Stack>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Col> */}

                    <Col lg={6}>
                      <Paper style={{ padding: "20px" }}>
                        {/* {productcollection.length != 0 && <Stack
                          justifyContent={"flex-end"}
                          alignItems={"center"}
                          direction={"row"}
                        >
                          {otherchargescollection.length > 0 ? (
                            <Typography variant="subtitle2" color="GrayText">
                              Add or Modify Other Charges
                              <IconButton
                                aria-label="add"
                                color="success"
                                onClick={() => {

                                  const newdata = [...otherchargescollection]
                                  const data = newdata.map(d => ({
                                    ...d,
                                    // Amount:(productcollection.reduce((accumulator, object) => {
                                    //   return accumulator + object.Rate * object.Quantity - object.DisAmt
                                    // }, 0)* parseFloat(d.Percentage/100)).toFixed(2)
                                  }))
                                  setotherchargescollection(data)
                                  toggleOpenOthers()
                                }}
                              >
                                <AddCircleIcon />
                              </IconButton>
                            </Typography>
                          ) : (
                            <Typography variant="subtitle2" color="GrayText">
                              Other Charges
                              <IconButton
                                aria-label="add"
                                color="success"
                                onClick={toggleOpenOthers}
                              >
                                <AddCircleIcon />
                              </IconButton>
                            </Typography>
                          )}
                        </Stack>} */}

                        <Grid
                          container
                          justifyContent={"center"}
                          alignItems={"center"}
                          p={3}
                          rowSpacing={2}
                          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        >
                          <Grid item xs={12}>
                            <Divider>
                              <Chip
                                label="Bill Amount"
                                variant="outlined"
                                color="primary"
                                size="small"
                              />
                            </Divider>
                            <Stack
                              justifyContent={"space-between"}
                              direction={"row"}
                              className="mt-1"
                            >
                              <Stack
                                justifyContent={"flex-end"}
                                direction={"row"}
                              >
                                <Typography
                                  variant="subtitle2"
                                  color="GrayText"
                                  pr={1}
                                  ml={2}
                                >
                                  Gross Amount
                                </Typography>
                              </Stack>
                              <Typography
                                variant="subtitle2"
                                color="GrayText"
                                style={{ paddingRight: "7px" }}
                              >
                                {numeral(
                                  productcollection.reduce(
                                    (accumulator, object) => {
                                      return (
                                        accumulator +

                                        object.Rate * object.Quantity -
                                        object.DisAmt
                                      )
                                    },
                                    0
                                  )
                                ).format("0,0.00")}
                              </Typography>
                            </Stack>
                            {/* <Divider/> */}
                          </Grid>
                          {/* Discount */}
                          {/* <Grid item xs={12}>
                          <Stack
                            justifyContent={"space-between"}
                            direction={"row"}
                          >
                            <Stack
                              justifyContent={"flex-end"}
                              direction={"row"}
                            >
                              <Typography
                                variant="subtitle2"
                                color="GrayText"
                                pr={1}
                                ml={2}
                              >
                                Discount
                              </Typography>
                            </Stack>

                            <Typography
                              variant="subtitle2"
                              color="GrayText"
                              textTransform={"capitalize"}
                              style={{ paddingRight: "7px" }}
                            >
                              {numeral(
                                productcollection.reduce(
                                  (accumulator, object) => {
                                    return (
                                      accumulator +
                                      object.Rate *
                                        object.Quantity *
                                        (object.DisPer / 100)
                                    )
                                  },
                                  0
                                )
                              ).format("0,0.00")}
                            </Typography>
                          </Stack>
                        </Grid> */}

                          {/* <Grid item xs={12}>                         
                          <Stack
                            justifyContent={"space-between"}
                            direction={"row"}
                          >
                            <Stack
                              justifyContent={"flex-end"}
                              direction={"row"}
                            >
                              <Typography
                                variant="subtitle2"
                                color="GrayText"
                                pr={1}
                              >
                                CESS
                              </Typography>
                            </Stack>

                            <Typography
                              variant="subtitle2"
                              color="GrayText"
                              style={{ paddingRight: "7px" }}
                            >
                              {numeral(
                                productcollection.reduce(
                                  (accumulator, object) => {
                                    return (
                                      accumulator +
                                      ((object.Quantity * object.Rate -
                                        (object.Quantity *
                                          object.Rate *
                                          object.Discount) /
                                          100) *
                                        object.DutyPer) /
                                        100
                                    )
                                  },
                                  0
                                )
                              ).format("0,0.00")}
                            </Typography>
                          </Stack>
                        </Grid> */}
                          {/* Other Charges */}

                          {/* Calculation_Of_GST === "Y" */}
                          {otherchargescollection
                            // .filter(item => item.Calculation_Of_GST === "Y")
                            .map((item, index) => (
                              <Grid item xs={12} key={index}>
                                <Stack
                                  justifyContent={"space-between"}
                                  direction={"row"}
                                >
                                  <Stack
                                    justifyContent={"flex-end"}
                                    direction={"column"}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      color="GrayText"
                                      pr={1}
                                      ml={2}
                                    >
                                      {`${item.Ledger} `}
                                      <span
                                        style={{
                                          fontWeight: "normal",
                                          color: "#638889",
                                        }}
                                      >
                                        {/* {`(${Number(item.Percentage)}%)`} */}
                                      </span>

                                      <sup
                                        style={{
                                          color: "red",
                                        }}
                                      >
                                        *
                                      </sup>

                                      {/* <br /> */}
                                      {/* <Typography
                                        variant="caption"
                                        color="coral"
                                        pr={1}
                                        sx={{fontSize:'10px'}}
                                      >                                        
                                        {item.Calculation_Of_GST === "Y" && "(Calculated with GST)"  }
                                      </Typography> */}
                                    </Typography>
                                  </Stack>
                                  <Typography
                                    variant="subtitle2"
                                    color="GrayText"
                                    style={{ paddingRight: "7px" }}
                                  >
                                    <span
                                      style={{
                                        color:
                                          item.Type === "Addition"
                                            ? "#40679E"
                                            : "#E8751A",
                                        paddingLeft: 5,
                                      }}
                                    >

                                      {/* {item.Type === "Addition" ? "(+)" : "(-)"} */}

                                      {item.Type === "Addition" ? "(+" : "(-"}
                                      {/* {" "} */}
                                      {`${Number(item.Percentage)}%)`}
                                    </span>{" "}
                                    {numeral(item.Amount).format("0,0.00")}
                                  </Typography>
                                </Stack>
                              </Grid>
                            ))}

                          {/* Calculation_Of_GST === "N" */}
                          {/* {otherchargescollection
                          .filter(item => item.Calculation_Of_GST === "N")
                          .map((item, index) => (
                            <Grid item xs={12} key={index}>
                              <Stack
                                justifyContent={"space-between"}
                                direction={"row"}
                              >
                                <Stack
                                  justifyContent={"flex-end"}
                                  direction={"row"}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="GrayText"
                                    pr={1}
                                    ml={2}
                                  >
                                    {`${item.Ledger} `}
                                    <span
                                      style={{
                                        fontWeight: "normal",
                                        color: "#638889",
                                      }}
                                    >
                                    
                                    </span>
                                  </Typography>
                                </Stack>
                                <Typography
                                  variant="subtitle2"
                                  color="GrayText"
                                  style={{ paddingRight: "7px" }}
                                >
                                  <span
                                    style={{
                                      color:
                                        item.Type === "Addition"
                                          ? "#40679E"
                                          : "#E8751A",
                                      paddingLeft: 5,
                                    }}
                                  >
                                    {item.Type === "Addition" ? "(+" : "(-"}                                  
                                    {`${Number(item.Percentage)}%)`}
                                  </span>{" "}
                                  {numeral(item.Amount).format("0,0.00")}
                                </Typography>
                              </Stack>
                            </Grid>
                          ))} */}

                          {sessionStorage.getItem("RegisterType") != "SEZ" &&
                            sessionStorage.getItem("CStateCode") == 0
                            // customerStateCode 
                            && (
                              <>
                                <Grid item xs={12}>
                                  <Stack
                                    justifyContent={"space-between"}
                                    direction={"row"}
                                  >
                                    <Stack
                                      justifyContent={"flex-end"}
                                      direction={"row"}
                                    >
                                      <Typography
                                        variant="subtitle2"
                                        color="GrayText"
                                        pr={1}
                                        ml={2}
                                      >
                                        CGST
                                      </Typography>
                                    </Stack>

                                    <Typography
                                      variant="subtitle2"
                                      color="GrayText"
                                      textTransform={"capitalize"}
                                      style={{ paddingRight: "7px" }}
                                    >

                                      {sessionStorage.getItem("IGSTApplicable") ===
                                        "Y" &&
                                        sessionStorage.getItem("RegisterType") ===
                                        "SEZ"
                                        ? 0
                                        : sessionStorage.getItem("RegisterType") ===
                                          "SEZ"
                                          ? 0
                                          : sessionStorage.getItem(
                                            "QuotationStateCode"
                                          ) === sessionStorage.getItem("CStateCode")
                                            ? otherchargescollection.filter(
                                              data =>
                                                data.Calculation_Of_GST === "Y"
                                            ).length != 0
                                              ?
                                              // numeral(
                                              // productcollection.reduce(
                                              //   (accumulator, object) => {
                                              //     return (
                                              //       accumulator +
                                              //       ((object.Rate *
                                              //         object.Quantity -
                                              //         object.DisAmt +
                                              //         ((object.Rate *
                                              //           object.Quantity -
                                              //           object.DisAmt) *
                                              //           object.OtherChargesAdd) /
                                              //           100 -
                                              //         ((object.Rate *
                                              //           object.Quantity -
                                              //           object.DisAmt) *
                                              //           object.OtherChargesSub) /
                                              //           100) *
                                              //         object.GSTPer) /
                                              //         100 /
                                              //         2
                                              //     )
                                              //   },
                                              //   0
                                              // ) 

                                              //       +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                                              //         return (
                                              //           accumulator +
                                              //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                                              //         )
                                              //       }, 0)-
                                              // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                              //         return (
                                              //           accumulator +
                                              //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                                              //         )
                                              //       }, 0))/2
                                              //     ).format("0,0.00")
                                              numeral(totalCGSTAmount).format("0,0.00")
                                              : numeral(
                                                productcollection.reduce(
                                                  (accumulator, object) => {
                                                    return (
                                                      accumulator +
                                                      ((object.Quantity *
                                                        object.Rate -
                                                        (object.Quantity *
                                                          object.Rate *
                                                          object.DisPer) /
                                                        100) *
                                                        object.GSTPer) /
                                                      100 /
                                                      2
                                                    )
                                                  },
                                                  0
                                                ) + (otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                                  return (
                                                    accumulator +
                                                    (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)
                                                  )
                                                }, 0) -
                                                  otherchargescollection.filter((data) => (data.Type === 'Deduction') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                                    return (
                                                      accumulator +
                                                      (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)


                                                    )
                                                  }, 0)) / 2
                                              ).format("0,0.00")
                                            : 0}
                                    </Typography>
                                  </Stack>
                                </Grid>

                                <Grid item xs={12}>
                                  <Stack
                                    justifyContent={"space-between"}
                                    direction={"row"}
                                  >
                                    <Stack
                                      justifyContent={"flex-end"}
                                      direction={"row"}
                                    >
                                      <Typography
                                        variant="subtitle2"
                                        color="GrayText"
                                        pr={1}
                                        ml={2}
                                      >
                                        SGST
                                      </Typography>
                                    </Stack>
                                    <Typography
                                      variant="subtitle2"
                                      color="GrayText"
                                      style={{ paddingRight: "7px" }}
                                    >
                                      {sessionStorage.getItem("IGSTApplicable") ===
                                        "Y" &&
                                        sessionStorage.getItem("RegisterType") ===
                                        "SEZ"
                                        ? 0
                                        : sessionStorage.getItem("RegisterType") ===
                                          "SEZ"
                                          ? 0
                                          : sessionStorage.getItem(
                                            "QuotationStateCode"
                                          ) === sessionStorage.getItem("CStateCode")
                                            ? otherchargescollection.filter(
                                              data =>
                                                data.Calculation_Of_GST === "Y"
                                            ).length != 0
                                              ?
                                              //   ? numeral(
                                              //       productcollection.reduce(
                                              //         (accumulator, object) => {
                                              //           return (
                                              //             accumulator +
                                              //             ((object.Rate *
                                              //               object.Quantity -
                                              //               object.DisAmt +
                                              //               ((object.Rate *
                                              //                 object.Quantity -
                                              //                 object.DisAmt) *
                                              //                 object.OtherChargesAdd) /
                                              //                 100 -
                                              //               ((object.Rate *
                                              //                 object.Quantity -
                                              //                 object.DisAmt) *
                                              //                 object.OtherChargesSub) /
                                              //                 100) *
                                              //               object.GSTPer) /
                                              //               100 /
                                              //               2
                                              //           )
                                              //         },
                                              //         0
                                              //       )+ +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                                              //         return (
                                              //           accumulator +
                                              //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                                              //         )
                                              //       }, 0)-
                                              // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                              //         return (
                                              //           accumulator +
                                              //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                                              //         )
                                              //       }, 0))/2
                                              //     ).format("0,0.00")
                                              numeral(totalSGSTAmount).format("0,0.00")
                                              : numeral(
                                                productcollection.reduce(
                                                  (accumulator, object) => {
                                                    return (
                                                      accumulator +
                                                      ((object.Quantity *
                                                        object.Rate -
                                                        (object.Quantity *
                                                          object.Rate *
                                                          object.DisPer) /
                                                        100) *
                                                        object.GSTPer) /
                                                      100 /
                                                      2
                                                    )
                                                  },
                                                  0
                                                ) + (otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                                  return (
                                                    accumulator +
                                                    (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)
                                                  )
                                                }, 0) -
                                                  otherchargescollection.filter((data) => (data.Type === 'Deduction') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                                    return (
                                                      accumulator +
                                                      (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)


                                                    )
                                                  }, 0)) / 2
                                              ).format("0,0.00")
                                            : 0}
                                    </Typography>
                                  </Stack>
                                </Grid>
                              </>
                            )}

                          {customerStateCode !== null &&
                            sessionStorage.getItem("CStateCode") != 0
                            // customerStateCode

                            && (
                              <Grid item xs={12}>
                                <Stack
                                  justifyContent={"space-between"}
                                  direction={"row"}
                                >
                                  <Stack
                                    justifyContent={"flex-end"}
                                    direction={"row"}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      color="GrayText"
                                      pr={1}
                                      ml={2}
                                    >
                                      TaxAmt
                                    </Typography>
                                  </Stack>

                                  <Typography
                                    variant="subtitle2"
                                    color="GrayText"
                                    style={{ paddingRight: "7px" }}
                                  >
                                    {sessionStorage.getItem("IGSTApplicable") ===
                                      "Y" &&
                                      sessionStorage.getItem("RegisterType") === "SEZ"
                                      ? otherchargescollection.filter(
                                        data => data.Calculation_Of_GST === "Y"
                                      ).length != 0
                                        ?
                                        //   numeral(
                                        //       productcollection.reduce(
                                        //         (accumulator, object) => {
                                        //           return (
                                        //             accumulator +
                                        //             ((object.Rate *
                                        //               object.Quantity -
                                        //               object.DisAmt +
                                        //               ((object.Rate *
                                        //                 object.Quantity -
                                        //                 object.DisAmt) *
                                        //                 object.OtherChargesAdd) /
                                        //                 100 -
                                        //               ((object.Rate *
                                        //                 object.Quantity -
                                        //                 object.DisAmt) *
                                        //                 object.OtherChargesSub) /
                                        //                 100) *
                                        //               object.GSTPer) /
                                        //               100
                                        //           )
                                        //         },
                                        //         0
                                        //       ) +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                                        //         return (
                                        //           accumulator +
                                        //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                                        //         )
                                        //       }, 0)-
                                        // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                        //         return (
                                        //           accumulator +
                                        //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                                        //         )
                                        //       }, 0))
                                        //     ).format("0,0.00")
                                        numeral(totalIGSTAmount).format("0,0.00")
                                        : numeral(
                                          productcollection.reduce(
                                            (accumulator, object) => {
                                              return (
                                                accumulator +
                                                ((object.Quantity *
                                                  object.Rate -
                                                  (object.Quantity *
                                                    object.Rate *
                                                    object.DisPer) /
                                                  100) *
                                                  object.GSTPer) /
                                                100
                                              )
                                            },
                                            0
                                          ) + (otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                            return (
                                              accumulator +
                                              (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)
                                            )
                                          }, 0) -
                                            otherchargescollection.filter((data) => (data.Type === 'Deduction') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                              return (
                                                accumulator +
                                                (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)


                                              )
                                            }, 0))
                                        ).format("0,0.00")

                                      : sessionStorage.getItem("RegisterType") ===
                                        "SEZ"
                                        ? 0
                                        :
                                        // sessionStorage.getItem(
                                        //   "QuotationStateCode"
                                        // ) 
                                        0
                                          === sessionStorage.getItem("CStateCode")
                                          ? 0
                                          : otherchargescollection.filter(
                                            data => data.Calculation_Of_GST === "Y"
                                          ).length != 0
                                            ? numeral(
                                              numeral(totalIGSTAmount).format("0,0.00")
                                              //       productcollection.reduce(
                                              //         (accumulator, object) => {
                                              //           return (
                                              //             accumulator +
                                              //             ((object.Rate *
                                              //               object.Quantity -
                                              //               object.DisAmt +
                                              //               ((object.Rate *
                                              //                 object.Quantity -
                                              //                 object.DisAmt) *
                                              //                 object.OtherChargesAdd) /
                                              //                 100 -
                                              //               ((object.Rate *
                                              //                 object.Quantity -
                                              //                 object.DisAmt) *
                                              //                 object.OtherChargesSub) /
                                              //                 100) *
                                              //               object.GSTPer) /
                                              //               100
                                              //           )
                                              //         },
                                              //         0
                                              //       ) +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                                              //         return (
                                              //           accumulator +
                                              //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                                              //         )
                                              //       }, 0)-
                                              // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                              //         return (
                                              //           accumulator +
                                              //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                                              //         )
                                              //       }, 0))
                                            ).format("0,0.00")
                                            : numeral(
                                              productcollection.reduce(
                                                (accumulator, object) => {
                                                  return (
                                                    accumulator +
                                                    ((object.Quantity *
                                                      object.Rate -
                                                      (object.Quantity *
                                                        object.Rate *
                                                        object.DisPer) /
                                                      100) *
                                                      object.GSTPer) /
                                                    100
                                                  )
                                                },
                                                0
                                              ) + (otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                                return (
                                                  accumulator +
                                                  (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)
                                                )
                                              }, 0) -
                                                otherchargescollection.filter((data) => (data.Type === 'Deduction') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                                  return (
                                                    accumulator +
                                                    (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)


                                                  )
                                                }, 0))
                                            ).format("0,0.00")}
                                  </Typography>
                                </Stack>
                              </Grid>
                            )}

                          {sessionStorage.getItem("RegisterType") === "SEZ" &&
                            sessionStorage.getItem("IGSTApplicable") === "Y" && (
                              <Grid item xs={12}>
                                <Stack
                                  justifyContent={"space-between"}
                                  direction={"row"}
                                >
                                  <Stack
                                    justifyContent={"flex-end"}
                                    direction={"row"}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      color="GrayText"
                                      pr={1}
                                      ml={2}
                                    >
                                      IGST
                                    </Typography>
                                  </Stack>

                                  <Typography
                                    variant="subtitle2"
                                    color="GrayText"
                                    style={{ paddingRight: "7px" }}
                                  >
                                    {sessionStorage.getItem("IGSTApplicable") ===
                                      "Y" &&
                                      sessionStorage.getItem("RegisterType") === "SEZ"
                                      ? otherchargescollection.filter(
                                        data => data.Calculation_Of_GST === "Y"
                                      ).length != 0
                                        ? numeral(
                                          totalIGSTAmount
                                          //       productcollection.reduce(
                                          //         (accumulator, object) => {
                                          //           return (
                                          //             accumulator +
                                          //             ((object.Rate *
                                          //               object.Quantity -
                                          //               object.DisAmt +
                                          //               (
                                          //                 (object.Rate *
                                          //                 object.Quantity -
                                          //                 object.DisAmt) *
                                          //                 object.OtherChargesAdd) /
                                          //                 100 
                                          //                 -
                                          //               ((object.Rate *
                                          //                 object.Quantity -
                                          //                 object.DisAmt) *
                                          //                 object.OtherChargesSub) /
                                          //                 100) *
                                          //               object.GSTPer) /
                                          //               100
                                          //           )
                                          //         },
                                          //         0
                                          //       ) +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                                          //         return (
                                          //           accumulator +
                                          //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                                          //         )
                                          //       }, 0)-
                                          // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                          //         return (
                                          //           accumulator +
                                          //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                                          //         )
                                          //       }, 0))
                                        ).format("0,0.00")
                                        : numeral(
                                          productcollection.reduce(
                                            (accumulator, object) => {
                                              return (
                                                accumulator +
                                                ((object.Quantity *
                                                  object.Rate -
                                                  (object.Quantity *
                                                    object.Rate *
                                                    object.DisPer) /
                                                  100) *
                                                  object.GSTPer) /
                                                100
                                              )
                                            },
                                            0
                                          ) + (otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                            return (
                                              accumulator +
                                              (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)
                                            )
                                          }, 0) -
                                            otherchargescollection.filter((data) => (data.Type === 'Deduction') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                              return (
                                                accumulator +
                                                (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)


                                              )
                                            }, 0))
                                        ).format("0,0.00")
                                      : sessionStorage.getItem("RegisterType") ===
                                        "SEZ"
                                        ? 0
                                        : sessionStorage.getItem(
                                          "SalesOrderStateCode"
                                        ) === sessionStorage.getItem("CStateCode")
                                          ? 0
                                          : otherchargescollection.filter(
                                            data =>
                                              data.Calculation_Of_GST === "Y"
                                          ).length != 0
                                            ? numeral(
                                              numeral(totalIGSTAmount).format("0,0.00")
                                              //       productcollection.reduce(
                                              //         (accumulator, object) => {
                                              //           return (
                                              //             accumulator +
                                              //             ((object.Rate *
                                              //               object.Quantity -
                                              //               object.DisAmt +
                                              //               ((object.Rate *
                                              //                 object.Quantity -
                                              //                 object.DisAmt) *
                                              //                 object.OtherChargesAdd) /
                                              //                 100 -
                                              //               ((object.Rate *
                                              //                 object.Quantity -
                                              //                 object.DisAmt) *
                                              //                 object.OtherChargesSub) /
                                              //                 100) *
                                              //               object.GSTPer) /
                                              //               100 /
                                              //               2
                                              //           )
                                              //         },
                                              //         0
                                              //       ) +(otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N')&&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15) ).reduce((accumulator, object) => {
                                              //         return (
                                              //           accumulator +
                                              //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )
                                              //         )
                                              //       }, 0)-
                                              // otherchargescollection.filter((data) => (data.Type === 'Deduction')&& (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') &&(parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                              //         return (
                                              //           accumulator +
                                              //           (parseFloat(object.Amount) * parseFloat(object.Tax )/100 )


                                              //         )
                                              //       }, 0))
                                            ).format("0,0.00")
                                            :
                                            numeral(
                                              productcollection.reduce(
                                                (accumulator, object) => {
                                                  return (
                                                    accumulator +
                                                    ((object.Quantity *
                                                      object.Rate -
                                                      (object.Quantity *
                                                        object.Rate *
                                                        object.DisPer) /
                                                      100) *
                                                      object.GSTPer) /
                                                    100
                                                  )
                                                },
                                                0
                                              ) + (otherchargescollection.filter((data) => (data.Type === 'Addition') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                                return (
                                                  accumulator +
                                                  (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)
                                                )
                                              }, 0) -
                                                otherchargescollection.filter((data) => (data.Type === 'Deduction') && (data.GST_Applicability === 'Y' && data.Calculation_Of_GST == 'N') && (parseInt(data.GroupId) === 13 || parseInt(data.GroupId) === 15 || parseInt(data.UnderGroupId) === 13 || parseInt(data.UnderGroupId) === 15)).reduce((accumulator, object) => {
                                                  return (
                                                    accumulator +
                                                    (parseFloat(object.Amount) * parseFloat(object.Tax) / 100)


                                                  )
                                                }, 0))
                                            ).format("0,0.00")}
                                  </Typography>
                                </Stack>
                              </Grid>
                            )}



                          <Grid item xs={12} className="mt-1">
                            <Divider />
                            <Stack
                              justifyContent={"space-between"}
                              direction={"row"}
                            >
                              <Stack
                                justifyContent={"flex-end"}
                                direction={"row"}
                              >
                                <Typography
                                  variant="h6"
                                  color="#5B9A8B"
                                  pr={1}
                                  ml={2}
                                >
                                  Net Amount
                                </Typography>
                              </Stack>

                              <Typography
                                variant="h6"
                                color="#5B9A8B"
                                textAlign={"right"}
                                style={{ paddingRight: "7px" }}
                              >
                                <span
                                  style={{
                                    fontSize: "small",
                                    paddingRight: "5px",
                                  }}
                                >
                                  {currency}
                                </span>
                                {totalamt === 0
                                  ? numeral(NetAmount
                                    // productcollection.reduce(
                                    //   (accumulator, object) => {
                                    //     return (
                                    //       accumulator +                                        
                                    //       (object.Rate * object.Quantity -
                                    //         object.DisAmt ))
                                    //         // ((object.Rate * object.Quantity -
                                    //         //   object.DisAmt) *
                                    //         //   object.OtherChargesAdd) /
                                    //         //   100 -
                                    //         // ((object.Rate * object.Quantity -
                                    //         //   object.DisAmt) *
                                    //         //   object.OtherChargesSub) /
                                    //         //   100)

                                    //   },
                                    //   0
                                    // )+{totalOtherChargesAmount}+{totalIGSTAmount}
                                    //  +
                                    //   productcollection.reduce(
                                    //     (accumulator, object) => {
                                    //       return (
                                    //         accumulator +                                         

                                    //         ((object.Rate * object.Quantity -
                                    //           object.DisAmt +
                                    //           ((object.Rate *
                                    //             object.Quantity -
                                    //             object.DisAmt) *
                                    //             object.OtherChargesAdd) /
                                    //             100 -
                                    //           ((object.Rate *
                                    //             object.Quantity -
                                    //             object.DisAmt) *
                                    //             object.OtherChargesSub) /
                                    //             100) *
                                    //           object.GSTPer) /
                                    //           100
                                    //       )
                                    //     },
                                    //     0
                                    //   ) +
                                    //   productcollection.reduce(
                                    //     (accumulator, object) => {
                                    //       return (
                                    //         accumulator +
                                    //         ((object.Quantity * object.Rate -
                                    //           (object.Quantity *
                                    //             object.Rate *
                                    //             object.Discount) /
                                    //             100) *
                                    //           object.DutyPer) /
                                    //           100
                                    //       )
                                    //     },
                                    //     0
                                    //   )
                                  ).format("0,0.00")
                                  : numeral(parseFloat(totalamt)
                                  ).format("0,0.00")}
                                <div className="form-check d-flex justify-content-end align-items-start gap-2 m-0 p-0">
                                  <div className="d-flex justify-content-center align-items-center gap-2">
                                    <h5 className="font-size-10 mt-2">
                                      Round Off
                                    </h5>
                                    <Switch
                                      onChange={handleChange}
                                      checked={roundoffstatus1}
                                      width={30}
                                      height={15}
                                    />
                                  </div>
                                </div>
                              </Typography>
                            </Stack>
                          </Grid>

                          {otherchargescollection.some(
                            item => item.Calculation_Of_GST === "Y"
                          ) && (
                              <Grid item xs={12} className="px-3">
                                <Typography
                                  variant="caption"
                                  color="textSecondary"
                                  align="center"
                                >
                                  <span
                                    style={{
                                      color: "red",
                                    }}
                                  >
                                    *
                                  </span>{" "}
                                  Charges computed inclusive of GST
                                </Typography>
                              </Grid>
                            )}
                        </Grid>
                      </Paper>
                    </Col>
                  </Row>
                </div>

                <Modal isOpen={modalUom} toggle={toggleUom}>
                  <ModalHeader toggle={toggleUom}>UOM</ModalHeader>
                  <ModalBody>
                    <Card className="p-3">
                      <div>
                        <Table
                          striped
                          responsive
                          style={{ width: "100%", fontSize: "13px" }}
                        >
                          <thead>
                            <tr className="table-info">
                              {/* <th
                                style={{ padding: "5px" }}
                                className="text-center"
                              >
                                SNo
                              </th> */}
                              <th
                                style={{ padding: "5px" }}
                                className="text-center"
                              >
                                Primary UOM
                              </th>
                              <th
                                style={{ padding: "5px" }}
                                className="text-center"
                              >
                                Secondary UOM
                              </th>
                              {/* <th
                                style={{ padding: "5px" }}
                                className="text-center"
                              >
                                Tax Percentage
                              </th> */}
                            </tr>
                          </thead>
                          <tbody>
                            <React.Fragment>
                              {productcollection.filter((data) => data.Product_Details_Id === IndexforUom).map((item, index) => (
                                <tr
                                  key={index}
                                  onClick={() => {
                                    // cesspopup(item.customer_id, item.taxper)
                                    toggleUom()
                                  }}
                                >
                                  {/* <td style={{
                                        padding: "5px",
                                        textAlign: "center",
                                      }}>
                                    {index + 1}
                                  </td> */}
                                  <td
                                    style={{
                                      padding: "5px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Button
                                      className="primary"
                                      onClick={() => {
                                        let indexid = productcollection.findIndex(obj => obj.Product_Details_Id === IndexforUom);

                                        // Update productcollection
                                        const newProductCollection = [...productcollection];
                                        newProductCollection[indexid].UOMCheck = "Primary";
                                        setproductcollection(newProductCollection);
                                      }}
                                    >
                                      {item.UOM_Description}
                                    </Button>
                                  </td>
                                  <td
                                    style={{
                                      padding: "5px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Button
                                      className="Secondary"
                                      onClick={() => {
                                        let indexid = productcollection.findIndex(obj => obj.Product_Details_Id == IndexforUom);

                                        // Update productcollection
                                        const newProductCollection = [...productcollection];
                                        newProductCollection[indexid].UOMCheck = "Secondary";
                                        setproductcollection(newProductCollection);

                                      }}
                                    >
                                      {" "}
                                      {item.SecondaryUOM}
                                    </Button>
                                  </td>
                                  {/* <td style={{ padding: "5px" }}>
                                    {item.taxper}
                                  </td> */}
                                </tr>
                              ))}
                            </React.Fragment>
                          </tbody>
                        </Table>
                      </div>
                    </Card>
                  </ModalBody>
                </Modal>
                {/* comment By Yuki Old Other Charges  */}
                {/* <Modal isOpen={modal1}>
                  <ModalHeader >Other Charges</ModalHeader>
                  <ModalBody>
                    <Card className="p-3">
                      <Row className="mb-2">
                        <Col>
                          <label className="input">
                            <Select
                              options={otherchargesData}
                              classNamePrefix="select2-search-disable"
                              styles={customStyles}
                              value={otherchargeshelp}
                              onChange={value => {
                                let arr = otherchargesData1.filter(
                                  item => item.customer_id == value.value
                                )
                                selectedCustomer1(arr)                                
                                let dd = otherchargesData.filter(
                                  item =>
                                    parseInt(item.value) !==
                                    parseInt(value.value)
                                )
                                setotherchargesData(dd)
                              }}
                            />
                            <span className="input__label1">
                              General Ledger <b className="text-danger">*</b>
                            </span>
                          </label>
                        </Col>
                      </Row>
                      <div style={{ marginBottom: "25px" }}>
                        <Table striped responsive style={{ width: "100%" }}>
                          <thead>
                            <tr className="table-info">
                              <th className="text-center">SNo</th>
                              <th className="text-center text-nowrap">
                                Ledger
                              </th>
                              <th className="text-center">Amount</th>
                              <th className="text-center">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <React.Fragment>
                              {otherchargescollection.map((item, index) => (
                                <tr key={index}>
                                  <td className="text-center">{index + 1}</td>
                                  <td className="text-nowrap">{item.Ledger}</td>
                                  <td
                                    style={{ width: "100px" }}
                                    className="p-1"
                                  >
                                    <Input
                                      type="number"
                                      value={item.Amount}
                                      style={{ width: "100px" }}
                                      onChange={e => {
                                        const newInputValues = [
                                          ...otherchargescollection,
                                        ]
                                        newInputValues[index].Amount =
                                          e.target.value
                                        setotherchargescollection(
                                          newInputValues
                                        )
                                      }}
                                    />
                                  </td>
                                  <td className="text-center">
                                    <Link
                                      to="#"
                                      className="text-danger"
                                      onClick={() => {
                                        toggledeletemodal1(index, item.LedgerId)                                       
                                      }}
                                    >
                                      <i
                                        className="uil uil-trash-alt font-size-18"
                                        id="deletetooltip"
                                      />
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="deletetooltip"
                                      >
                                        Delete
                                      </UncontrolledTooltip>
                                    </Link>
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          </tbody>
                        </Table>
                      </div>
                    </Card>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="secondary"
                      onClick={() => {
                        toggle1()                       
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="bg-info"
                      onClick={() => {
                        if (otherchargescollection.length !== 0) {
                          toggle1()                          
                        } else {
                          setotherchargeserr(true)
                        }
                      }}
                    >
                      Save
                    </Button>
                  </ModalFooter>
                </Modal> */}
                <Modal isOpen={modal2} toggle={toggle2}>
                  <ModalHeader toggle={toggle2}>Cess</ModalHeader>
                  <ModalBody>
                    <div>
                      <Table
                        striped
                        responsive
                        style={{ width: "100%", fontSize: "13px" }}
                      >
                        <thead>
                          <tr className="table-info">
                            <th
                              style={{ padding: "5px", textAlign: "center" }}
                              className="text-center"
                            >
                              SNo
                            </th>
                            <th
                              style={{ padding: "5px", textAlign: "left" }}
                              className="text-center"
                            >
                              Ledger
                            </th>
                            <th
                              style={{ padding: "5px", textAlign: "center" }}
                              className="text-center"
                            >
                              Tax Percentage
                            </th>
                            <th
                              style={{ padding: "5px", textAlign: "center" }}
                              className="text-center"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <React.Fragment>
                            {CessData.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.customer_name}</td>
                                <td align="center">{item.taxper}</td>
                                <td className="text-center" align="center">
                                  <CustomButton2
                                    variant="outlined"
                                    color="success"
                                    size="small"
                                    onClick={() => {
                                      cesspopup(item.customer_id, item.taxper)
                                      toggle2()
                                    }}
                                  >
                                    Select
                                  </CustomButton2>
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        </tbody>
                      </Table>
                    </div>
                  </ModalBody>
                </Modal>
                <div className="d-none">
                  {/* <ProductMaster
                ShowModalProps={ProductModal}
                CallBack={RandomCallback}
                inputValue={val}
                EditMode={EditProduct}
                ProductCallback={returnFromProductMaster}
              /> */}
                </div>
              </CardBody>
            </Card>
            <Paper className="d-flex justify-content-center p-4" elevation={5}>
              {props.match.params.id ? (
                // <React.Fragment>
                //   <div className="d-flex">
                //     <div className="mx-2">
                //       <Link
                //         to="#"
                //         className="btn btn-danger"
                //         onClick={e => {
                //           if (window.confirm("are you sure ? You want to discard changes?")) {
                //             history.push("/Quotation")
                //           } else {
                //           }

                //         }}
                //       >
                //         Cancel
                //       </Link>
                //     </div>
                //     {!props.match.params.id1?

                //     <div className="mx-2">
                //       <CustomButton
                //         //   className="btn btn-success"
                //         onClick={e => {
                //           if (
                //             JSON.parse(sessionStorage.getItem("MenuItemQuotationControls"))
                //               .Edit == "Y"
                //           ) {
                //             e.preventDefault()
                //             const targetObject = productcollection.find(
                //               item => item.Rate === "" || item.Rate == 0
                //             )
                //             const targetObject1 = productcollection.find(
                //               item =>
                //                 item.Quantity === "" ||
                //                 item.Quantity == 0 ||
                //                 item.Quantity === null
                //             )

                //             console.log(targetObject, targetObject1)
                //             if (targetObject) {
                //               setrateerror(true)
                //             } else if (targetObject1) {
                //               setqtyerror(true)
                //             } else {
                //               Updatehdr()
                //               setTimeout(() => {
                //                 Updatedtl()
                //                 UpdateOtherCharges()
                //               }, 500)
                //               setinvoiceupdate(true)
                //             }
                //           } else {
                //             toastr.warning(
                //               "Please Contact Admin",
                //               "Operation Not Allowed"
                //             )
                //           }
                //         }}
                //       >
                //         Update
                //       </CustomButton>
                //     </div>
                //     :  
                //     <div className="mx-3 d-flex justify-content-center ">
                //       <ButtonMui
                //         variant="outlined"
                //         color="primary"
                //        onClick={()=> {
                //       setPrintPerview(true)
                //       window.scrollTo({
                //         top: 0,
                //         behavior: 'smooth' // This smooths the scrolling behavior
                //       });
                //        }}
                //         startIcon={<PrintIcon />}
                //         size="small"
                //         className="pr-2"
                //       >
                //         Print
                //       </ButtonMui>
                //     </div>}
                //   </div>
                // </React.Fragment>

                <React.Fragment>
                  <div className="d-flex">
                    <div className="mx-2">
                      <Link
                        to="#"
                        className="btn btn-danger"
                        onClick={e => {
                          if (props.match.params.id1 === "QR") {
                            if (window.confirm("Are you sure? You want to discard changes?")) {
                              history.push("/QuotationReport");
                            }
                          } else {
                            if (window.confirm("Are you sure? You want to discard changes?")) {
                              history.push("/Quotation");
                            }
                          }
                        }}
                      >
                        Cancel
                      </Link>
                    </div>

                    {/* Check if props.match.params.id1 is not defined */}
                    {!props.match.params.id1 ? (
                      <div className="mx-2">
                        <CustomButton
                          onClick={e => {
                            // if (
                            //   JSON.parse(sessionStorage.getItem("MenuItemQuotationControls"))
                            //     .Edit === "Y"
                            // ) {
                            e.preventDefault();
                            const targetObject = productcollection.find(
                              item => item.Rate === "" || item.Rate == 0
                            );
                            const targetObject1 = productcollection.find(
                              item =>
                                item.Quantity === "" ||
                                item.Quantity == 0 ||
                                item.Quantity === null
                            );

                            // console.log(targetObject, targetObject1);
                            if (targetObject) {
                              setrateerror(true);
                            } else if (targetObject1) {
                              setqtyerror(true);
                            } else {
                              Updatehdr();
                              setTimeout(() => {
                                Updatedtl();
                                UpdateOtherCharges();
                              }, 500);

                            }
                            // } else {
                            //   toastr.warning("Please Contact Admin", "Operation Not Allowed");
                            // }
                          }}
                        >
                          Update
                        </CustomButton>
                      </div>
                    ) : (
                      // Check if id1 is "QR"
                      props.match.params.id1 === "QR" ? null : (
                        <div className="mx-3 d-flex justify-content-center">
                          <ButtonMui
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                              setPrintPerview(true);
                              window.scrollTo({
                                top: 0,
                                behavior: "smooth", // Smooth scrolling behavior
                              });
                            }}
                            startIcon={<PrintIcon />}
                            size="small"
                            className="pr-2"
                          >
                            Print
                          </ButtonMui>
                        </div>
                      )
                    )}
                  </div>
                </React.Fragment>

              ) : (
                <React.Fragment>
                  <div className="d-flex">
                    <div className="mx-2">
                      <button
                        to="#"
                        className="btn"
                        style={{
                          backgroundColor: "#E43D40",
                          color: "white",
                          fontWeight: "bolder",
                        }}
                        onClick={e => {
                          if (window.confirm("are you sure ? You want to discard changes?")) {
                            history.push("/Quotation")
                          } else {
                          }

                        }}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="mx-2">
                      <CustomButton
                        //   className="btn btn-success"
                        onClick={e => {
                          if (
                            customerNameHelp.value !== "" &&
                            productcollection.length !== 0
                          ) {
                            e.preventDefault()
                            const targetObject = productcollection.find(
                              item => item.Rate === "" || item.Rate == 0
                            )
                            const targetObject1 = productcollection.find(
                              item =>
                                item.Quantity === "" ||
                                item.Quantity == 0 ||
                                item.Quantity === null
                            )

                            // console.log(targetObject, targetObject1)
                            if (targetObject) {
                              setrateerror(true)
                            } else if (targetObject1) {
                              setqtyerror(true)
                            } else {
                              InsertQuotationhdr()
                              setTimeout(() => {
                                InsertQuotationdtl()
                                InsertOtherCharges()
                              }, 700)
                              // setinvoicesuccess(true)
                            }
                          } else {
                            if (customerNameHelp.value === "") {
                              setcustomerpopup(true)
                            } else {
                              setproductpopup(true)
                            }
                          }
                        }}
                      >
                        Save
                      </CustomButton>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </Paper>
          </div >}
      </div >

      <Modal isOpen={BlockModal} size="xl" toggle={toggles}>
        <ModalHeader tag={"h4"} toggle={toggles}>
          <Typography variant="h6" color="#186F65" sx={{ pr: 2 }}>
            Warehouses
          </Typography>
        </ModalHeader>

        <ModalBody>
          <Row className="mb-2">
            <div className=" shadow-sm">

              <div className="d-flex "> <p className="blockquote font-size-17 react-datepicker__day--today card-columns font-monospace font-size-16 mb-2">Product Name: {ProductName}</p>
                <p className="blockquote font-monospace font-size-17 react-datepicker__day--today">Quantity :{validBlockedQty}</p></div>
              <Table striped>
                <thead style={{ border: "1px solid white" }}>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#79AC78",
                        color: "white",
                      }}
                      className="text-left"
                    >
                      SNo
                    </th>
                    <th
                      style={{
                        backgroundColor: "#79AC78",
                        color: "white",
                      }}
                      className="text-left"
                    >
                      Company Name
                    </th>
                    <th
                      style={{
                        backgroundColor: "#79AC78",
                        color: "white",
                      }}
                      className="text-left"
                    >
                      Warehouse
                    </th>
                    <th
                      style={{
                        backgroundColor: "#79AC78",
                        color: "white",
                      }}
                      className="text-left"
                    >
                      Total Stock
                    </th>
                    <th
                      style={{
                        backgroundColor: "#79AC78",
                        color: "white",
                      }}
                      className="text-left"
                    >
                      Blocked Stock
                    </th>
                    <th
                      style={{
                        backgroundColor: "#79AC78",
                        color: "white",
                      }}
                      className="text-left"
                    >
                      Balance Stock
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {warehouseQtyCollection.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            padding: "5px",
                            textAlign: "left",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            textAlign: "left",
                          }}
                        >
                          {item.Company_Name}
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            textAlign: "left",
                          }}
                        >
                          {item.Warehouse_Name}
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            textAlign: "left",
                          }}
                        >
                          {(item.Stock) + (item.PUOM) + "/" + (parseInt(numeral(item.SecStock).format("0"))) + (item.SUOM)}
                        </td>
                        {props.match.params.id ? (
                          <td
                            style={{
                              padding: "5px",
                              textAlign: "left",
                            }}
                          >
                            {parseInt(item.Blocked_Qty) +
                              parseInt(item.BalanceStock) + (item.PUOM) + "/" + ((parseInt(numeral(item.SecBlocked_Qty).format("0")))
                                +
                                (parseInt(numeral(item.SecBalanceStock).format("0")))) + (item.SUOM)}
                          </td>
                        ) : (
                          <td
                            style={{
                              padding: "5px",
                              textAlign: "left",
                            }}
                          >
                            {parseInt(item.Blocked_Qty) +
                              parseInt(item.AlreadyBlockedQty) + (item.PUOM) + "/" + ((parseInt(numeral(item.SecBlocked_Qty).format("0"))) +
                                (parseInt(numeral(item.SecAlreadyBlockedQty).format("0")))) + (item.SUOM)}
                          </td>
                        )}
                        {props.match.params.id ? (
                          <td
                            style={{
                              padding: "5px",
                              textAlign: "left",
                            }}
                          >
                            {item.Stock -
                              (parseInt(item.Blocked_Qty) +
                                parseInt(item.BalanceStock)) + (item.PUOM) + "/" + ((parseInt(numeral(item.SecBlocked_Qty).format("0"))) +
                                  (parseInt(numeral(item.SecBalanceStock).format("0")))) + (item.SUOM)}
                          </td>
                        ) : (
                          <td
                            style={{
                              padding: "5px",
                              textAlign: "left",
                            }}
                          >
                            {item.Stock -
                              (parseInt(item.Blocked_Qty) +
                                parseInt(item.AlreadyBlockedQty)) + (item.PUOM) + "/" + ((parseInt(numeral(item.SecStock).format("0"))) - (parseInt(numeral(item.SecBlocked_Qty).format("0"))) +
                                  (parseInt(numeral(item.SecAlreadyBlockedQty).format("0")))) + (item.SUOM)}
                          </td>
                        )}
                      </tr>
                    ))}
                  </React.Fragment>
                </tbody>
              </Table>
            </div>
          </Row>
          <Row>
            <Col className="text-center ">
              {" "}
              <Button onClick={toggles} color="danger">
                {" "}
                Cancel
              </Button>{" "}
              {/* <Button onClick={toggleblocks} color="success">
                {" "}
                Save
              </Button> */}
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      {/*Curent Other Charges */}
      <Modal isOpen={otherModel} toggle={toggleOpenOthers} size="lg">
        <ModalHeader toggle={toggleOpenOthers}>Other Charges</ModalHeader>
        <ModalBody>
          <Grid item xs={12}>
            <Label>Other Charges
              {otherchargeshelp.value.length == 0 ? (
                <IconButton
                  aria-label="add"
                  color="success"
                  size={"small"}
                  onClick={() => {
                    setOtherChargesModal(true)
                    setRandomcallbackOthercharges((Math.floor(Math.random() * 90) + 10))
                  }}
                >
                  <AddCircleOutlineIcon
                    sx={{ fontSize: "15px" }}
                  />
                </IconButton>
              ) : (
                <IconButton
                  aria-label="add"
                  color="warning"
                  size={"small"}
                  onClick={() => {

                    setOtherChargesModal(true)
                    setRandomcallbackOthercharges((Math.floor(Math.random() * 90) + 10))
                  }}
                >
                  <EditIcon sx={{ fontSize: "15px" }} />
                </IconButton>
              )}
            </Label>
            <Select
              ref={LedgerRef}
              options={otherchargesData}
              classNamePrefix="select2-search-disable"
              styles={customStyles}
              value={otherchargeshelp}
              onChange={value => {


                if (value.label == "Add Ledger....") {

                  setOtherChargesModal(true)
                  setRandomcallbackOthercharges((Math.floor(Math.random() * 90) + 10))

                } else {
                  let arr = otherchargesData1.filter(
                    item => item.customer_id == value.value
                  )
                  // console.log(value,'value')
                  selectedCustomer1(arr)
                  let dd = otherchargesData.filter(
                    item =>
                      parseInt(item.value) !== parseInt(value.value)
                  )
                  setotherchargesData(dd)
                }
              }}
            />
          </Grid>
          {/* calculation of gst Yes  */}
          <Grid item xs={12} className="mt-3">
            <Table responsive style={{ width: "100%" }}>
              <tbody>
                <React.Fragment>
                  {otherchargescollection
                    // .filter(item => item.Calculation_Of_GST == "Y")
                    .map((item, index) => (
                      <tr key={index}>
                        {/* <td className="text-center" style={{ width: "10%" }}>{index + 1}</td> */}
                        <td
                          className="text-nowrap"
                          style={{
                            width: "30%",
                            fontSize: "12px",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            color="GrayText"
                            pr={1}
                          >
                            {item.Ledger}
                          </Typography>
                          <Typography
                            variant="caption"
                            color="coral"
                            pr={1}
                            sx={{ fontSize: "10px" }}
                          >
                            {item.Calculation_Of_GST === "Y" &&
                              "(Include Accessable value)"}
                          </Typography>
                        </td>

                        <td style={{ width: "20%" }}>
                          <label
                            className="input"
                            style={{
                              marginRight: "8px",
                              width: "100%",
                            }}
                          >
                            <select
                              // className="input__field"
                              value={item.Type}
                              style={{
                                width: "100%",
                                height: "30px",
                                borderColor: "lightgray",
                              }}
                              onChange={e => {
                                const newInputValues = [
                                  ...otherchargescollection,
                                ]
                                const indexvalue =
                                  otherchargescollection.findIndex(
                                    obj =>
                                      obj.LedgerId === item.LedgerId
                                  )
                                newInputValues[indexvalue].Type =
                                  e.target.value
                                setotherchargescollection(
                                  newInputValues
                                )

                                if (
                                  otherchargescollection.length !== 0
                                ) {
                                  const CalculationOfGST =
                                    otherchargescollection.filter(
                                      data =>
                                        data.Calculation_Of_GST ===
                                        "Y"
                                    )
                                  const CalculationOfGSTNo =
                                    otherchargescollection.filter(
                                      data =>
                                        data.Calculation_Of_GST ===
                                        "N"
                                    )
                                  if (CalculationOfGST.length != 0) {
                                    productcollection.forEach(obj => {
                                      obj.OtherChargesAdd = 0
                                      obj.OtherChargesSub = 0
                                    })
                                    let prod = productcollection
                                    let other = otherchargescollection
                                    // console.log(prod)
                                    for (let obj of prod) {
                                      for (let obj1 of other) {
                                        if (
                                          obj1.Calculation_Of_GST ==
                                          "Y"
                                        ) {
                                          if (
                                            obj1.Type === "Addition"
                                          ) {
                                            obj.OtherChargesAdd =
                                              0 +
                                              parseFloat(
                                                obj1.Percentage
                                              ) +
                                              parseFloat(
                                                obj.OtherChargesAdd
                                              )

                                            //  obj.OtherChargesAdd =parseFloat(obj1.Percentage)+parseFloat(obj.OtherChargesAdd)
                                          } else if (
                                            obj1.Type === "Deduction"
                                          ) {
                                            obj.OtherChargesSub =
                                              0 +
                                              parseFloat(
                                                obj1.Percentage
                                              ) +
                                              parseFloat(
                                                obj.OtherChargesSub
                                              )

                                            // obj.OtherChargesSub= 0
                                            // obj.OtherChargesSub =parseFloat(obj1.Percentage)+parseFloat(obj.OtherChargesSub)
                                          }
                                        }
                                      }
                                      // console.log(prod,'check')
                                    }
                                  } else if (
                                    CalculationOfGSTNo.length !== 0
                                  ) {
                                    // console.log("No")
                                    // toggle1()
                                  }
                                } else {
                                  setotherchargeserr(true)
                                }
                              }}
                            >
                              {options3.map(option => (
                                <option
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.text}
                                </option>
                              ))}
                            </select>
                            <span
                              className="input__label1"
                              style={{ fontSize: "9px" }}
                            >
                              Type
                            </span>
                          </label>
                        </td>

                        <td style={{ width: "20%" }} className="p-1">
                          <label
                            className="input"
                            style={{
                              marginRight: "8px",
                              width: "100%",
                            }}
                          >
                            <Input
                              type="number"
                              value={item.Percentage}
                              style={{
                                width: "90%",
                                marginTop: "8px",
                                height: "30px",
                              }}
                              onChange={e => {
                                const newInputValues = [
                                  ...otherchargescollection,
                                ]
                                const indexvalue =
                                  otherchargescollection.findIndex(
                                    obj =>
                                      obj.LedgerId === item.LedgerId
                                  )
                                const totalGrossAmt = totalAmount
                                const amount = numeral(
                                  (e.target.value * totalGrossAmt) /
                                  100
                                ).format("0,0.00")
                                newInputValues[
                                  indexvalue
                                ].Percentage = e.target.value
                                // newInputValues[indexvalue].Amount =
                                //   Number((e.target.value * totalGrossAmt) /
                                //   100).toFixed(2)
                                setotherchargescollection(
                                  newInputValues
                                )

                                if (
                                  otherchargescollection.length !== 0
                                ) {
                                  const CalculationOfGST =
                                    otherchargescollection.filter(
                                      data =>
                                        data.Calculation_Of_GST ===
                                        "Y"
                                    )
                                  const CalculationOfGSTNo =
                                    otherchargescollection.filter(
                                      data =>
                                        data.Calculation_Of_GST ===
                                        "N"
                                    )
                                  if (CalculationOfGST.length != 0) {
                                    productcollection.forEach(obj => {
                                      obj.OtherChargesAdd = 0
                                      obj.OtherChargesSub = 0
                                    })
                                    let prod = productcollection
                                    let other = otherchargescollection
                                    // console.log(prod)
                                    for (let obj of prod) {
                                      for (let obj1 of other) {
                                        if (
                                          obj1.Calculation_Of_GST ==
                                          "Y"
                                        ) {
                                          if (
                                            obj1.Type === "Addition"
                                          ) {
                                            obj.OtherChargesAdd =
                                              0 +
                                              parseFloat(
                                                obj1.Percentage
                                              ) +
                                              parseFloat(
                                                obj.OtherChargesAdd
                                              )

                                            //  obj.OtherChargesAdd =parseFloat(obj1.Percentage)+parseFloat(obj.OtherChargesAdd)
                                          } else if (
                                            obj1.Type === "Deduction"
                                          ) {
                                            obj.OtherChargesSub =
                                              0 +
                                              parseFloat(
                                                obj1.Percentage
                                              ) +
                                              parseFloat(
                                                obj.OtherChargesSub
                                              )

                                            // obj.OtherChargesSub= 0
                                            // obj.OtherChargesSub =parseFloat(obj1.Percentage)+parseFloat(obj.OtherChargesSub)
                                          }
                                        }
                                      }
                                      // console.log(prod,'check')
                                    }
                                  } else if (
                                    CalculationOfGSTNo.length !== 0
                                  ) {
                                    // console.log("No")
                                    toggle1()
                                  }
                                } else {
                                  setotherchargeserr(true)
                                }
                              }}
                              onFocus={e => {
                                e.target.select()
                              }}
                              onKeyPress={e => {
                                if (e.key === 'Enter') {
                                  updateFinalPercentage();
                                  if (e.target.value && LedgerRef.current) {
                                    LedgerRef.current.focus();
                                  }
                                }
                              }}
                            />
                            <span
                              className="input__label1"
                              style={{
                                fontSize: "9px",
                                marginTop: "12px",
                              }}
                            >
                              %
                            </span>
                          </label>
                        </td>

                        <td style={{ width: "20%" }} className="p-1">
                          <label
                            className="input"
                            style={{
                              marginRight: "8px",
                              width: "100%",
                            }}
                          >
                            <Input
                              type="number"
                              value={item.Amount}
                              style={{
                                width: "100%",
                                marginTop: "8px",
                                height: "30px",
                              }}
                              onChange={e => {
                                const newInputValues = [
                                  ...otherchargescollection,
                                ]
                                const totalGrossAmt = totalAmount
                                const indexvalue =
                                  otherchargescollection.findIndex(
                                    obj =>
                                      obj.LedgerId === item.LedgerId
                                  )
                                const percentage = numeral(
                                  (e.target.value * 100) /
                                  totalGrossAmt
                                ).format("0.00")
                                newInputValues[indexvalue].Amount =
                                  e.target.value
                                // newInputValues[indexvalue].Percentage = 0
                                // e.target.value
                                // newInputValues[
                                //   indexvalue
                                // ].Percentage = Number((e.target.value * 100) /
                                // totalGrossAmt).toFixed(2)
                                setotherchargescollection(
                                  newInputValues
                                )

                                if (
                                  otherchargescollection.length !== 0
                                ) {
                                  const CalculationOfGST =
                                    otherchargescollection.filter(
                                      data =>
                                        data.Calculation_Of_GST ===
                                        "Y"
                                    )
                                  const CalculationOfGSTNo =
                                    otherchargescollection.filter(
                                      data =>
                                        data.Calculation_Of_GST ===
                                        "N"
                                    )
                                  if (CalculationOfGST.length != 0) {
                                    productcollection.forEach(obj => {
                                      obj.OtherChargesAdd = 0
                                      obj.OtherChargesSub = 0
                                    })
                                    let prod = productcollection
                                    let other = otherchargescollection
                                    // console.log(prod)
                                    for (let obj of prod) {
                                      for (let obj1 of other) {
                                        if (
                                          obj1.Calculation_Of_GST ==
                                          "Y"
                                        ) {
                                          if (
                                            obj1.Type === "Addition"
                                          ) {
                                            obj.OtherChargesAdd =
                                              0 +
                                              parseFloat(
                                                obj1.Percentage
                                              ) +
                                              parseFloat(
                                                obj.OtherChargesAdd
                                              )

                                            //  obj.OtherChargesAdd =parseFloat(obj1.Percentage)+parseFloat(obj.OtherChargesAdd)
                                          } else if (
                                            obj1.Type === "Deduction"
                                          ) {
                                            obj.OtherChargesSub =
                                              0 +
                                              parseFloat(
                                                obj1.Percentage
                                              ) +
                                              parseFloat(
                                                obj.OtherChargesSub
                                              )

                                            // obj.OtherChargesSub= 0
                                            // obj.OtherChargesSub =parseFloat(obj1.Percentage)+parseFloat(obj.OtherChargesSub)
                                          }
                                        }
                                      }
                                      // console.log(prod,'check')
                                    }
                                  } else if (
                                    CalculationOfGSTNo.length !== 0
                                  ) {
                                    // console.log("No")
                                  }
                                } else {
                                  setotherchargeserr(true)
                                }
                              }}
                              onFocus={e => {
                                e.target.select()
                              }}
                              onKeyPress={e => {
                                if (e.key === 'Enter') {
                                  // Call updateFinalTotalAmount when Enter is pressed
                                  updateFinalTotalAmount();
                                  if (e.target.value && LedgerRef.current) {
                                    LedgerRef.current.focus();
                                  }
                                }
                              }}
                            />
                            <span
                              className="input__label1"
                              style={{
                                fontSize: "9px",
                                marginTop: "10px",
                              }}
                            >
                              Amount
                            </span>
                          </label>
                        </td>

                        <td
                          className="text-center"
                          style={{ width: "10%" }}
                        >
                          <Link
                            to="#"
                            className="text-danger"
                            onClick={() => {
                              const indexvalue =
                                otherchargescollection.findIndex(
                                  obj =>
                                    obj.LedgerId === item.LedgerId
                                )
                              toggledeletemodal1(
                                indexvalue,
                                item.LedgerId
                              )
                            }}
                          >
                            <i
                              className="uil uil-trash-alt font-size-18"
                              id="deletetooltip"
                            />
                            <UncontrolledTooltip
                              placement="top"
                              target="deletetooltip"
                            >
                              Delete
                            </UncontrolledTooltip>
                          </Link>
                        </td>
                      </tr>
                    ))}
                </React.Fragment>
              </tbody>
            </Table>
          </Grid>
          {/* calculation of gst No  */}
          {/* <Grid item xs={12}>
                      <Table responsive style={{ width: "100%" }}>
                        <tbody>
                          <React.Fragment>
                            {otherchargescollection
                              .filter(item => item.Calculation_Of_GST == "N")
                              .map((item, index) => (
                                <tr key={index}>                                 
                                  <td
                                    className="text-nowrap"
                                    style={{
                                      width: "30%",
                                      fontSize: "12px",
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      color="GrayText"
                                      pr={1}
                                    >
                                      {item.Ledger}
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        color="coral"
                                        pr={1}
                                        sx={{ fontSize: "10px" }}
                                      >
                                        { ((item.GST_Applicability=='Y') && (item.GroupId==13 || item.GroupId==15))?"(GST Applicable)"+''+(item.Tax)+'%':'' }
                                      </Typography>
                                  </td>

                                  <td style={{ width: "20%" }}>
                                    <label
                                      className="input"
                                      style={{
                                        marginRight: "8px",
                                        width: "100%",
                                      }}
                                    >
                                      <select                                     
                                        value={item.Type}
                                        style={{
                                          width: "100%",
                                          height: "30px",
                                          borderColor: "lightgray",
                                        }}
                                        onChange={e => {
                                          const newInputValues = [
                                            ...otherchargescollection,
                                          ]
                                          const indexvalue =
                                            otherchargescollection.findIndex(
                                              obj =>
                                                obj.LedgerId === item.LedgerId
                                            )
                                          newInputValues[indexvalue].Type =
                                            e.target.value
                                          setotherchargescollection(
                                            newInputValues
                                          )

                                          if (
                                            otherchargescollection.length !== 0
                                          ) {
                                            const CalculationOfGST =
                                              otherchargescollection.filter(
                                                data =>
                                                  data.Calculation_Of_GST ===
                                                  "Y"
                                              )
                                            const CalculationOfGSTNo =
                                              otherchargescollection.filter(
                                                data =>
                                                  data.Calculation_Of_GST ===
                                                  "N"
                                              )
                                            if (CalculationOfGST.length != 0) {
                                              productcollection.forEach(obj => {
                                                obj.OtherChargesAdd = 0
                                                obj.OtherChargesSub = 0
                                              })
                                              let prod = productcollection
                                              let other = otherchargescollection
                                              // console.log(prod)
                                              for (let obj of prod) {
                                                for (let obj1 of other) {
                                                  if (
                                                    obj1.Calculation_Of_GST ==
                                                    "Y"
                                                  ) {
                                                    if (
                                                      obj1.Type === "Addition"
                                                    ) {
                                                      obj.OtherChargesAdd =
                                                        0 +
                                                        parseFloat(
                                                          obj1.Percentage
                                                        ) +
                                                        parseFloat(
                                                          obj.OtherChargesAdd
                                                        )
                                                      
                                                    } else if (
                                                      obj1.Type === "Deduction"
                                                    ) {
                                                      obj.OtherChargesSub =
                                                        0 +
                                                        parseFloat(
                                                          obj1.Percentage
                                                        ) +
                                                        parseFloat(
                                                          obj.OtherChargesSub
                                                        )
                                                     
                                                    }
                                                  }
                                                }                                               
                                              }
                                            } else if (
                                              CalculationOfGSTNo.length !== 0
                                            ) {                                         
                                            }
                                          } else {
                                            setotherchargeserr(true)
                                          }
                                        }}
                                      >
                                        {options3.map(option => (
                                          <option
                                            key={option.value}
                                            value={option.value}
                                          >
                                            {option.text}
                                          </option>
                                        ))}
                                      </select>
                                      <span
                                        className="input__label1"
                                        style={{ fontSize: "9px" }}
                                      >
                                        Type
                                      </span>
                                    </label>
                                  </td>

                                  <td style={{ width: "20%" }} className="p-1">
                                    <label
                                      className="input"
                                      style={{
                                        marginRight: "8px",
                                        width: "100%",
                                      }}
                                    >
                                      <Input
                                        type="number"
                                        value={item.Percentage}
                                        style={{
                                          width: "100%",
                                          marginTop: "8px",
                                          height: "30px",
                                        }}
                                        onChange={e => {
                                          const newInputValues = [
                                            ...otherchargescollection,
                                          ]
                                          const totalGrossAmt = totalAmount
                                          const indexvalue =
                                            otherchargescollection.findIndex(
                                              obj =>
                                                obj.LedgerId === item.LedgerId
                                            )
                                          const amount = numeral(
                                            (e.target.value * totalGrossAmt) /
                                              100
                                          ).format("0,0.00")
                                          newInputValues[
                                            indexvalue
                                          ].Percentage = e.target.value
                                          newInputValues[indexvalue].Amount =
                                            Number((e.target.value * totalGrossAmt) /
                                            100).toFixed(2)
                                          setotherchargescollection(
                                            newInputValues
                                          )

                                          if (
                                            otherchargescollection.length !== 0
                                          ) {
                                            const CalculationOfGST =
                                              otherchargescollection.filter(
                                                data =>
                                                  data.Calculation_Of_GST ===
                                                  "Y"
                                              )
                                            const CalculationOfGSTNo =
                                              otherchargescollection.filter(
                                                data =>
                                                  data.Calculation_Of_GST ===
                                                  "N"
                                              )
                                            if (CalculationOfGST.length != 0) {
                                              productcollection.forEach(obj => {
                                                obj.OtherChargesAdd = 0
                                                obj.OtherChargesSub = 0
                                              })
                                              let prod = productcollection
                                              let other = otherchargescollection
                                              // console.log(prod)
                                              for (let obj of prod) {
                                                for (let obj1 of other) {
                                                  if (
                                                    obj1.Calculation_Of_GST ==
                                                    "Y"
                                                  ) {
                                                    if (
                                                      obj1.Type === "Addition"
                                                    ) {
                                                      obj.OtherChargesAdd =
                                                        0 +
                                                        parseFloat(
                                                          obj1.Percentage
                                                        ) +
                                                        parseFloat(
                                                          obj.OtherChargesAdd
                                                        )
                                                     
                                                    } else if (
                                                      obj1.Type === "Deduction"
                                                    ) {
                                                      obj.OtherChargesSub =
                                                        0 +
                                                        parseFloat(
                                                          obj1.Percentage
                                                        ) +
                                                        parseFloat(
                                                          obj.OtherChargesSub
                                                        )
                                                     
                                                    }
                                                  }
                                                }                                              
                                              }
                                            } else if (
                                              CalculationOfGSTNo.length !== 0
                                            ) {                                            
                                            }
                                          } else {
                                            setotherchargeserr(true)
                                          }
                                        }}
                                        onFocus={e => {
                                          e.target.select()
                                        }}
                                      />
                                      <span
                                        className="input__label1"
                                        style={{
                                          fontSize: "9px",
                                          marginTop: "12px",
                                        }}
                                      >
                                        %
                                      </span>
                                    </label>
                                  </td>

                                  <td style={{ width: "20%" }} className="p-1">
                                    <label
                                      className="input"
                                      style={{
                                        marginRight: "8px",
                                        width: "100%",
                                      }}
                                    >
                                      <Input
                                        type="number"
                                        value={item.Amount}
                                        style={{
                                          width: "100%",
                                          marginTop: "8px",
                                          height: "30px",
                                        }}
                                        onChange={e => {
                                          const newInputValues = [
                                            ...otherchargescollection,
                                          ]
                                          const totalGrossAmt = totalAmount
                                          const indexvalue =
                                            otherchargescollection.findIndex(
                                              obj =>
                                                obj.LedgerId === item.LedgerId
                                            )
                                          const percentage = numeral(
                                            (e.target.value * 100) /
                                              totalGrossAmt
                                          ).format("0.00")
                                          newInputValues[indexvalue].Amount =
                                            e.target.value
                                            newInputValues[indexvalue].Percentage = 0
                                           
                                    
                                          setotherchargescollection(
                                            newInputValues
                                          )

                                          if (
                                            otherchargescollection.length !== 0
                                          ) {
                                            const CalculationOfGST =
                                              otherchargescollection.filter(
                                                data =>
                                                  data.Calculation_Of_GST ===
                                                  "Y"
                                              )
                                            const CalculationOfGSTNo =
                                              otherchargescollection.filter(
                                                data =>
                                                  data.Calculation_Of_GST ===
                                                  "N"
                                              )
                                            if (CalculationOfGST.length != 0) {
                                              productcollection.forEach(obj => {
                                                obj.OtherChargesAdd = 0
                                                obj.OtherChargesSub = 0
                                              })
                                              let prod = productcollection
                                              let other = otherchargescollection
                                         
                                              for (let obj of prod) {
                                                for (let obj1 of other) {
                                                  if (
                                                    obj1.Calculation_Of_GST ==
                                                    "Y"
                                                  ) {
                                                    if (
                                                      obj1.Type === "Addition"
                                                    ) {
                                                      obj.OtherChargesAdd =
                                                        0 +
                                                        parseFloat(
                                                          obj1.Percentage
                                                        ) +
                                                        parseFloat(
                                                          obj.OtherChargesAdd
                                                        )

                                                    
                                                    } else if (
                                                      obj1.Type === "Deduction"
                                                    ) {
                                                      obj.OtherChargesSub =
                                                        0 +
                                                        parseFloat(
                                                          obj1.Percentage
                                                        ) +
                                                        parseFloat(
                                                          obj.OtherChargesSub
                                                        )

                                                    
                                                    }
                                                  }
                                                }
                                               
                                              }
                                            } else if (
                                              CalculationOfGSTNo.length !== 0
                                            ) {
                                           
                                            }
                                          } else {
                                            setotherchargeserr(true)
                                          }
                                        }}
                                        onFocus={e => {
                                          e.target.select()
                                        }}
                                      />
                                      <span
                                        className="input__label1"
                                        style={{
                                          fontSize: "9px",
                                          marginTop: "10px",
                                        }}
                                      >
                                        Amount
                                      </span>
                                    </label>
                                  </td>

                                  <td
                                    className="text-center"
                                    style={{ width: "10%" }}
                                  >
                                    <Link
                                      to="#"
                                      className="text-danger"
                                      onClick={() => {
                                        const indexvalue =
                                          otherchargescollection.findIndex(
                                            obj =>
                                              obj.LedgerId === item.LedgerId
                                          )
                                        toggledeletemodal1(
                                          indexvalue,
                                          item.LedgerId
                                        )
                                      }}
                                    >
                                      <i
                                        className="uil uil-trash-alt font-size-18"
                                        id="deletetooltip"
                                      />
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="deletetooltip"
                                      >
                                        Delete
                                      </UncontrolledTooltip>
                                    </Link>
                                  </td>
                                </tr>
                              ))}
                          </React.Fragment>
                        </tbody>
                      </Table>
                    </Grid> */}
          <div className="d-flex justify-content-center align-items-center gap-2">
            <CustomButton2
              size="small"
              color="primary"
              variant="contained"
              onClick={() => {

                const allValuesNotZero = otherchargescollection.every(obj => obj.Amount !== 0)
                // console.log(allValuesNotZero)
                if (allValuesNotZero) {
                  toggleOpenOthers()
                } else {
                  setRateError(true)
                }







              }}
            >
              Add
            </CustomButton2>
          </div>
        </ModalBody>
      </Modal>


      <Dialog
        onClose={Closepopup}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <img src={Popupimage} style={{ width: "400px", height: "400px" }} />
      </Dialog>

      <div className="d-none">
        {/* <LedgerMaster
        ShowModalProps={CustomerModal}
        CallBack={RandomCallbackCustomer}
        CustomerandSupplier={false}
        EditIdProps={customerNameHelp.value}
        isEditProps={customerNameHelp.value.length != 0}
        InvoiceEditMode={props.match.params.id}
        LedgerCallback={returnFromLedgerMaster}
        // GroupId={27}
        GroupId={groupid}
      /> */}
        {/* <GeneralLegermaster
        ComponentsProps={true}
        ShowModalProps={OtherChargesModal}
        CallBack={RandomcallbackOthercharges}
        CustomerandSupplier={false}
        EditIdProps={otherchargeshelp.value}
        isEditProps={otherchargeshelp.value.length != 0}
        InvoiceEditMode={props.match.params.id}
        LedgerCallback={returnFromLedgerMasterOtherCharges}
      /> */}
      </div>



      {
        nodataerror ? (
          <SweetAlert
            title="No Data Found"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            danger
            onConfirm={() => {
              setnodataerror(false)
            }}
          ></SweetAlert>
        ) : null
      }

      {
        customerpopup ? (
          <SweetAlert
            title="Enter Customer Name"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              setcustomerpopup(false)
              CustomerRef.current.focus()
            }}
          ></SweetAlert>
        ) : null
      }
      {
        RateError ? (
          <SweetAlert
            title="Enter Amount"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            danger
            onConfirm={() => {
              setRateError(false)
            }}
          ></SweetAlert>
        ) : null
      }

      {
        productpopup ? (
          <SweetAlert
            title="Add Product"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              setproductpopup(false)
              setval({ label: "Select Product", value: "" })
              setOptions([{ label: "Type Something to Search...", value: "" }])
              setpreviouspriceShow(false)
              setViewStockDetails(false)
              setQtyEnter('')
              setRateEnter('')
              SelectProcuctRef.current.focus()
            }}
          ></SweetAlert>
        ) : null
      }

      {
        quantitypopup ? (
          <SweetAlert
            title="Sales Quantity should be less than Balance Quantity"
            timeout={2500}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              setquantitypopup(false)
            }}
          ></SweetAlert>
        ) : null
      }

      {
        invoicesuccess ? (
          <SweetAlert
            title="Quotation Added Successfully"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setinvoicesuccess(false)
            }}
          ></SweetAlert>
        ) : null
      }

      {
        invoiceupdate ? (
          <SweetAlert
            title="Quotation Updated Successfully"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setinvoiceupdate(false)
            }}
          ></SweetAlert>
        ) : null
      }

      {
        qtyerror ? (
          <SweetAlert
            title="Enter Quantity"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              setqtyerror(false)
              QtyRef.current.focus()

            }}
          ></SweetAlert>
        ) : null
      }

      {
        rateerror ? (
          <SweetAlert
            title="Enter Rate"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              setrateerror(false)
              RateRef.current.focus()
            }}
          ></SweetAlert>
        ) : null
      }

      {
        otherchargeserr ? (
          <SweetAlert
            title="Add OtherCharges"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            danger
            onConfirm={() => {
              setotherchargeserr(false)
            }}
          ></SweetAlert>
        ) : null
      }


      {
        Buyersuccess ? (
          <SweetAlert
            title="Ledger Added Successfully"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setBuyersuccess(false)
            }}
          ></SweetAlert>
        ) : null
      }

      {
        Updatedalert ? (
          <SweetAlert
            title="Ledger Updated Successfully"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setUpdatedalert(false)
            }}
          ></SweetAlert>
        ) : null
      }

      {
        productsuccess ? (
          <SweetAlert
            title="Product Added Successfully"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setproductsuccess(false)
            }}
          ></SweetAlert>
        ) : null
      }

      {
        productupdate ? (
          <SweetAlert
            title="Product Updated Successfully"
            timeout={2000}
            style={{
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setproductupdate(false)
            }}
          ></SweetAlert>
        ) : null
      }

      {deletedconfirm ? (
        <SweetAlert
          title="Are You Sure?"
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          confirmBtnBsStyle="success"
          showConfirm={true}
          cancelBtnBsStyle="danger"
          cancelBtnText="Cancel"
          confirmBtnText="Yes,delete it!"
          showCancel={true}
          warning
          onConfirm={() => {
            Deleteinvoiceproduct();
            setdeletedconfirm(false);
          }}
          onCancel={() => {
            setdeletedconfirm(false);
            // setdeleted(false);
          }}
        >
          <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
        </SweetAlert>
      ) : null}
      <Dialog
        onClose={ClosePrevpopup}
        aria-labelledby="simple-dialog-title"
        open={openPrev}
        maxWidth={"lg"}
      >
        {previousprice && (
          <div className="mt-2">
            <div
              style={{
                marginBottom: "8px",
                marginLeft: 10,
                fontWeight: "bold",
              }}
              className="d-flex justify-content-between align-items-center gap-2"
            >
              <p style={{ marginRight: "10px" }}>
                {`Previous Price for `}{" "}
                <Typography variant="button" color="blue">
                  {prevpriceProductName}
                </Typography>
              </p>
              <IconButton
                color="error"
                aria-label="close"
                onClick={() => {
                  setpreviousprice(false)
                  setopenPrev(false)
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <Zoom in={true}>
              <Paper sx={{ p: 4, borderRadius: 5 }} elevation={2}>
                {prevpricedata.length > 0 ? (
                  <>
                    <Table2 size="small">
                      <TableHead2>
                        <TableRow2 style={{ backgroundColor: "#F6D776" }}>
                          <TableCell2>Bill No</TableCell2>
                          <TableCell2>Bill Date</TableCell2>
                          <TableCell2>Quantity</TableCell2>
                          <TableCell2>UOM</TableCell2>
                          <TableCell2>Price</TableCell2>
                          <TableCell2>Discount (%)</TableCell2>
                        </TableRow2>
                      </TableHead2>
                      <TableBody2>
                        {prevpricedata.map((item, index) => {
                          const [
                            salesBillNo,
                            salesBillDate,
                            quantity,
                            unit,
                            price,
                            discount,
                          ] =
                            item.SALESBILLDETAILSGETPREVIOUSDETALAS.split("--")
                          return (
                            <TableRow2 key={index}>
                              <TableCell2>{salesBillNo}</TableCell2>
                              <TableCell2>{salesBillDate}</TableCell2>
                              <TableCell2>{quantity}</TableCell2>
                              <TableCell2>{unit}</TableCell2>
                              <TableCell2>{price}</TableCell2>
                              <TableCell2>{discount}</TableCell2>
                            </TableRow2>
                          )
                        })}
                      </TableBody2>
                    </Table2>
                  </>
                ) : (
                  <>
                    <Typography
                      variant="subtitle2"
                      color="#FE7A36"
                      sx={{ m: 1, p: 2 }}
                    >
                      No Previous Price Record found
                    </Typography>
                  </>
                )}
              </Paper>
            </Zoom>
          </div>
        )}
      </Dialog>
      <Backdrop open={dialogbox} className={classes.backdrop}>
        <Spinner name="ball-spin-fade-loader" color="#fafafa" />
      </Backdrop>
          <Backdrop open={dailoa1} className={classes.backdrop}>
              <Spinner name="ball-spin-fade-loader" color="#fafafa" />
            </Backdrop>
    </React.Fragment >
  )
}

export default QuotationAdd

